webpackJsonp([3,0],{

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * Created by jv on 04/01/2017.
	 */
	var config = __webpack_require__(510);
	
	var utils = {};
	var queryParams = void 0;
	
	(function (Utils) {
	  var MAX_UID = 1000000;
	
	  Utils.UUID = function () {
	    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
	      var r = Math.random() * 16 | 0,
	          v = c === "x" ? r : r & 0x3 | 0x8;
	      return v.toString(16);
	    });
	  };
	
	  Utils.generateUIDShort = function () {
	    return ("0000" + (Math.random() * Math.pow(36, 4) << 0).toString(36)).slice(-4);
	  };
	
	  Utils.generateElementId = function (prefix) {
	    do {
	      prefix += ~~(Math.random() * MAX_UID); // "~~" acts like a faster Math.floor() here
	    } while (document.getElementById(prefix));
	
	    return prefix;
	  };
	
	  Utils.redirect = function (link) {
	    window.location.href = link;
	  };
	
	  Utils.reloadPage = function (forceReload) {
	    window.location.reload(forceReload);
	  };
	
	  // %note: might be better to use https://www.npmjs.com/package/lodash for most of these utility functions
	  Utils.isUndefined = function (obj) {
	    return typeof obj === "undefined";
	  };
	
	  Utils.isDefined = function (obj) {
	    return !Utils.isUndefined(obj);
	  };
	
	  Utils.isNull = function (obj) {
	    return typeof obj === "undefined" || obj === null;
	  };
	
	  Utils.isNotNull = function (obj) {
	    return !Utils.isNull(obj);
	  };
	
	  Utils.isNullOrEmpty = function (str) {
	    return Utils.isNull(str) || str === "";
	  };
	
	  Utils.isString = function (value) {
	    return Utils.isNotNull(value) && typeof value === "string";
	  };
	
	  Utils.isBoolean = function (value) {
	    return value === true || value === false;
	  };
	
	  Utils.isNumber = function (value) {
	    return Utils.isNotNull(value) && !isNaN(value) && typeof value === "number";
	  };
	
	  Utils.isArray = function (obj) {
	    return Utils.isNotNull(obj) && Array.isArray(obj);
	  };
	
	  Utils.isObject = function (obj) {
	    return Utils.isNotNull(obj) && (typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object";
	  };
	
	  Utils.isMomentObject = function (obj) {
	    return Utils.isObject(obj) && obj.hasOwnProperty("_isAMomentObject") && obj._isAMomentObject === true;
	  };
	
	  Utils.isFunction = function (obj) {
	    return typeof obj === "function";
	  };
	
	  Utils.isValidEmail = function (email) {
	    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	    return re.test(email);
	  };
	
	  Utils.defaultFor = function (value, defaultValue, type) {
	    if (Utils.isNotNull(type) && (typeof value === "undefined" ? "undefined" : _typeof(value)) !== type) {
	      return defaultValue;
	    }
	
	    return Utils.isNotNull(value) ? value : defaultValue;
	  };
	
	  Utils.stringToInt = function (value) {
	    if (/^(\-|\+)?([0-9]+|Infinity)$/.test(value)) {
	      return Number(value);
	    }
	
	    return NaN;
	  };
	
	  Utils.stringToBoolean = function (value) {
	    return Utils.isNotNull(value) && (value === "true" || value === true) ? true : false;
	  };
	
	  Utils.parseFloat = function (value) {
	    var parsedValue = parseFloat(value);
	
	    if (Utils.isNumber(parsedValue)) {
	      return parsedValue;
	    }
	
	    return null;
	  };
	
	  Utils.stringifyJSON = function (obj, replacer, space) {
	    return JSON.stringify(obj, replacer, space);
	  };
	
	  Utils.parseJSON = function (str, safe, nullOnError) {
	    if (safe) {
	      try {
	        var objValue = JSON.parse(str);
	        return objValue;
	      } catch (e) {
	        return nullOnError ? null : str;
	      }
	    } else {
	      return JSON.parse(str);
	    }
	  };
	
	  Utils.rgbToHex = function (r, g, b) {
	    if (r > 255 || g > 255 || b > 255) {
	      throw "Invalid color component";
	    }
	
	    var hex = (r << 16 | g << 8 | b).toString(16);
	    return "#" + ("000000" + hex).slice(-6);
	  };
	
	  Utils.hexToRgb = function (hex) {
	    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
	    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
	    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
	      return r + r + g + g + b + b;
	    });
	
	    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	    return result ? {
	      r: parseInt(result[1], 16),
	      g: parseInt(result[2], 16),
	      b: parseInt(result[3], 16)
	    } : null;
	  };
	
	  Utils.hexToCmyk = function (hex) {
	    var computedC = void 0;
	    var computedM = void 0;
	    var computedY = void 0;
	    var computedK = void 0;
	
	    hex = hex.replace("#", "");
	
	    if (hex.length !== 6) {
	      return null;
	    }
	    if (/[0-9a-f]{6}/i.test(hex) !== true) {
	      return null;
	    }
	
	    var r = parseInt(hex.substring(0, 2), 16);
	    var g = parseInt(hex.substring(2, 4), 16);
	    var b = parseInt(hex.substring(4, 6), 16);
	
	    // BLACK
	    if (r === 0 && g === 0 && b === 0) {
	      return {
	        c: 0,
	        m: 0,
	        y: 0,
	        k: 1
	      };
	    }
	
	    computedC = 1 - r / 255;
	    computedM = 1 - g / 255;
	    computedY = 1 - b / 255;
	
	    var minCMY = Math.min(computedC, Math.min(computedM, computedY));
	
	    computedC = (computedC - minCMY) / (1 - minCMY);
	    computedM = (computedM - minCMY) / (1 - minCMY);
	    computedY = (computedY - minCMY) / (1 - minCMY);
	    computedK = minCMY;
	
	    return {
	      c: computedC,
	      m: computedM,
	      y: computedY,
	      k: computedK
	    };
	  };
	
	  Utils.roundNumber = function (number, decimals) {
	    if (Utils.isNumber(number)) {
	      var rounder = Math.pow(10, decimals);
	      return Math.round(number * rounder) / rounder;
	    }
	
	    return NaN;
	  };
	
	  Utils.format = function (format) {
	    var args = Array.prototype.slice.call(arguments, 1);
	    return format.replace(/{(\d+)}/g, function (match, number) {
	      return utils.isDefined(args[number]) ? args[number] : match;
	    });
	  };
	
	  Utils.formatMoney = function (value, currency) {
	    if (currency.beforePrice) {
	      return currency.escapedSymbol + "" + utils.formatNumber(utils.roundNumber(value, 2), { decimalLength: 2 });
	    }
	
	    return utils.formatNumber(utils.roundNumber(value, 2), { decimalLength: 2 }) + "" + currency.symbol;
	  };
	
	  Utils.formatNumber = function (value, options) {
	    if (!utils.isNumber(value)) return null;
	
	    options = utils.isNotNull(options) ? options : {};
	
	    var decimalLength = ~~options.decimalLength,
	        groupLength = utils.isNumber(options.groupLength) ? options.groupLength : 3,
	        groupDelimiter = options.groupDelimiter || ",",
	        decimalDelimiter = options.decimalDelimiter;
	
	    var re = "\\d(?=(\\d{" + groupLength + "})+" + (decimalLength > 0 ? "\\D" : "$") + ")",
	        num = value.toFixed(Math.max(0, decimalLength));
	
	    return (decimalDelimiter ? num.replace(".", decimalDelimiter) : num).replace(new RegExp(re, "g"), "$&" + groupDelimiter);
	  };
	
	  Utils.getRandomIntInclusive = function (min, max) {
	    min = Math.ceil(min);
	    max = Math.floor(max);
	    return Math.floor(Math.random() * (max - min + 1)) + min;
	  };
	
	  Utils.getContrastYIQ = function (hexColor) {
	    hexColor = hexColor.replace("#", "");
	
	    var r = parseInt(hexColor.substr(0, 2), 16);
	    var g = parseInt(hexColor.substr(2, 2), 16);
	    var b = parseInt(hexColor.substr(4, 2), 16);
	    var yiq = (r * 299 + g * 587 + b * 114) / 1000;
	
	    return yiq;
	  };
	
	  Utils.getContrastColor = function (color, options) {
	    options = Utils.isNotNull(options) ? options : {};
	
	    var yiqColor = Utils.getContrastYIQ(color);
	
	    var threshold = Utils.isNumber(options.threshold) ? options.threshold : 256 / 2;
	    var belowThresholdColor = Utils.isNotNull(options.belowThresholdColor) ? options.belowThresholdColor : "#ffffff";
	    var aboveThresholdColor = Utils.isNotNull(options.aboveThresholdColor) ? options.aboveThresholdColor : "#000000";
	
	    return yiqColor < threshold ? belowThresholdColor : aboveThresholdColor;
	  };
	
	  Utils.invertColor = function (hexColor) {
	    hexColor = hexColor.replace("#", ""); // remove #
	    hexColor = parseInt(hexColor, 16); // convert to integer
	    hexColor = 0xFFFFFF ^ hexColor; // invert three bytes
	    hexColor = hexColor.toString(16); // convert to hex
	    hexColor = ("000000" + hexColor).slice(-6); // pad with leading zeros
	    hexColor = "#" + hexColor; // prepend #
	
	    return hexColor;
	  };
	
	  Utils.arraysAreEqual = function (arr1, arr2) {
	    if (arr1 === arr2) return true;
	    if (utils.isNull(arr1) || utils.isNull(arr2)) return false;
	    if (arr1.length !== arr2.length) return false;
	
	    for (var i = 0; i < arr1.length; i++) {
	      if (arr1[i] !== arr2[i]) return false;
	    }
	
	    return true;
	  };
	
	  Utils.resetFormElement = function (el) {
	    $(el).wrap("<form></form>").closest("form").get(0).reset();
	    $(el).unwrap();
	  };
	
	  Utils.setButtonLoading = function ($element, flag) {
	    if (utils.isNull($element) || !$element.length) return;
	
	    $element.prop("disabled", flag);
	
	    if (flag) {
	      $element.addClass("btn-loading");
	    } else {
	      $element.removeClass("btn-loading");
	    }
	  };
	
	  Utils.getServiceUrl = function (path) {
	    return config.serviceBaseURL + path;
	  };
	
	  Utils.luhnCheck = function (str) {
	    return str.split("").reduceRight(function (prev, curr, idx) {
	      if ((idx + 1) % 2 !== 0) {
	        curr = (curr * 2).toString().split("").reduce(function (p, c) {
	          return +p + +c;
	        });
	      }
	      return +prev + +curr;
	    }) % 10 === 0;
	  };
	
	  Utils.resolveProperty = function (path, obj) {
	    return path.split(".").reduce(function (prev, curr) {
	      return prev ? prev[curr] : null;
	    }, obj || self);
	  };
	
	  Utils.setPropertyValue = function (path, obj, value, createMissing) {
	    return path.split(".").reduce(function (prev, curr, index, arr) {
	      if (createMissing && utils.isNotNull(prev) && !prev.hasOwnProperty(curr)) {
	        if (index < arr.length - 1) {
	          prev[curr] = {};
	        }
	      }
	
	      // Note: maybe add check to see if prev is an object and also check to see
	
	      if (index === arr.length - 1) {
	        prev[curr] = value;
	      }
	
	      return prev ? prev[curr] : null;
	    }, obj || self);
	  };
	
	  Utils.getQueryParam = function (name) {
	    return queryParams[name];
	  };
	
	  Utils.getUrlPath = function () {
	    return window.location.pathname;
	  };
	
	  Utils.getPathSection = function (index) {
	    var path = window.location.pathname;
	    var pathSections = path.split("/");
	
	    for (var i = 0; i < pathSections.length; i++) {
	      var pathSection = pathSections[i];
	
	      if (Utils.isNullOrEmpty(pathSection)) {
	        index++;
	        continue;
	      }
	
	      if (i + 1 === index) {
	        return pathSection;
	      }
	    }
	
	    return null;
	  };
	
	  Utils.getPathSectionLength = function () {
	    var path = window.location.pathname;
	    var pathSections = path.split("/");
	
	    return pathSections.length;
	  };
	
	  Utils.btoa = function (stringToEncode) {
	    return Utils.isNotNull(stringToEncode) ? window.btoa(encodeURIComponent(stringToEncode)) : null;
	  };
	
	  Utils.atob = function (stringToDecode) {
	    return Utils.isNotNull(stringToDecode) ? decodeURIComponent(window.atob(stringToDecode)) : null;
	  };
	
	  var entityMap = {
	    "&": "&amp;",
	    "<": "&lt;",
	    ">": "&gt;",
	    '"': "&quot;", // eslint-disable-line
	    "'": "&#39;",
	    "/": "&#x2F;"
	  };
	
	  Utils.escapeHtml = function (string) {
	    return String(string).replace(/[&<>"'\/]/g, function (s) {
	      return entityMap[s];
	    });
	  };
	
	  Utils.debounce = function (func, wait, immediate, context) {
	    var timeout = void 0;
	    return function () {
	      context = context || this;
	      var args = arguments;
	      var later = function later() {
	        timeout = null;
	        if (!immediate) func.apply(context, args);
	      };
	
	      var callNow = immediate && !timeout;
	      clearTimeout(timeout);
	      timeout = setTimeout(later, wait);
	      if (callNow) func.apply(context, args);
	    };
	  };
	})(utils);
	
	// Load query parameters once
	(window.onpopstate = function () {
	  var match = void 0,
	      pl = /\+/g,
	      // Regex for replacing addition symbol with a space
	  search = /([^&=]+)=?([^&]*)/g,
	      decode = function decode(s) {
	    return decodeURIComponent(s.replace(pl, " "));
	  },
	      query = window.location.search.substring(1);
	
	  queryParams = {};
	  while (match = search.exec(query)) {
	    var name = decode(match[1]);
	    var value = decode(match[2]);
	
	    if (queryParams.hasOwnProperty(name)) {
	      if (!utils.isArray(queryParams[name])) {
	        // Make it an array
	        queryParams[name] = [queryParams[name]];
	      }
	
	      queryParams[name].push(value);
	    } else {
	      queryParams[name] = value;
	    }
	  }
	})();
	
	module.exports = utils;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * User: jv
	 * Date: 12/05/16
	 * Time: 12:56
	 */
	var utils = __webpack_require__(4);
	var log = __webpack_require__(7)();
	var CONSTANTS = __webpack_require__(331);
	var localeReq = __webpack_require__(17);
	
	var LanguageManager = {};
	
	(function (LanguageManager) {
	    var locale = null;
	    var localeMap = null;
	
	    LanguageManager.init = function () {
	        localStorage.removeItem("locale");
	        // locale = sessionStorage.getItem("locale");
	
	        var tmpLocale = utils.getQueryParam("locale");
	        if (!utils.isNullOrEmpty(tmpLocale)) {
	            locale = tmpLocale;
	            // sessionStorage.setItem("locale", locale);
	        }
	
	        if (utils.isNullOrEmpty(locale) || !localeExists(locale)) {
	            locale = CONSTANTS.DEFAULT_LOCALE;
	        }
	
	        $("html").addClass(locale);
	
	        _init();
	    };
	
	    function _init() {
	        getLocaleMap();
	        applyLocale();
	        $(".page-wrapper").show();
	
	        if (utils.isFunction(LanguageManager.onInit)) {
	            LanguageManager.onInit();
	        }
	
	        if (utils.isFunction(LanguageManager.onInitGlobal)) {
	            LanguageManager.onInitGlobal();
	        }
	    }
	
	    LanguageManager.onInit = null;
	
	    LanguageManager.onInitGlobal = null;
	
	    LanguageManager.changeLocale = function (newLocale) {
	        if (localeExists(newLocale)) {
	            $("html").removeClass(locale).addClass(newLocale);
	            locale = newLocale;
	            // sessionStorage.setItem("locale", locale);
	            LanguageManager.localize();
	        } else {
	            throw "Locale does not exist";
	        }
	    };
	
	    LanguageManager.getCurrentLocale = function () {
	        return locale;
	    };
	
	    LanguageManager.localize = function () {
	        if (!localeMapIsDefined() || locale !== localeMap.locale) {
	            getLocaleMap();
	            applyLocale();
	        } else {
	            applyLocale();
	        }
	    };
	
	    function getLocaleMap() {
	        try {
	            log.info("Trying to fetch locale '%s'", locale);
	
	            var localeRequire = "./" + locale + ".json";
	
	            log.info("'%s' is in %o ? %s", localeRequire, localeReq.keys(), $.inArray(localeRequire, localeReq.keys()) !== -1);
	
	            if ($.inArray(localeRequire, localeReq.keys()) !== -1) {
	                var tmpLocaleMap = localeReq(localeRequire);
	
	                log.info("Successfully fetched locale map for locale [%s]: %o", locale, tmpLocaleMap);
	
	                localeMap = tmpLocaleMap;
	            } else if (locale !== "en-GB" && $.inArray("./en-GB.json", localeReq.keys()) !== -1) {
	                $("html").removeClass(locale).addClass("en-GB");
	                locale = "en-GB";
	                // sessionStorage.setItem("locale", locale);
	                getLocaleMap(callback);
	            } else {
	                log.error("Couldn't find locale [%s] in known locale list: %o", locale, localeReq.keys());
	                alert("Localisation could not be loaded, contact your site administrator.");
	            }
	        } catch (e) {
	            console.error(e);
	        }
	    }
	
	    LanguageManager.localeExists = function (locale) {
	        return localeExists(locale);
	    };
	
	    function localeExists(pLocale) {
	        var localeRequire = "./" + pLocale + ".json";
	
	        return $.inArray(localeRequire, localeReq.keys()) !== -1;
	    }
	
	    LanguageManager.applyLocale = function (selector) {
	        if (localeMapIsDefined() && locale === localeMap.locale) {
	            // Add back to include the selector itself
	            applyLocale($(selector).find("[data-localize]").addBack(selector).filter("[data-localize]"));
	        }
	    };
	
	    function applyLocale($element) {
	        $element = utils.isNotNull($element) ? $element : $("[data-localize]");
	
	        $element.each(function () {
	            var element = $(this);
	            var key = $(this).data("localize");
	
	            if ((typeof localeMap === "undefined" ? "undefined" : _typeof(localeMap)) === "object" && localeMap.localization.hasOwnProperty(key)) {
	                changeTextOrPlaceholder(element, LanguageManager.getValueForKey(key));
	            } else {
	                changeTextOrPlaceholder(element, key);
	            }
	        });
	    }
	
	    function changeTextOrPlaceholder(element, text) {
	        if (element.is("input") || element.is("textarea")) {
	            //element.attr("placeholder", text.toLowerCase());
	            element.attr("placeholder", text);
	        } else {
	            replaceNodeText(element, text);
	        }
	    }
	
	    function replaceNodeText(element, text) {
	        element.html(text);
	    }
	
	    LanguageManager.getValueForKey = function (key) {
	        if (localeMapIsDefined() && localeMap.localization.hasOwnProperty(key)) {
	            var result = localeMap.localization[key];
	            result = result.replaceAll("{next-icon}", "<i class='fa fa-angle-double-right'></i>");
	            return result;
	        } else {
	            return key;
	        }
	    };
	
	    function localeMapIsDefined() {
	        return utils.isObject(localeMap) && localeMap.hasOwnProperty("locale") && localeMap.hasOwnProperty("localization");
	    }
	})(LanguageManager);
	
	// Expose the Language manager to the window, this will be available as soon as the Language manager is accessed the first time (when a game is loaded)
	/* Use this code in the console to cycle between all languages on a 3 second delay
	
	["en-GB","nl-BE","it-IT","et-EE","de-DE","es-ES","pt-PT","si-SI","fi-FI","ba-BA","rs-RS","hr-HR","se-SE","pl-PL","gr-GR","cz-CZ","fr-FR","lv-LV","jp-JP"].forEach((element, index) => {
	    setTimeout(() => {
	        LanguageManager.changeLocale(element);
	    }, 3000 * index);
	});
	
	* */
	window.LanguageManager = LanguageManager;
	
	module.exports = LanguageManager;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Created by jv on 25/07/2017.
	 */
	var utils = __webpack_require__(4);
	
	var hasLogged = false;
	
	module.exports = function (debug) {
	  var Logger = {};
	
	  // function init(force)
	  // {
	  //   if(debug || __DEVELOPMENT__ || force)
	  //   {
	  //     for(var m in console)
	  //     {
	  //       if(utils.isFunction(console[m]))
	  //       {
	  //         Logger[m] = console[m].bind(window.console);
	  //       }
	  //     }
	  //
	  //     Logger.cssLog = function(...args)
	  //     {
	  //       if(!hasLogged)
	  //       {
	  //         Logger.info("If you want to preserve the correct file name and line number stuff then you can add the logger.js script to the blackbox (chrome)\nThis basically removes the file from debugging, read: https://developer.chrome.com/devtools/docs/blackboxing");
	  //         hasLogged = true;
	  //       }
	  //
	  //       args = Logger.cssify.apply(null, args);
	  //       return Logger.log.apply(null, args);
	  //     }
	  //   }
	  //   else
	  //   {
	  //     for(var m in console)
	  //     {
	  //       if(utils.isFunction(console[m]))
	  //       {
	  //         Logger[m] = () => {};
	  //       }
	  //     }
	  //
	  //     Logger.cssLog = () => {};
	  //   }
	  // }
	  //
	  // init();
	
	  function isDebug() {
	    if (!window.console || !window.console.info || !window.console.debug || !window.console.error || !window.console.log || !window.console.warn || !window.console.trace) {
	      return false;
	    }
	
	    return debug || (false) || window.__PRODUCTION_LOGGING__;
	  }
	
	  function firstLogCheck() {
	    if (!hasLogged) {
	      console.log("If you want to preserve the correct file name and line number stuff then you can add the logger.js script to the blackbox (chrome)\nThis basically removes the file from debugging, read: https://developer.chrome.com/devtools/docs/blackboxing");
	      hasLogged = true;
	    }
	  }
	
	  Logger.trace = function () {
	    if (isDebug()) {
	      firstLogCheck();
	
	      try {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        console.trace.apply(null, args);
	      } catch (e) {
	        console.error(e);
	      }
	    }
	  };
	
	  Logger.debug = function () {
	    if (isDebug()) {
	      firstLogCheck();
	
	      try {
	        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	          args[_key2] = arguments[_key2];
	        }
	
	        console.debug.apply(null, args);
	      } catch (e) {
	        console.error(e);
	      }
	    }
	  };
	
	  Logger.log = function () {
	    if (isDebug()) {
	      firstLogCheck();
	
	      try {
	        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	          args[_key3] = arguments[_key3];
	        }
	
	        console.log.apply(null, args);
	      } catch (e) {
	        console.error(e);
	      }
	    }
	  };
	
	  Logger.info = function () {
	    if (isDebug()) {
	      firstLogCheck();
	
	      try {
	        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	          args[_key4] = arguments[_key4];
	        }
	
	        console.info.apply(null, args);
	      } catch (e) {
	        console.error(e);
	      }
	    }
	  };
	
	  Logger.cssLog = function () {
	    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	      args[_key5] = arguments[_key5];
	    }
	
	    if (isDebug()) {
	      firstLogCheck();
	      args = Logger.cssify.apply(null, args);
	
	      try {
	        console.log.apply(null, args);
	      } catch (e) {
	        console.error(e);
	      }
	    }
	  };
	
	  Logger.warn = function () {
	    if (isDebug()) {
	      firstLogCheck();
	
	      try {
	        for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	          args[_key6] = arguments[_key6];
	        }
	
	        console.warn.apply(null, args);
	      } catch (e) {
	        console.error(e);
	      }
	    }
	  };
	
	  Logger.error = function () {
	    if (isDebug()) {
	      firstLogCheck();
	
	      try {
	        for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	          args[_key7] = arguments[_key7];
	        }
	
	        console.error.apply(null, args);
	      } catch (e) {
	        console.error(e);
	      }
	    }
	  };
	
	  Logger.cssify = function () {
	    for (var _len8 = arguments.length, args = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
	      args[_key8] = arguments[_key8];
	    }
	
	    if (args.length > 1) {
	      var css = args[args.length - 1];
	      args.splice(args.length - 1, 1);
	
	      var cssString = "";
	
	      for (var key in css) {
	        if (css.hasOwnProperty(key)) {
	          cssString += key + ": " + css[key] + ";";
	        }
	      }
	
	      if (utils.isString(args[0])) {
	        if ((args[0].match(/%c/g) || []).length === 0) {
	          // Css applies to the whole text so just insert the css at the second (first is the text) and last place
	          args[0] = "%c" + args[0] + "%c";
	
	          args.splice(1, 0, cssString);
	          //Resets the css
	          args.push("");
	        } else if (args.length === 1) {
	          //If there's only text with no arguments, same as before, insert css at second and last place
	          args.push(cssString);
	          //Resets the css
	          args.push("");
	        } else {
	          // Determine where the css arguments need to go in the array
	          /*
	             %s - String.
	             %d - Number (integer or floating point value).
	             %i - Integer.
	             %f - Floating point value.
	             %j - JSON. Replaced with the string '[Circular]' if the argument contains circular references.
	             %o - JavaScript Object
	           */
	
	          // position BEFORE the first %c
	          var startPos = args[0].indexOf("%c");
	          // position AFTER the last %c
	          var endPos = args[0].lastIndexOf("%c") + 2;
	
	          if (startPos !== -1 && endPos !== -1 && startPos !== endPos) {
	            var leftSubString = args[0].substring(0, startPos);
	            var rightSubString = args[0].substr(endPos);
	            // Find all format occurrences
	            var firstInsert = (leftSubString.match(/(%s|%d|%i|%f|%j|%o)/g) || []).length;
	            var secondInsert = (rightSubString.match(/(%s|%d|%i|%f|%j|%o)/g) || []).length;
	
	            // Account for the text that's in the first position
	            args.splice(firstInsert + 1, 0, cssString);
	            //Resets the css
	            args.splice(args.length - secondInsert, 0, "");
	          }
	        }
	      }
	
	      return args;
	    }
	  };
	
	  // http://www.flatuicolorpicker.com/
	  /*
	    SUMMER SKY
	    1E8BC3
	    30, 139, 195
	   */
	  Logger.infoCss = {
	    "background-color": "#1E8BC3",
	    "color": "#ffffff"
	  };
	
	  /*
	    EUCALYPTUS
	    26A65B
	    38, 166, 91
	   */
	  Logger.successCss = {
	    "background-color": "#26A65B",
	    "color": "#ffffff"
	  };
	
	  /*
	    SANDSTORM
	    F9BF3B
	    249, 191, 59
	   */
	  Logger.warningCss = {
	    "background-color": "#F9BF3B",
	    "color": "#000000"
	  };
	
	  /*
	    FLAMINGO
	    EF4836
	    239, 72, 54
	   */
	  Logger.errorCss = {
	    "background-color": "#EF4836",
	    "color": "#ffffff"
	  };
	
	  return Logger;
	};
	
	/*
	Examples:

	logger.info("Hi");
	logger.warn("Warning");
	logger.error("Error");
	logger.cssLog("Hi %s", "Jan", logger.successCss);
	logger.cssLog("Hi %cthere Jan%c", logger.warningCss);
	logger.cssLog("Hi there %s, my name is %c%s and I am%c %d", "Jan", "Someone", 23, logger.errorCss);
	*/

/***/ }),

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	var _userServices = __webpack_require__(96);
	
	var _userServices2 = _interopRequireDefault(_userServices);
	
	var _formUtils = __webpack_require__(277);
	
	var _formUtils2 = _interopRequireDefault(_formUtils);
	
	var _utils = __webpack_require__(4);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _modal = __webpack_require__(517);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _icon_account = __webpack_require__(894);
	
	var _icon_account2 = _interopRequireDefault(_icon_account);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by jv on 10/03/2017.
	 */
	// Styles
	__webpack_require__(738);
	__webpack_require__(740);
	__webpack_require__(737);
	
	// js
	__webpack_require__(918);
	__webpack_require__(531);
	// Polyfill promises
	__webpack_require__(735);
	__webpack_require__(518);
	// These libs aren't nice and put themselves in window instead of being able to be required into a variable
	// prepend the JS files with 'script-loader?' to require them like they were added with ordinary <script> tags
	// https://webpack.github.io/docs/shimming-modules.html
	__webpack_require__(921); // Is used to check if browser is outdated
	__webpack_require__(920); // requires the cookieconsent library like it was a script tag in the html
	__webpack_require__(919);
	
	// Dark mode favicon
	var faviconDark = __webpack_require__(928);
	
	// Global app styles (after external libs)
	__webpack_require__(771);
	
	var log = __webpack_require__(7)();
	
	
	var Shared = {};
	
	(function (Shared) {
	  Shared.init = function () {
	    if (Shared.isOutdated()) {
	      log.info("Browser is outdated, redirecting to /outdated");
	      _utils2.default.redirect("/outdated");
	    }
	
	    var userData = Shared.getUserData();
	
	    if (_utils2.default.isNotNull(userData)) {
	      log.info("User: %o", userData);
	    }
	
	    if (false) {} else {
	      if (_utils2.default.isNotNull(userData)) {}
	      // ga("set", "userId", userData.userKey);
	      // ga("set", "dimension1", userData.userKey);
	
	
	      // ga("send", "pageview");
	    }
	
	    setUpMatchMedia();
	
	    // Set default nav link highlight (try to find it based on current path
	    Shared.setNavHighlight();
	
	    setUpFragmentImages();
	
	    _languageManager2.default.init();
	
	    var urlParams = new URLSearchParams(window.location.search);
	    var queryParamLocale = urlParams.get("l");
	
	    if (_languageManager2.default.localeExists(queryParamLocale)) {
	      localStorage.setItem("teacher_locale", queryParamLocale);
	    }
	
	    var savedTeacherLocale = localStorage.getItem("teacher_locale");
	
	    if (_utils2.default.isNotNull(userData) && _utils2.default.isNotNull(userData.locale)) {
	      console.log("Trying to set locale from logged in user: " + userData.locale);
	      _languageManager2.default.changeLocale(userData.locale);
	    } else if (savedTeacherLocale !== null) {
	      console.log("Trying to set locale from saved setting: " + savedTeacherLocale);
	      _languageManager2.default.changeLocale(savedTeacherLocale);
	    }
	  };
	
	  _languageManager2.default.onInitGlobal = function () {
	    // Needs to be done after localization has been applied
	    setUpProfileTooltip();
	    setUpLanguageSelector();
	
	    try {
	      cookieconsent.initialise({
	        palette: {
	          popup: {
	            background: "#222222",
	            text: "#ffffff"
	          },
	          button: {
	            background: "#679CD3",
	            text: "#ffffff"
	          }
	        },
	        theme: "classic",
	        content: {
	          message: _languageManager2.default.getValueForKey("cookies.message"),
	          dismiss: _languageManager2.default.getValueForKey("cookies.button.text"),
	          link: _languageManager2.default.getValueForKey("cookies.link.text"),
	          href: _languageManager2.default.getValueForKey("cookies.link")
	        }
	      });
	    } catch (e) {
	      console.error(e);
	    }
	  };
	
	  Shared.setNavHighlight = function (href) {
	    href = _utils2.default.isNotNull(href) ? href : _utils2.default.getUrlPath();
	
	    $("header .navbar-nav .nav-item a.nav-link").each(function (index, el) {
	      var $el = $(el);
	      var navLink = $el.attr("href"),
	          alternatives = $el.data("link-alternatives");
	
	      if (href === navLink || _utils2.default.isNotNull(alternatives) && alternatives.split(";").includes(href)) {
	        $el.addClass("active");
	      }
	    });
	
	    $("header .navbar-nav .nav-item a.nav-link[href='" + href + "']").addClass("active");
	  };
	
	  Shared.isOutdated = function () {
	    return !Modernizr.filereader;
	  };
	
	  Shared.getUserData = function () {
	    var userData = $("#logged-in-user-data").attr("data-user");
	    if (_utils2.default.isNotNull(userData)) {
	      userData = decodeURIComponent(userData);
	
	      if (_utils2.default.isNotNull(userData)) {
	        userData = _utils2.default.parseJSON(userData, true);
	      }
	    }
	    return userData;
	  };
	
	  Shared.isLoggedIn = function () {
	    return _utils2.default.isNotNull(Shared.getUserData());
	  };
	
	  function setUpFragmentImages() {
	    var headerLogo = __webpack_require__(473);
	    // let footerLogo = require("Images/footer/cartamundi-logo.png");
	
	    $(".header-ecoceo-brand").append("<img src='" + headerLogo + "' alt='EcoCEO'/>");
	    $(".header-ecoceo-user").append("" + _icon_account2.default);
	    // $("#footer-main-logo").append("<img src='" + footerLogo + "'/>");
	  }
	
	  function setUpMatchMedia() {
	    // Matches the favicon to the current preferred color scheme
	
	    if (!_utils2.default.isFunction(window.matchMedia)) {
	      return;
	    }
	
	    var faviconDarkLink = document.createElement("link");
	    faviconDarkLink.setAttribute("rel", "favicon icon");
	    faviconDarkLink.setAttribute("type", "image/png");
	    faviconDarkLink.setAttribute("media", "(prefers-color-scheme:dark)");
	    faviconDarkLink.setAttribute("href", faviconDark);
	    document.head.appendChild(faviconDarkLink);
	
	    var links = collectLinks();
	
	    var current = document.createElement("link");
	    current.setAttribute("rel", "shortcut icon");
	    document.head.appendChild(current);
	
	    function faviconApplyLoop() {
	      links.forEach(function (link) {
	        if (window.matchMedia(link.media).matches) {
	          current.setAttribute("type", link.getAttribute("type"));
	          current.setAttribute("href", link.getAttribute("href"));
	        }
	      });
	    }
	
	    faviconApplyLoop();
	    links.forEach(function (link) {
	      document.head.removeChild(link);
	    });
	
	    var lightMediaMatch = window.matchMedia("(prefers-color-scheme:light)");
	    var darkMediaMatch = window.matchMedia("(prefers-color-scheme:dark)");
	
	    if (_utils2.default.isFunction(lightMediaMatch.addEventListener)) {
	      /*
	        This is basically an alias for EventTarget.addEventListener(), for backwards compatibility purposes.
	        Older browsers should use addListener instead of addEventListener since MediaQueryList only inherits from EventTarget in newer browsers.
	      */
	
	      lightMediaMatch.addEventListener("change", function (e) {
	        if (!e.matches) return;
	        faviconApplyLoop();
	      });
	
	      darkMediaMatch.addEventListener("change", function (e) {
	        if (!e.matches) return;
	        faviconApplyLoop();
	      });
	    } else {
	      // noinspection JSDeprecatedSymbols
	      lightMediaMatch.addListener(function (e) {
	        if (!e.matches) return;
	        faviconApplyLoop();
	      });
	
	      // noinspection JSDeprecatedSymbols
	      darkMediaMatch.addListener(function (e) {
	        if (!e.matches) return;
	        faviconApplyLoop();
	      });
	    }
	  }
	
	  function collectLinks() {
	    return Array.prototype.slice.apply(document.head.querySelectorAll("link[rel*='icon']"));
	  }
	
	  function setUpProfileTooltip() {
	    var $trigger = $("[data-nav-trigger='tooltip']");
	    var $popoverContent = $trigger.next();
	    $popoverContent = $($popoverContent.prop("outerHTML")).css("display", "").prop("outerHTML");
	
	    $trigger.popover({
	      content: $popoverContent,
	      html: true,
	      template: "<div class='popover popover-c-primary user-profile-popover' role='tooltip'><div class='popover-arrow'></div><div class='popover-body'></div></div>"
	    });
	
	    /*$trigger.on("hide.bs.popover", (e) =>
	    {
	      let $this = $(e.currentTarget);
	      let $popover = $(".user-profile-popover");
	      if(($popover.length && $popover.is(":hover")) || ($this.length && $this.is(":hover")))
	      {
	        log.info("HOVERING");
	        e.preventDefault();
	      }
	    });*/
	  }
	
	  function setUpLanguageSelector() {
	    var loggedInUser = Shared.getUserData();
	
	    var selectize = _formUtils2.default.setUpSelectize("#header-locale-selection", [{ value: "bs-BA", text: _languageManager2.default.getValueForKey("language.bs-BA") }, { value: "cs-CZ", text: _languageManager2.default.getValueForKey("language.cs-CZ") }, { value: "de-DE", text: _languageManager2.default.getValueForKey("language.de-DE") }, { value: "et-EE", text: _languageManager2.default.getValueForKey("language.et-EE") }, { value: "en-GB", text: _languageManager2.default.getValueForKey("language.en-GB"), default: true }, { value: "es-ES", text: _languageManager2.default.getValueForKey("language.es-ES") }, { value: "fr-FR", text: _languageManager2.default.getValueForKey("language.fr-FR") }, { value: "hr-HR", text: _languageManager2.default.getValueForKey("language.hr-HR") }, { value: "it-IT", text: _languageManager2.default.getValueForKey("language.it-IT") }, { value: "lv-LV", text: _languageManager2.default.getValueForKey("language.lv-LV") }, { value: "hu-HU", text: _languageManager2.default.getValueForKey("language.hu-HU") }, { value: "nl-BE", text: _languageManager2.default.getValueForKey("language.nl-BE") }, { value: "pl-PL", text: _languageManager2.default.getValueForKey("language.pl-PL") }, { value: "pt-PT", text: _languageManager2.default.getValueForKey("language.pt-PT") }, { value: "sl-SI", text: _languageManager2.default.getValueForKey("language.sl-SI") }, { value: "sk-SK", text: _languageManager2.default.getValueForKey("language.sk-SK") }, { value: "fi-FI", text: _languageManager2.default.getValueForKey("language.fi-FI") }, { value: "sv-SE", text: _languageManager2.default.getValueForKey("language.sv-SE") }, { value: "el-GR", text: _languageManager2.default.getValueForKey("language.el-GR") }, { value: "sr-RS", text: _languageManager2.default.getValueForKey("language.sr-RS") }, { value: "ja-JP", text: _languageManager2.default.getValueForKey("language.ja-JP") }]);
	
	    if (selectize && _utils2.default.isNotNull(loggedInUser)) {
	      selectize.setValue(loggedInUser.locale || "en-GB", true);
	    } else if (selectize && localStorage.getItem("teacher_locale") !== null) {
	      selectize.setValue(localStorage.getItem("teacher_locale") || "en-GB", true);
	    }
	
	    $("#header-locale-selection").off("change").on("change", function (e) {
	      var $el = $(this);
	      var locale = $el.val();
	
	      // Update the current language
	      _languageManager2.default.changeLocale(locale);
	      localStorage.setItem("teacher_locale", locale);
	
	      // Update user profile if logged in
	      var loggedInUser = Shared.getUserData();
	      if (_utils2.default.isNull(loggedInUser)) {
	        return;
	      }
	
	      var userKey = loggedInUser.userKey;
	
	      _userServices2.default.updateLocale(userKey, locale);
	    });
	  }
	
	  Shared.Dialog = _modal2.default;
	
	  return Shared;
	})(Shared);
	
	module.exports = Shared;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Created by jv on 2019-09-10 (13:39).
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	var _utils = __webpack_require__(4);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var log = __webpack_require__(7)();
	
	
	__webpack_require__(765);
	
	var GameView = function () {
	  function GameView(options) {
	    _classCallCheck(this, GameView);
	
	    this.key = options.key;
	    this.$container = $(options.container);
	    this.html = options.html;
	    this.$element = null;
	
	    this.gameSessionController = options.gameSessionController;
	
	    this.hasRendered = false;
	  }
	
	  _createClass(GameView, [{
	    key: "render",
	    value: function render() {
	      this.hasRendered = false;
	
	      this.$element = $(this.html);
	      this.$container.append(this.$element);
	      _languageManager2.default.applyLocale(this.$element);
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.show();
	      }
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.hide();
	      }
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.remove();
	      }
	    }
	  }, {
	    key: "onRender",
	    value: function onRender() {
	      this.hasRendered = true;
	    }
	  }, {
	    key: "_setUpEventListeners",
	    value: function _setUpEventListeners() {}
	  }]);
	
	  return GameView;
	}();
	
	module.exports = GameView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 20/07/2017.
	 */
	var utils = __webpack_require__(4);
	var Tooltip = __webpack_require__(509);
	var log = __webpack_require__(7)();
	
	module.exports = function () {
	  function FormValidator(options) {
	    _classCallCheck(this, FormValidator);
	
	    if (utils.isNull(options)) {
	      throw "options must be defined";
	    }
	
	    this.selector = $(options.selector);
	    // Rules either come from javascript in this property or from data attributes
	    // eg. data-fv-required="true" data-fv-min-length="6" data-fv-max-length="30" data-fv-same-as="something"
	    // if both are present then rules from javascript take priority
	    this.rules = options.rules;
	
	    this.errorClassName = utils.isNullOrEmpty(options.errorClassName) ? "is-invalid" : options.errorClassName;
	
	    this.validateOnChange = utils.isBoolean(options.validateOnChange) ? options.validateOnChange : false;
	    this.onValidateElement = options.onValidateElement;
	
	    this.hasChangedValues = false;
	
	    this.init();
	  }
	
	  _createClass(FormValidator, [{
	    key: "init",
	    value: function init() {
	      var that = this;
	
	      that.selector.find("input, textarea").on("input", function (e) {
	        var $el = $(this);
	        $el.removeClass(that.errorClassName);
	        if (utils.isNotNull(that.rules.tooltip)) {
	          Tooltip.dispose({ selector: $el }); // %NOTE: maybe better to enable/disable instead of create/destroy?
	        }
	      });
	
	      that.selector.find("select").on("change", function (e) {
	        var $el = $(this);
	        $el.removeClass(that.errorClassName);
	        if (utils.isNotNull(that.rules.tooltip)) {
	          Tooltip.dispose({ selector: $el }); // %NOTE: maybe better to enable/disable instead of create/destroy?
	        }
	      });
	
	      that.selector.find("input, textarea, select").on("change", function (e) {
	        var $el = $(this);
	        var name = $el.data("fv-name") || $el.attr("id");
	
	        var elRules = null;
	
	        if (utils.isNotNull(name) && utils.isNotNull(that.rules) && that.rules.hasOwnProperty(name)) {
	          elRules = that.rules[name];
	        }
	
	        var validateOnChange = that.validateOnChange;
	
	        if (utils.isNotNull(elRules)) {
	          validateOnChange = that.validateOnChange && elRules.validateOnChange !== false || elRules.validateOnChange;
	        }
	
	        if (validateOnChange) {
	          var isValid = FormValidator.validateElement($el, that.errorClassName, elRules);
	
	          if (utils.isFunction(that.onValidateElement)) {
	            that.onValidateElement($el, isValid);
	          }
	        }
	
	        that.hasChangedValues = true;
	      });
	    }
	  }, {
	    key: "clearForm",
	    value: function clearForm() {
	      this.selector.find("input, select, textarea").each(function (index, el) {
	        var $el = $(el);
	        var name = $el.data("fv-name") || $el.attr("id");
	        var tagName = $el.prop("tagName").toLowerCase();
	        var type = tagName === "input" ? $el.attr("type") : tagName;
	
	        if ($el.data("fv-ignore") === true || type === "hidden" || utils.isNullOrEmpty(name)) {
	          return true;
	        }
	
	        $el.val("");
	      });
	    }
	  }, {
	    key: "setValueForKey",
	    value: function setValueForKey(key, value, options) {
	      options = utils.isNotNull(options) ? options : {};
	
	      var $el = this.selector.find("[data-fv-name='" + key + "']");
	
	      if (utils.isNull($el) || !$el.length) {
	        $el = this.selector.find("#" + key);
	      }
	
	      if (utils.isNotNull($el) && $el.length) {
	        var tagName = $el.prop("tagName").toLowerCase();
	        var type = tagName === "input" ? $el.attr("type") : tagName;
	
	        if ($el.length > 0 && utils.isNotNull($el[0].selectize)) {
	          $el[0].selectize.setValue(value, true);
	        } else if (type === "checkbox") {
	          $el.prop("checked", value);
	        } else if (type === "radio") {
	          $el.prop("checked", $el.val() === value);
	        } else {
	
	          $el.val(value);
	        }
	
	        if (options.markAsChanged) {
	          this.hasChangedValues = true;
	        }
	
	        if (options.triggerChangeEvent) {
	          $el.trigger("change");
	        }
	
	        return $el;
	      } else {
	        return null;
	      }
	    }
	  }, {
	    key: "setValid",
	    value: function setValid(key, flag) {
	      var $el = this.selector.find("[data-fv-name='" + key + "']");
	
	      if (utils.isNull($el) || !$el.length) {
	        $el = this.selector.find("#" + key);
	      }
	
	      if (utils.isNotNull($el) && $el.length) {
	        if (utils.isNull(flag)) {
	          $el.removeClass("is-invalid").removeClass("is-valid");
	        }
	
	        if (flag) {
	          $el.removeClass("is-invalid").addClass("is-valid");
	        } else {
	          $el.removeClass("is-valid").addClass("is-invalid");
	        }
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate() {
	      var that = this;
	      var isValid = true;
	
	      this.selector.find("input, textarea, select").each(function (index, el) {
	        var $el = $(el);
	
	        var name = $el.data("fv-name") || $el.attr("id");
	
	        var elRules = null;
	
	        if (utils.isNotNull(name) && utils.isNotNull(that.rules) && that.rules.hasOwnProperty(name)) {
	          elRules = that.rules[name];
	        }
	
	        var formElValid = FormValidator.validateElement($el, that.errorClassName, elRules);
	
	        // log.info("%s is %s for rules %o", name, (formElValid ? "valid" : "not valid"), elRules);
	        if (utils.isFunction(that.onValidateElement)) {
	          that.onValidateElement($el, formElValid);
	        }
	
	        isValid = isValid && formElValid;
	      });
	
	      return isValid;
	    }
	  }, {
	    key: "getFormData",
	    value: function getFormData() {
	      var formData = {};
	
	      this.selector.find("input, select, textarea").each(function (index, el) {
	        var $el = $(el);
	        var name = $el.data("fv-name") || $el.attr("id");
	        var tagName = $el.prop("tagName").toLowerCase();
	        var type = tagName === "input" ? $el.attr("type") : tagName;
	
	        if ($el.data("fv-ignore") === true || type === "hidden") {
	          return true;
	        } else if (type === "checkbox") {
	          formData[name] = $el.prop("checked");
	        } else if (type === "radio") {
	          if ($el.prop("checked")) {
	            formData[name] = $el.val();
	          } else if (formData[name] === undefined) {
	            formData[name] = null;
	          }
	        } else {
	          formData[name] = $el.val();
	        }
	      });
	
	      return formData;
	    }
	  }], [{
	    key: "validateElement",
	    value: function validateElement(selector, errorClassName, rules) {
	      var $el = $(selector).removeClass(errorClassName);
	      var name = $el.data("fv-name") || $el.attr("id");
	      rules = utils.isNotNull(rules) ? rules : {};
	
	      if (utils.isNotNull(rules.tooltip)) {
	        Tooltip.dispose({ selector: $el });
	      }
	
	      var isValid = true;
	
	      var tagName = $el.prop("tagName").toLowerCase();
	      var type = tagName === "input" ? $el.attr("type") : tagName;
	      var value = $el.val();
	      var required = utils.isBoolean(rules.required) ? rules.required : $el.data("fv-required") || false;
	      var minLength = utils.isDefined(rules.minLength) ? rules.minLength : $el.data("fv-min-length");
	      var maxLength = utils.isDefined(rules.maxLength) ? rules.maxLength : $el.data("fv-max-length");
	      var minVal = utils.isDefined(rules.minVal) ? rules.minVal : $el.data("fv-min-val");
	      var maxVal = utils.isDefined(rules.maxVal) ? rules.maxVal : $el.data("fv-max-val");
	      var sameAs = utils.isDefined(rules.sameAs) ? rules.sameAs : $el.data("fv-same-as");
	      var validateFunc = rules.validator;
	      var trim = rules.trim === true;
	
	      if ($el.data("fv-ignore") === true || type === "hidden") {
	        return isValid;
	      }
	
	      var formElInfo = {
	        tagName: tagName,
	        type: type,
	        value: value,
	        required: required,
	        minLength: minLength,
	        maxLength: maxLength,
	        minVal: minVal,
	        maxVal: maxVal,
	        sameAs: sameAs,
	        validator: validateFunc,
	        trim: trim
	      };
	
	      log.cssLog("%c%s%c form element info: %o", name, formElInfo, log.infoCss);
	
	      if (utils.isNotNull(value) && trim) value = value.trim();
	
	      if (utils.isNullOrEmpty(value)) {
	        if (required) {
	          log.cssLog("%s is not valid because the value is required and value is [%s]", name, value, log.errorCss);
	          isValid = false;
	        }
	      } else {
	        if (type === "number") {
	          value = utils.stringToInt(value);
	        }
	
	        if (isValid && type === "number" && !utils.isNumber(value)) {
	          log.cssLog("%s is not valid because type is number and [%s] is not a number", name, value, log.errorCss);
	          isValid = false;
	        }
	
	        if (tagName === "input" || tagName === "textarea") {
	          if (type === "number") {
	            if (isValid && utils.isNumber(minVal)) {
	              if (value < minVal) {
	                log.cssLog("%s is not valid because value [%s] is less than the min-val (%s)", name, value, minVal, log.errorCss);
	                isValid = false;
	              }
	            }
	
	            if (isValid && utils.isNumber(maxVal)) {
	              if (value > maxVal) {
	                log.cssLog("%s is not valid because value [%s] is more than the max-val (%s)", name, value, maxVal, log.errorCss);
	                isValid = false;
	              }
	            }
	          } else {
	            if (isValid && utils.isNumber(minLength)) {
	              if (value.length < minLength) {
	                log.cssLog("%s is not valid because the length [%s] of value [%s] is less than the min-length (%s)", name, value.length, value, minLength, log.errorCss);
	                isValid = false;
	              }
	            }
	
	            if (isValid && utils.isNumber(maxLength)) {
	              if (value.length > maxLength) {
	                log.cssLog("%s is not valid because the length [%s] of value [%s] is greater than the max-length (%s)", name, value.length, value, maxLength, log.errorCss);
	                isValid = false;
	              }
	            }
	          }
	        }
	
	        if (isValid && type === "email" && !utils.isValidEmail(value)) {
	          log.cssLog("%s is not valid because type is email and [%s] is not a valid email", name, value, log.errorCss);
	          isValid = false;
	        }
	
	        if (isValid && utils.isNotNull(sameAs)) {
	          var sameAsEl = $("[data-fv-name='" + sameAs + "']");
	          var sameAsValue = void 0;
	
	          if (utils.isNotNull(sameAs) && sameAs.length) {
	            sameAsValue = sameAsEl.val();
	          } else {
	            sameAs = $(sameAs);
	
	            if (utils.isNotNull(sameAs) && sameAs.length) {
	              sameAsValue = sameAsEl.val();
	            }
	          }
	
	          if (value !== sameAsValue) {
	            log.cssLog("%s is not valid because value [%s] is not the same as value [%s] from %s", name, value, sameAsValue, sameAs, log.errorCss);
	            isValid = false;
	          }
	        }
	      }
	
	      if (isValid && utils.isFunction(validateFunc)) {
	        if (!validateFunc(value)) {
	          log.cssLog("%s is not valid because custom validator function did not return true for value [%s]", name, value, log.errorCss);
	          isValid = false;
	        }
	      }
	
	      if (isValid) {
	        log.cssLog("%s is valid with value [%s] for form element %o", name, value, formElInfo, log.successCss);
	      } else {
	        if (!$el.hasClass(errorClassName)) {
	          $el.addClass(errorClassName);
	        }
	
	        if (utils.isNotNull(rules.tooltip)) // %NOTE: maybe better to enable/disable instead of create/destroy?
	          {
	            Tooltip.create({
	              selector: $el,
	              content: rules.tooltip,
	              placement: utils.isNullOrEmpty(rules.tooltipPlacement) ? "top" : rules.tooltipPlacement
	            });
	          }
	      }
	
	      return isValid;
	    }
	  }]);
	
	  return FormValidator;
	}();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(4);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	var _investmentView = __webpack_require__(806);
	
	var _investmentView2 = _interopRequireDefault(_investmentView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 2019-09-25 (10:20).
	 */
	__webpack_require__(794);
	__webpack_require__(793);
	
	var log = __webpack_require__(7)();
	
	
	var resourceIcons = __webpack_require__(272);
	var investmentIcons = __webpack_require__(325);
	
	__webpack_require__(372);
	__webpack_require__(744);
	
	var investmentData = {
	    microchip_factory: {
	        image: "microchip_factory.svg",
	        imagePopup: "info_microchip_factory.svg",
	        market: { price: 2, image: "microchip.svg" }
	    },
	    phone_factory: {
	        image: "mobile_phone_factory.svg",
	        imagePopup: "info_mobile_phone_factory.svg",
	        market: { price: 5, image: "mobile phone.svg" }
	    },
	    bike_factory: {
	        image: "ebike_factory.svg",
	        imagePopup: "info_bike_factory.svg",
	        market: { price: 7, image: "bike.svg" }
	    },
	    microchip_efficiency: { image: "efficiency_microchip.svg", imagePopup: "info_resource_efficiency_microchip.svg" },
	    microchip_substitution: {
	        image: "substitution_microchip.svg",
	        imagePopup: "info_resource_substitution_microchip.svg"
	    },
	    phone_efficiency: { image: "efficiency_mobile.svg", imagePopup: "info_resource_efficiency_mobile.svg" },
	    phone_substitution: { image: "substitution_mobile.svg", imagePopup: "info_resource_substitution_mobile.svg" },
	    bike_efficiency: { image: "efficiency_bike.svg", imagePopup: "info_resource_efficiency_bike.svg" },
	    bike_substitution: { image: "substitution_bike.svg", imagePopup: "info_resource_substitution_bike.svg" },
	    waste_recycling: { image: "waste_recycling.svg", imagePopup: "info_waste_recycling.svg" },
	    microchip_reuse: { image: "microchip_reuse_facility.svg", imagePopup: "info_microchip_reuse_facility.svg" },
	    product_refurbishing: {
	        image: "product_refurbishing_facility.svg",
	        imagePopup: "info_product_refurbishing_facility.svg"
	    },
	    rental_maintenance: { image: "rental_maintenance_service.svg", imagePopup: "info_rental_maintenance_service.svg" },
	    repair_workshop: {
	        image: "repair_workshop.svg",
	        imagePopup: "info_repair_workshop.svg",
	        upgradeText: "investment.repair_workshop.text"
	    },
	    hire_employee: { image: "hire_employee.svg", imagePopup: "info_hire_employee.svg" }
	};
	
	var InvestmentsView = function () {
	    function InvestmentsView(options) {
	        _classCallCheck(this, InvestmentsView);
	
	        this.$container = $(options.container);
	        this.$element = null;
	
	        this.hasRendered = false;
	        if (InvestmentsView.hasPurchasedInvestment(options.team, { title: "bike_factory" })) {
	            investmentData.product_refurbishing.image = "product_refurbishing_facility_bike.svg";
	            investmentData.product_refurbishing.imagePopup = "info_product_refurbishing_facility_bike.svg";
	
	            investmentData.rental_maintenance.image = "rental_maintenance_service_bike.svg";
	            investmentData.rental_maintenance.imagePopup = "info_rental_maintenance_service_bike.svg";
	        }
	        this.investmentData = investmentData;
	
	        this.team = options.team;
	        this._roundOverview = options.roundOverview;
	
	        this.investments = options.investments;
	
	        this.onInvestmentClicked = options.onInvestmentClicked;
	    }
	
	    _createClass(InvestmentsView, [{
	        key: "render",
	        value: function render() {
	            this.hasRendered = false;
	
	            this.$element = $(_investmentView2.default);
	            this.$container.append(this.$element);
	            _languageManager2.default.applyLocale(this.$element);
	
	            // this.renderSlider();
	            this.renderOverview();
	
	            this.setUpEventListeners();
	        }
	    }, {
	        key: "renderOverview",
	        value: function renderOverview() {
	            try {
	                // this.$container.find(".investments-container").empty();
	
	                for (var i = 0; i < this.investments.length; ++i) {
	                    var investment = this.investments[i];
	
	                    var hardRequirements = InvestmentsView.checkHardRequirements(this.team, investment);
	                    var softRequirements = InvestmentsView.checkSoftRequirements(this.team, investment);
	                    var circular = investment.type === "circular";
	
	                    var hidden = InvestmentsView.hasPurchasedInvestment(this.team, investment) && !investment.rebuyable || !hardRequirements || circular && this.currentRoundData.roundIndex < 4;
	                    var notAffordable = !InvestmentsView.canAffordInvestment(this.roundOverview, investment);
	                    var locked = notAffordable || !softRequirements || this.currentRoundData.roundIndex < investment.minRound || this.currentRoundData.roundIndex > investment.maxRound;
	
	                    var $investmentTemplate = $("#upgrade-card-template")[0];
	                    var $clone = $($investmentTemplate).contents().clone();
	
	                    $clone.find(".investment-points").addClass(investment.points !== 0 ? "" : "visibility-hidden");
	
	                    $clone.find(".investment-cost label").text(investment.cost * -1);
	                    $clone.find(".investment-points label").text(investment.points);
	
	                    $clone.find(".upgrade-title").attr("data-localize", "investment." + investment.title + ".title");
	                    $clone.attr("data-investment-key", investment.key);
	
	                    var imageList = this.investmentData[investment.title];
	
	                    if (imageList !== undefined) {
	                        if (imageList.image !== undefined) {
	                            var src = investmentIcons("./" + imageList.image);
	
	                            investment.imagePopup = imageList.imagePopup;
	                            investment.imageBackground = imageList.imageBackground;
	                            investment.market = imageList.market;
	                            investment.upgradeText = imageList.upgradeText;
	
	                            $clone.find(".upgrade-body").html(src);
	                            $clone.find(".upgrade-body svg").css({
	                                "width": "100%",
	                                "height": "100%"
	                            });
	
	                            if (investment.upgradeText) {
	                                $clone.find(".upgrade-text").attr("data-localize", investment.upgradeText);
	                            } else {
	                                $clone.find(".upgrade-text").hide();
	                            }
	                        }
	                    }
	
	                    investment.calculatedCSSClass = InvestmentsView.calculateCSSClass(investment);
	
	                    $clone.addClass(investment.calculatedCSSClass);
	                    $clone.addClass(hidden ? "hidden" : "");
	                    $clone.addClass(notAffordable ? "not-affordable" : "");
	                    $clone.addClass(locked ? "locked" : "");
	
	                    if (notAffordable) {
	                        $clone.find(".investment-cost img").replaceWith(resourceIcons("./coins_red.svg"));
	                    }
	
	                    _languageManager2.default.applyLocale($clone);
	                    this.$container.find(".investments-container").append($clone);
	                }
	            } catch (e) {
	                log.error("Failed to render investment overview - " + e);
	            }
	        }
	    }, {
	        key: "updateData",
	        value: function updateData() {}
	    }, {
	        key: "show",
	        value: function show() {
	            if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	                this.$container.show();
	            }
	        }
	    }, {
	        key: "hide",
	        value: function hide() {
	            if (_utils2.default.isNotNull(this.$container) && this.$container.length) {
	                this.$container.hide();
	            }
	        }
	    }, {
	        key: "destroy",
	        value: function destroy() {
	            if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	                this.$element.remove();
	            }
	        }
	    }, {
	        key: "setUpEventListeners",
	        value: function setUpEventListeners() {
	            this.setUpInvestmentCardClickListener();
	        }
	    }, {
	        key: "setUpInvestmentCardClickListener",
	        value: function setUpInvestmentCardClickListener() {
	            var _this = this;
	
	            this.$element.find(".upgrade-card:not(.locked)").off("click").on("click", function (e) {
	                var $this = $(e.delegateTarget);
	                var investmentKey = $this.data("investment-key");
	
	                log.info("Clicked - %s", investmentKey);
	
	                var investment = _this.getInvestmentForKey(investmentKey);
	
	                if (_utils2.default.isNotNull(investment)) {
	                    var isLocked = $this.hasClass("locked");
	
	                    if (!isLocked) {
	                        if (_utils2.default.isFunction(_this.onInvestmentClicked)) {
	                            _this.onInvestmentClicked.call(_this, investment);
	                        }
	                    }
	                }
	            });
	        }
	    }, {
	        key: "getInvestmentForKey",
	        value: function getInvestmentForKey(key) {
	            if (_utils2.default.isNull(key)) return null;
	
	            for (var i = 0; i < this.investments.length; i++) {
	                if (this.investments[i].key === key) {
	                    return this.investments[i];
	                }
	            }
	
	            return null;
	        }
	    }, {
	        key: "roundOverview",
	        get: function get() {
	            return this._roundOverview;
	        },
	        set: function set(roundOverview) {
	            this._roundOverview = roundOverview;
	
	            this.updateData();
	        }
	    }, {
	        key: "currentRoundData",
	        get: function get() {
	            return this.roundOverview.currentRoundData;
	        }
	    }], [{
	        key: "calculateCSSClass",
	        value: function calculateCSSClass(investment) {
	            try {
	                switch (investment.description) {
	                    case "factory":
	                        return "type-factory";
	                    case "waste":
	                        return "type-waste";
	                    case "reuse":
	                        return "type-reuse";
	                    case "rental":
	                        return "type-rental";
	                    case "employee":
	                        return "type-employee";
	                    default:
	                        return "";
	                }
	            } catch (e) {}
	            return "";
	        }
	    }, {
	        key: "canAffordInvestment",
	        value: function canAffordInvestment(roundOverview, investment) {
	            return roundOverview.currentRoundData.credits >= investment.cost;
	        }
	    }, {
	        key: "hasPurchasedInvestment",
	        value: function hasPurchasedInvestment(team, investment) {
	            return this.purchasedInvestmentCount(team, investment) > 0;
	        }
	    }, {
	        key: "getPurchasedInvestment",
	        value: function getPurchasedInvestment(team, investment) {
	            return InvestmentsView.getPurchasedInvestmentByTitle(team, investment);
	        }
	    }, {
	        key: "checkHardRequirements",
	        value: function checkHardRequirements(team, investment) {
	            if (investment.title === "microchip_efficiency" && this.hasPurchasedInvestment(team, { title: "microchip_substitution" })) {
	                return false;
	            }
	            if (investment.title === "microchip_substitution" && this.hasPurchasedInvestment(team, { title: "microchip_efficiency" })) {
	                return false;
	            }
	            if (investment.title === "phone_efficiency" && this.hasPurchasedInvestment(team, { title: "phone_substitution" })) {
	                return false;
	            }
	            if (investment.title === "phone_substitution" && this.hasPurchasedInvestment(team, { title: "phone_efficiency" })) {
	                return false;
	            }
	            if (investment.title === "bike_efficiency" && this.hasPurchasedInvestment(team, { title: "bike_substitution" })) {
	                return false;
	            }
	            if (investment.title === "bike_substitution" && this.hasPurchasedInvestment(team, { title: "bike_efficiency" })) {
	                return false;
	            }
	
	            if (investment.title === "phone_factory" || investment.title === "phone_efficiency" || investment.title === "phone_substitution") {
	                return !this.hasPurchasedInvestment(team, { title: "bike_factory" });
	            }
	            if (investment.title === "bike_factory" || investment.title === "bike_efficiency" || investment.title === "bike_substitution") {
	                return !this.hasPurchasedInvestment(team, { title: "phone_factory" });
	            }
	            return true;
	        }
	    }, {
	        key: "checkSoftRequirements",
	        value: function checkSoftRequirements(team, investment) {
	            if (investment.title === "microchip_efficiency" || investment.title === "microchip_substitution") {
	                return this.hasPurchasedInvestment(team, { title: "microchip_factory" });
	            }
	            if (investment.title === "phone_efficiency" || investment.title === "phone_substitution") {
	                return this.hasPurchasedInvestment(team, { title: "phone_factory" });
	            }
	            if (investment.title === "bike_efficiency" || investment.title === "bike_substitution") {
	                return this.hasPurchasedInvestment(team, { title: "bike_factory" });
	            }
	
	            if (investment.title === "product_refurbishing") {
	                return this.hasPurchasedInvestment(team, { title: "microchip_reuse" });
	            }
	            if (investment.title === "rental_maintenance") {
	                return this.hasPurchasedInvestment(team, { title: "phone_factory" }) || this.hasPurchasedInvestment(team, { title: "bike_factory" });
	            }
	            if (investment.title === "repair_workshop") {
	                return this.hasPurchasedInvestment(team, { title: "rental_maintenance" });
	            }
	            return true;
	        }
	    }, {
	        key: "purchasedInvestmentCount",
	        value: function purchasedInvestmentCount(team, investment) {
	            return team.investmentData.filter(function (i) {
	                return i.title === investment.title;
	            }).length;
	        }
	    }, {
	        key: "getPurchasedInvestmentByTitle",
	        value: function getPurchasedInvestmentByTitle(team, investment) {
	            var investments = team.investmentData.filter(function (i) {
	                return i.title === investment.title;
	            });
	
	            if (investments.length > 0) {
	                investments[0].imagePopup = investmentData[investment.title].imagePopup;
	                investments[0].imageBackground = investmentData[investment.title].imageBackground;
	                investments[0].market = investmentData[investment.title].market;
	                investments[0].upgradeText = investmentData[investment.title].upgradeText;
	
	                return investments[0];
	            }
	
	            return null;
	        }
	    }]);
	
	    return InvestmentsView;
	}();
	
	exports.default = InvestmentsView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Created by jv on 19/07/2017.
	 */
	var utils = __webpack_require__(4);
	var request = __webpack_require__(248);
	
	var UserServices = {};
	
	(function (UserServices) {
	  UserServices.logout = function () {
	    return request.get({
	      url: "/logout",
	      cache: false
	    });
	  };
	
	  UserServices.usernameExists = function (username) {
	    return request.post({
	      // url: "/access/authenticate/password",
	      url: utils.getServiceUrl("/users/validate-username/" + encodeURIComponent(username)),
	      cache: false,
	      dataType: request.DATA_TYPES.JSON,
	      contentType: request.CONTENT_TYPES.APPLICATION_JSON
	    });
	  };
	
	  UserServices.authenticateUser = function (username, password) {
	    // AuthenticateUserServlet functions as a proxy for /access/authenticate/password so we can force logout when a new authentication is requested
	    return request.post({
	      // url: "/access/authenticate/password",
	      // url: "/authenticate-user",
	      url: "/authenticate-user",
	      cache: false,
	      dataType: request.DATA_TYPES.TEXT,
	      contentType: request.CONTENT_TYPES.APPLICATION_FORM_URLENCODED,
	      data: {
	        username: utils.isDefined(username) ? username : null,
	        password: utils.isDefined(password) ? password : null
	      }
	    });
	  };
	
	  UserServices.requestPasswordReset = function (username) {
	    return request.post({
	      url: utils.getServiceUrl("/users/reset-password"),
	      cache: false,
	      // contentType: request.CONTENT_TYPES.APPLICATION_FORM_URLENCODED,
	      data: {
	        username: username
	      }
	    }).then(function (data) {
	      var rtrnData = null;
	
	      if (utils.isNotNull(data) && data.result === "success" && data.data) {
	        rtrnData = data.data;
	      }
	
	      return rtrnData;
	    });
	  };
	
	  UserServices.changePassword = function (data) {
	    return request.post({
	      url: utils.getServiceUrl("/users/change-password"),
	      cache: false,
	      // contentType: request.CONTENT_TYPES.APPLICATION_FORM_URLENCODED,
	      data: {
	        username: data.username,
	        "password-old": data.passwordOld,
	        "password-new": data.passwordNew,
	        ticket: data.ticket
	      }
	    }).then(function (data) {
	      var rtrnData = null;
	
	      if (utils.isNotNull(data) && data.result === "success" && data.data) {
	        rtrnData = data.data;
	      }
	
	      return rtrnData;
	    });
	  };
	
	  UserServices.getUser = function (key) {
	    return request.get({
	      url: utils.getServiceUrl("/users/" + key),
	      cache: false,
	      dataType: request.DATA_TYPES.JSON,
	      contentType: request.CONTENT_TYPES.APPLICATION_JSON
	    }).then(function (data) {
	      var user = null;
	
	      if (utils.isNotNull(data) && data.result === "success" && utils.isNotNull(data.data)) {
	        user = data.data;
	      }
	
	      return user;
	    });
	  };
	
	  UserServices.registerUser = function (userObj) {
	    return request.post({
	      url: utils.getServiceUrl("/users/register"),
	      cache: false,
	      dataType: request.DATA_TYPES.JSON,
	      contentType: request.CONTENT_TYPES.APPLICATION_JSON,
	      data: {
	        firstname: userObj.firstname,
	        username: userObj.username,
	        password: userObj.password,
	        email: userObj.email,
	        country: userObj.country,
	        locale: userObj.locale
	      }
	    }).then(function (data) {
	      var rtrnData = null;
	
	      if (utils.isNotNull(data) && data.result === "success" && data.data) {
	        rtrnData = data.data;
	      }
	
	      return rtrnData;
	    });
	  };
	
	  UserServices.editProfile = function (userKey, userObj) {
	    return request.put({
	      url: utils.getServiceUrl("/users/" + userKey + "/edit-profile"),
	      cache: false,
	      dataType: request.DATA_TYPES.JSON,
	      contentType: request.CONTENT_TYPES.APPLICATION_FORM_URLENCODED,
	      data: {
	        firstname: userObj.firstName,
	        "current-password": userObj.currentPassword,
	        "new-password": userObj.newPassword
	      }
	    }).then(function (data) {
	      var rtrnData = null;
	
	      if (utils.isNotNull(data) && data.result === "success" && data.data) {
	        rtrnData = data.data;
	      }
	
	      return rtrnData;
	    });
	  };
	
	  UserServices.updateLocale = function (userKey, locale) {
	    return request.put({
	      url: utils.getServiceUrl("/users/" + userKey + "/update-locale"),
	      cache: false,
	      dataType: request.DATA_TYPES.JSON,
	      contentType: request.CONTENT_TYPES.APPLICATION_FORM_URLENCODED,
	      data: {
	        locale: locale
	      }
	    }).then(function (data) {
	      var rtrnData = null;
	
	      if (utils.isNotNull(data) && data.result === "success" && data.data) {
	        rtrnData = data.data;
	      }
	
	      return rtrnData;
	    });
	  };
	})(UserServices);
	
	module.exports = UserServices;

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 16/03/2017.
	 */
	var utils = __webpack_require__(4);
	
	var knownErrors = ["401", // unauthorized
	
	"E91489", "E73550"];
	
	module.exports = function () {
	  function AppError(options) {
	    _classCallCheck(this, AppError);
	
	    options = utils.isNotNull(options) ? options : {};
	
	    this.code = options.appErrorCode || options.code;
	    this.message = options.message;
	
	    this.data = options.data;
	    this.exception = options.exception;
	  }
	
	  _createClass(AppError, [{
	    key: "readableErrorTitle",
	    get: function get() {
	      if ($.inArray(this.code, knownErrors) !== -1) {
	        return "errors.services." + this.code + ".title";
	      }
	
	      return "errors.services.general.title";
	    }
	  }, {
	    key: "readableErrorMessage",
	    get: function get() {
	      if ($.inArray(this.code, knownErrors) !== -1) {
	        return "errors.services." + this.code + ".message";
	      }
	
	      return "errors.services.general.message";
	    }
	  }]);
	
	  return AppError;
	}();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Created by jv on 13/01/2017.
	 */
	var utils = __webpack_require__(4);
	var log = __webpack_require__(7)();
	
	var storageController = {};
	
	(function (StorageController) {
	  StorageController.keys = {
	    LOGGED_IN_USER: "logged_in_user",
	    ORDER: "order",
	    ACTIVE_CARD_GAME: "active_card_game",
	    ROUND_TIMERS: "round_timers"
	  };
	
	  function shouldEncode(key) {
	    // Basically obfuscates the data from these keys
	    // return $.inArray(key, [ StorageController.keys.LOGGED_IN_USER, StorageController.keys.ORDER, StorageController.keys.ROUND_TIMERS ]) !== -1;
	    return [StorageController.keys.LOGGED_IN_USER, StorageController.keys.ORDER, StorageController.keys.ROUND_TIMERS].includes(key);
	  }
	
	  StorageController.clearAll = function () {
	    StorageController.clearSession();
	    StorageController.clearLocal();
	  };
	
	  StorageController.clearSession = function () {
	    sessionStorage.clear();
	  };
	
	  StorageController.clearLocal = function () {
	    localStorage.clear();
	  };
	
	  StorageController.removeFromSession = function (key) {
	    StorageController.saveToSession(key);
	  };
	
	  StorageController.saveToSession = function (key, obj) {
	    if (storageKeyIsValid(key)) {
	      // if obj is null then remove
	      if (utils.isUndefined(obj)) {
	        sessionStorage.removeItem(key);
	      } else {
	        if (utils.isObject(obj)) {
	          if (utils.isFunction(obj.getSerializable)) {
	            obj = obj.getSerializable();
	          }
	
	          obj = utils.stringifyJSON(obj);
	        }
	
	        if (shouldEncode(key)) {
	          obj = utils.btoa(obj);
	        }
	
	        sessionStorage.setItem(key, obj);
	      }
	    } else {
	      console.error("Invalid storage key [%s]", key);
	    }
	  };
	
	  StorageController.getFromSession = function (key, json) {
	    if (storageKeyIsValid(key)) {
	      var tmpValue = sessionStorage.getItem(key);
	
	      if (shouldEncode(key)) {
	        try {
	          tmpValue = utils.atob(tmpValue);
	        } catch (e) {
	          log.error("Failed to decode value '%s'", tmpValue);
	        }
	      }
	
	      if (json) {
	        return utils.parseJSON(tmpValue, true);
	      }
	
	      return tmpValue;
	    } else {
	      console.error("Invalid storage key [%s]", key);
	    }
	
	    return null;
	  };
	
	  StorageController.removeFromLocal = function (key) {
	    StorageController.saveToLocal(key);
	  };
	
	  StorageController.saveToLocal = function (key, obj) {
	    if (storageKeyIsValid(key)) {
	      if (utils.isUndefined(obj)) {
	        localStorage.removeItem(key);
	      } else {
	        if (utils.isObject(obj)) {
	          if (utils.isFunction(obj.getSerializable)) {
	            obj = obj.getSerializable();
	          }
	
	          obj = utils.stringifyJSON(obj);
	        }
	
	        if (shouldEncode(key)) {
	          obj = utils.btoa(obj);
	        }
	
	        localStorage.setItem(key, obj);
	      }
	    } else {
	      console.error("Invalid storage key [%s]", key);
	    }
	  };
	
	  StorageController.getFromLocal = function (key, json) {
	    if (storageKeyIsValid(key)) {
	      var tmpValue = localStorage.getItem(key);
	
	      if (shouldEncode(key)) {
	        try {
	          tmpValue = utils.atob(tmpValue);
	        } catch (e) {
	          log.error("Failed to decode value '%s'", tmpValue);
	        }
	      }
	
	      if (json) {
	        return utils.parseJSON(tmpValue, true);
	      }
	
	      return tmpValue;
	    } else {
	      console.error("Invalid storage key [%s]", key);
	    }
	
	    return null;
	  };
	
	  function storageKeyIsValid(key) {
	    for (var objKey in StorageController.keys) {
	      if (StorageController.keys.hasOwnProperty(objKey) && StorageController.keys[objKey] === key) {
	        return true;
	      }
	    }
	
	    return false;
	  }
	})(storageController);
	
	module.exports = storageController;

/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Created by jv on 2019-09-19 (12:14).
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	var _utils = __webpack_require__(4);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _constants = __webpack_require__(331);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GameSessionMessage = function () {
	  function GameSessionMessage(options) {
	    _classCallCheck(this, GameSessionMessage);
	
	    this.id = options.id || _utils2.default.UUID();
	
	    this.type = options.type || "request";
	    this.service = options.service;
	    this.error = options.error;
	
	    this.data = options.data;
	
	    this.params = options.params;
	  }
	
	  _createClass(GameSessionMessage, [{
	    key: "serialize",
	    value: function serialize() {
	      var data = {
	        id: this.id,
	
	        type: this.type,
	        service: this.service,
	        error: this.error,
	
	        data: this.data,
	
	        params: this.params,
	
	        sent: _moment2.default.utc().format(_constants2.default.API_DATE_FORMAT)
	      };
	
	      return _utils2.default.stringifyJSON(data);
	    }
	  }], [{
	    key: "createRequest",
	    value: function createRequest(serviceName, params, data) {
	      return new GameSessionMessage({
	        service: serviceName,
	        params: params,
	        data: data
	      });
	    }
	  }, {
	    key: "createResponse",
	    value: function createResponse(serviceName, params, data) {
	      return new GameSessionMessage({
	        type: "response",
	        service: serviceName,
	        params: params,
	        data: data
	      });
	    }
	  }, {
	    key: "createErrorMessage",
	    value: function createErrorMessage(errorCode, params, data) {
	      return new GameSessionMessage({
	        type: "error",
	        error: errorCode,
	        params: params,
	        data: data
	      });
	    }
	  }]);
	
	  return GameSessionMessage;
	}();
	
	exports.default = GameSessionMessage;

/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _utils = __webpack_require__(4);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _appError = __webpack_require__(234);
	
	var _appError2 = _interopRequireDefault(_appError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by jv on 16/01/2017.
	 */
	var log = __webpack_require__(7)();
	
	
	var request = {};
	
	(function (Request) {
	  Request.CONTENT_TYPES = {
	    APPLICATION_FORM_URLENCODED: "application/x-www-form-urlencoded",
	    TEXT_PLAIN: "text/plain",
	    APPLICATION_JSON: "application/json"
	  };
	
	  Request.DATA_TYPES = {
	    TEXT: "text",
	    JSON: "json",
	    XML: "xml"
	  };
	
	  Request.get = function (options) {
	    options.type = "GET";
	    return doRequest(options);
	  };
	
	  Request.post = function (options) {
	    options.type = "POST";
	    return doRequest(options);
	  };
	
	  Request.put = function (options) {
	    options.type = "PUT";
	    return doRequest(options);
	  };
	
	  Request.delete = function (options) {
	    options.type = "DELETE";
	    return doRequest(options);
	  };
	
	  function doRequest(options) {
	    var startTime = Date.now();
	    logRequestInfo(startTime, options);
	
	    // Download / Upload progress
	    if (_utils2.default.isFunction(options.onProgress) || _utils2.default.isFunction(options.onUploadProgress)) {
	      options.xhr = function () {
	        var xhr = new window.XMLHttpRequest();
	
	        if (_utils2.default.isFunction(options.onUploadProgress)) {
	          xhr.upload.addEventListener("progress", function (evt) {
	            if (evt.lengthComputable) {
	              var percentComplete = evt.loaded / evt.total;
	              options.onUploadProgress(percentComplete);
	            }
	          }, false);
	        }
	
	        if (_utils2.default.isFunction(options.onProgress)) {
	          xhr.addEventListener("progress", function (evt) {
	            if (evt.lengthComputable) {
	              var percentComplete = evt.loaded / evt.total;
	              options.onProgress(percentComplete);
	            }
	          }, false);
	        }
	
	        return xhr;
	      };
	    }
	
	    if (options.type !== "GET" && options.contentType === Request.CONTENT_TYPES.APPLICATION_JSON && (_utils2.default.isObject(options.data) || _utils2.default.isArray(options.data))) {
	      options.data = _utils2.default.stringifyJSON(options.data);
	    }
	
	    return new Promise(function (resolve, reject) {
	      // Request (order matters! in this case: always -> done / fail)
	      $.ajax(options).always(function (data, textStatus) {
	        logRequestComplete(startTime, options, textStatus, data);
	      }).done(function (data) {
	        if (_utils2.default.isNotNull(data) && data.hasOwnProperty("responseJSON") && data.responseJSON.result === "error") {
	          dataToError(data, reject);
	          return;
	        }
	
	        resolve(data);
	      }).fail(function (data) {
	        dataToError(data, reject);
	      });
	    });
	  }
	
	  function logRequestInfo(startTime, requestOptions) {
	    var startColor = "#5076ff";
	    var headerCss = _utils2.default.format("background-color: #222;color: {0};border-top: 1px solid {1};", startColor, startColor);
	    var footerCss = _utils2.default.format("border-bottom: 1px solid {0}", startColor);
	    log.info("%cRequest started%c\nUrl: %s\nMethod: %s\nContent-type: %s\nDataType: %s\n%cData: %o%c", headerCss, "", requestOptions.url, requestOptions.type, requestOptions.contentType, requestOptions.dataType, footerCss, requestOptions.data, "");
	  }
	
	  function logRequestComplete(startTime, requestOptions, textStatus, result) {
	    if (false) {
	      var executeTime = Date.now() - startTime;
	      executeTime = executeTime / 1000 + "s";
	
	      var completeColor = "#bada55";
	      var headerCss = _utils2.default.format("background-color: #222;color: {0};border-top: 1px solid {1};", completeColor, completeColor);
	      var footerCss = _utils2.default.format("border-bottom: 1px solid {0}", completeColor);
	
	      log.info("%cRequest complete%c\nUrl: %s\nMethod: %s\nStatus: %s\nExecute time: %s\n%cResult: %o%c",
	      /*empty string to reset css*/
	      headerCss, "", requestOptions.url, requestOptions.type, textStatus, executeTime, footerCss, result, "");
	    }
	  }
	
	  function dataToError(data, callback) {
	    if (_utils2.default.isFunction(callback)) {
	      if (_utils2.default.isNotNull(data) && data.hasOwnProperty("responseJSON") && _utils2.default.isNotNull(data.responseJSON) && data.responseJSON.result === "error") {
	        callback(new _appError2.default({
	          code: data.responseJSON.data.appErrorCode,
	          message: data.responseJSON.data.message,
	          data: data
	        }));
	      } else if (data.status === 401) {
	        callback(new _appError2.default({
	          code: "401",
	          message: _utils2.default.isNotNull(data.responseJSON) ? data.responseJSON.data : data.responseText,
	          data: data
	        }));
	      } else {
	        callback(new _appError2.default({
	          code: null,
	          message: null,
	          data: data
	        }));
	      }
	    }
	  }
	})(request);
	
	module.exports = request;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Created by jv on 2019-08-21 (11:47).
	 */
	var businessModelImages = __webpack_require__(323);
	
	var animationDuration = 2000;
	
	var infoSettings = {
	  radius: 19,
	  innerStrokeColor: "#000000",
	  innerStrokeRadius: 29,
	  innerStrokeWidth: 4,
	
	  text: {
	    fontFamily: "SpaceGrotesk", // %TODO: wss ander font ???
	    fontSize: 24,
	    alignment: "center",
	    color: "#000000"
	  },
	
	  markedColor: "#57B67D"
	};
	
	var testLayout = {
	  background: businessModelImages("./curved_background.svg"),
	  backgroundColor: "#f4f7f9",
	
	  size: {
	    width: 1168,
	    height: 730
	  },
	
	  infoSettings: infoSettings,
	
	  animationDuration: animationDuration
	};
	
	exports.default = testLayout;

/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(4);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _client = __webpack_require__(513);
	
	var _client2 = _interopRequireDefault(_client);
	
	var _gameSessionMessage = __webpack_require__(247);
	
	var _gameSessionMessage2 = _interopRequireDefault(_gameSessionMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 2019-09-11 (10:14).
	 */
	var log = __webpack_require__(7)();
	
	var GameSessionController = function () {
	  function GameSessionController(options) {
	    _classCallCheck(this, GameSessionController);
	
	    this.baseUrl = options.baseUrl;
	    if (_utils2.default.isNotNull(this.baseUrl) && this.baseUrl.endsWith("/")) this.baseUrl = this.baseUrl.substring(0, this.baseUrl.length - 1);
	
	    this.sessionId = options.sessionId;
	    this.asTeacher = options.asTeacher === true;
	    this.teamName = options.teamName;
	
	    this.onOpenListeners = [];
	    this.onCloseListeners = [];
	    this.onErrorListeners = [];
	    this.onMessageListeners = [];
	  }
	
	  _createClass(GameSessionController, [{
	    key: "init",
	    value: function init() {
	      var _this = this;
	
	      if (this.asTeacher) {
	        this.url = this.baseUrl + "/" + this.sessionId + "?as-teacher=true";
	      } else {
	        this.url = this.baseUrl + "/" + this.sessionId + "?team-name=" + encodeURIComponent(this.teamName);
	      }
	
	      this.client = new _client2.default({
	        url: this.url,
	        onOpen: function onOpen(event) {
	          return _this._onSessionOpened(event);
	        },
	        onClose: function onClose(event) {
	          return _this._onSessionClosed(event);
	        },
	        onError: function onError(event) {
	          return _this._onSessionError(event);
	        },
	        onMessage: function onMessage(event) {
	          return _this._onSessionMessage(event);
	        }
	      });
	    }
	  }, {
	    key: "_onSessionOpened",
	    value: function _onSessionOpened(event) {
	      log.cssLog("Successfully established socket connection - %o", event, log.successCss);
	
	      for (var i = 0; i < this.onOpenListeners.length; i++) {
	        this.onOpenListeners[i].call(this, event);
	      }
	    }
	  }, {
	    key: "_onSessionClosed",
	    value: function _onSessionClosed(event) {
	      log.cssLog("Socket connection was closed - %o", event, log.warningCss);
	
	      for (var i = 0; i < this.onCloseListeners.length; i++) {
	        this.onCloseListeners[i].call(this, event);
	      }
	    }
	  }, {
	    key: "_onSessionError",
	    value: function _onSessionError(event) {
	      log.cssLog("An error occurred on the socket connection - %o", event, log.errorCss);
	
	      for (var i = 0; i < this.onErrorListeners.length; i++) {
	        this.onErrorListeners[i].call(this, event);
	      }
	    }
	  }, {
	    key: "_onSessionMessage",
	    value: function _onSessionMessage(event) {
	      for (var i = 0; i < this.onMessageListeners.length; i++) {
	        this.onMessageListeners[i].call(this, event);
	      }
	    }
	  }, {
	    key: "connect",
	    value: function connect() {
	      if (_utils2.default.isNotNull(this.client)) {
	        this.client.open();
	      }
	    }
	  }, {
	    key: "disconnect",
	    value: function disconnect() {
	      if (_utils2.default.isNotNull(this.client)) {
	        this.client.close();
	      }
	    }
	  }, {
	    key: "sendMessage",
	    value: function sendMessage(message) {
	      if (_utils2.default.isNotNull(this.client)) {
	        var gameSessionMessage = void 0;
	
	        if (message instanceof _gameSessionMessage2.default) {
	          gameSessionMessage = message;
	        } else {
	          gameSessionMessage = new _gameSessionMessage2.default({
	            data: message
	          });
	        }
	
	        var serializedData = gameSessionMessage.serialize();
	
	        log.info("Sending message to server: %o\nSerialized: %s", gameSessionMessage, serializedData);
	
	        this.client.sendData(serializedData);
	      }
	    }
	  }, {
	    key: "addEventListener",
	    value: function addEventListener(type, func) {
	      if (_utils2.default.isNull(type) || !_utils2.default.isFunction(func)) return;
	
	      switch (type) {
	        case "session-opened":
	          this.onOpenListeners.push(func);
	          break;
	        case "session-closed":
	          this.onCloseListeners.push(func);
	          break;
	        case "session-error":
	          this.onErrorListeners.push(func);
	          break;
	        case "session-message":
	          this.onMessageListeners.push(func);
	          break;
	      }
	    }
	  }]);
	
	  return GameSessionController;
	}();
	
	exports.default = GameSessionController;

/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _utils = __webpack_require__(4);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _request = __webpack_require__(248);
	
	var _request2 = _interopRequireDefault(_request);
	
	var _appError = __webpack_require__(234);
	
	var _appError2 = _interopRequireDefault(_appError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var log = __webpack_require__(7)();
	
	
	var GameSessionServices = {};
	
	(function (GameSessionServices) {
	    GameSessionServices.getGameSessions = function () {
	        return _request2.default.get({
	            url: _utils2.default.getServiceUrl("/game-sessions"),
	            cache: false,
	            dataType: _request2.default.DATA_TYPES.JSON
	        }).then(function (data) {
	            if (data.result === "success") {
	                return data.data;
	            } else {
	                throw new _appError2.default({
	                    code: null,
	                    message: null,
	                    data: data,
	                    exception: new Error("Unexpected result from request")
	                });
	            }
	        });
	    };
	
	    GameSessionServices.createGameSession = function (gameSession) {
	        return _request2.default.post({
	            url: _utils2.default.getServiceUrl("/game-sessions"),
	            cache: false,
	            dataType: _request2.default.DATA_TYPES.JSON,
	            contentType: _request2.default.CONTENT_TYPES.APPLICATION_JSON,
	            data: gameSession
	        });
	    };
	
	    GameSessionServices.removeGameSession = function (gameSessionId) {
	        return _request2.default.delete({
	            url: _utils2.default.getServiceUrl("/game-sessions/" + gameSessionId + "?for-sessionid=true"),
	            cache: false,
	            dataType: _request2.default.DATA_TYPES.JSON
	        });
	    };
	
	    GameSessionServices.duplicateGameSession = function (gameSessionId) {
	        return _request2.default.post({
	            url: _utils2.default.getServiceUrl("/game-sessions/" + gameSessionId + "/duplicate?for-sessionid=true"),
	            cache: false,
	            dataType: _request2.default.DATA_TYPES.JSON
	        });
	    };
	
	    GameSessionServices.removeTeamFromGameSession = function (teamName, gameSessionId) {
	        return _request2.default.post({
	            url: _utils2.default.getServiceUrl("/game-sessions/" + gameSessionId + "/remove-team?for-sessionid=true"),
	            cache: false,
	            data: {
	                "team-name": teamName
	            }
	        });
	    };
	
	    GameSessionServices.goToSession = function (gameSessionId) {
	        var newSession = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        _utils2.default.redirect("/teacher/sessions/" + gameSessionId + "/" + (newSession ? "session-created" : ""));
	    };
	
	    GameSessionServices.getSessionLocale = function (gameSessionId) {
	        return _request2.default.get({
	            url: _utils2.default.getServiceUrl("/game-sessions/" + gameSessionId + "/locale"),
	            cache: false
	        }).then(function (data) {
	            if (data.result === "success") {
	                return data.data;
	            } else {
	                return null;
	            }
	        });
	    };
	})(GameSessionServices);
	
	exports.default = GameSessionServices;

/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _utils = __webpack_require__(4);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _userServices = __webpack_require__(96);
	
	var _userServices2 = _interopRequireDefault(_userServices);
	
	var _storageController = __webpack_require__(246);
	
	var _storageController2 = _interopRequireDefault(_storageController);
	
	var _appError = __webpack_require__(234);
	
	var _appError2 = _interopRequireDefault(_appError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var log = __webpack_require__(7)();
	
	
	var LoginManager = {};
	
	(function (LoginManager) {
	  LoginManager.ERRORS = {
	    USERNAME_PASSWORD_INCORRECT: "username_password_incorrect",
	    INCOMPLETE_PROFILE: "incomplete_profile",
	    USER_NOT_VERIFIED: "user_not_verified",
	    NO_USER_DATA: "no_user_data",
	    UNEXPECTED: "unexpected"
	  };
	
	  LoginManager.usernameExists = function (username) {
	    return _userServices2.default.usernameExists(username);
	  };
	
	  LoginManager.logout = function () {
	    _userServices2.default.logout().finally(function () {
	      _storageController2.default.removeFromLocal(_storageController2.default.keys.LOGGED_IN_USER);
	    });
	  };
	
	  LoginManager.login = function (username, password) {
	    // LoginManager.logout(() =>
	    // {
	    //   _login(username, password, successCb, failCb);
	    // });
	
	    // We no longer logout since the server does that for us now
	    return _login(username, password);
	  };
	
	  function _login(username, password) {
	    $("html").addClass("waiting");
	
	    _storageController2.default.removeFromLocal(_storageController2.default.keys.LOGGED_IN_USER);
	
	    return _userServices2.default.authenticateUser(username, password)
	    // [catch] before [then] because [then] throws new errors which would otherwise be caught by this [catch]
	    .catch(function (data) {
	      // Fail
	      log.error("Failed to authenticate - %o", data);
	      $("html").removeClass("waiting");
	
	      throw new _appError2.default({
	        data: {
	          data: data,
	          errorType: LoginManager.ERRORS.UNEXPECTED
	        },
	        exception: new Error("Unexpected error occurred")
	      });
	    }).then(function (data) {
	      // Success
	      var xmlDoc = $($.parseXML(data));
	      var referrer = xmlDoc.find("access-control").attr("referer");
	      var xmlData = xmlDoc.find("access-control").find("data").text();
	
	      log.info("Login xml data: %s", xmlData);
	
	      $("html").removeClass("waiting");
	
	      if (isSuccess(xmlDoc)) {
	        var userData = _utils2.default.parseJSON(xmlData, true);
	
	        if (_utils2.default.isNullOrEmpty(userData)) {
	          log.error("User data is empty in login response");
	
	          throw new _appError2.default({
	            data: {
	              data: data,
	              errorType: LoginManager.ERRORS.NO_USER_DATA
	            },
	            exception: new Error("User data is empty in login response")
	          });
	        }
	
	        if (!userData.hasOwnProperty("authenticated") || userData.authenticated) {
	          // Success
	          return {
	            userData: userData,
	            referer: referrer
	          };
	        } else {
	          // login failed (wrong credentials)
	          throw new _appError2.default({
	            data: {
	              data: data,
	              errorType: LoginManager.ERRORS.USERNAME_PASSWORD_INCORRECT
	            },
	            exception: new Error("Tried to login with wrong credentials")
	          });
	        }
	      } else if (isError(xmlDoc)) {
	        var errorData = _utils2.default.parseJSON(xmlData, true);
	
	        if (_utils2.default.isNotNull(errorData)) {
	          if (errorData.incomplete) {
	            //incomplete profile
	            throw new _appError2.default({
	              data: {
	                data: data,
	                errorType: LoginManager.ERRORS.INCOMPLETE_PROFILE
	              },
	              exception: new Error("Tried to login while profile is incomplete")
	            });
	          } else if (_utils2.default.isNotNull(errorData.errorCode)) {
	            //incomplete profile
	            throw new _appError2.default({
	              code: errorData.errorCode,
	              data: {
	                data: data,
	                errorType: getErrorForCode(errorData.errorCode)
	              },
	              exception: new Error("Tried to login while profile is incomplete")
	            });
	          }
	        }
	
	        throw new _appError2.default({
	          data: {
	            data: data,
	            errorType: LoginManager.ERRORS.USERNAME_PASSWORD_INCORRECT
	          },
	          exception: new Error("Tried to login with wrong credentials")
	        });
	      } else {
	        // always fun to say: should not come here... :)
	        throw new _appError2.default({
	          data: {
	            data: data,
	            errorType: LoginManager.ERRORS.UNEXPECTED
	          },
	          exception: new Error("Unexpected error occurred")
	        });
	      }
	    });
	  }
	
	  function is(what, xml) {
	    return xml.find("access-control").attr("result") === what;
	  }
	
	  function isSuccess(xml) {
	    return is("success", xml);
	  }
	
	  function isError(xml) {
	    return is("error", xml);
	  }
	
	  function isNotLoggedIn(xml) {
	    return is("null", xml);
	  }
	
	  function getErrorForCode(code) {
	    if (code === "E45370") {
	      return LoginManager.ERRORS.UNEXPECTED;
	    } else if (code === "E55053") {
	      return LoginManager.ERRORS.USER_NOT_VERIFIED;
	    } else if (code === "E73550") {
	      return LoginManager.ERRORS.USERNAME_PASSWORD_INCORRECT;
	    }
	
	    return LoginManager.ERRORS.UNEXPECTED;
	  }
	})(LoginManager);
	
	module.exports = LoginManager;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(4);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by jv on 2019-11-14 (12:30).
	 */
	__webpack_require__(739);
	var selectize = __webpack_require__(530);
	
	var FormUtils = {};
	
	(function (FormUtils) {
	  FormUtils.setUpSelectize = function (selector, data, placeholder) {
	    var $el = $(selector);
	
	    if (_utils2.default.isNotNull($el) && $el.length) {
	      if (_utils2.default.isNotNull($el[0].selectize)) {
	        $el[0].selectize.destroy();
	      }
	
	      $el.empty();
	
	      if (!_utils2.default.isNullOrEmpty(placeholder)) {
	        // Empty option tag is needed as placeholder for selectize
	        $el.append("<option></option>");
	      }
	
	      for (var i = 0; i < data.length; i++) {
	        $el.append("<option value='" + data[i].value + "' " + (data[i].default ? "selected" : "") + ">" + data[i].text + "</option>");
	      }
	
	      var $select = $el.selectize({
	        placeholder: placeholder
	      });
	      return $select[0].selectize;
	    }
	
	    return undefined;
	  };
	})(FormUtils);
	
	exports.default = FormUtils;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Created by jv on 2019-08-20 (13:34).
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	var _utils = __webpack_require__(4);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _appError = __webpack_require__(234);
	
	var _appError2 = _interopRequireDefault(_appError);
	
	var _default = __webpack_require__(273);
	
	var _default2 = _interopRequireDefault(_default);
	
	var _investmentsView = __webpack_require__(95);
	
	var _investmentsView2 = _interopRequireDefault(_investmentsView);
	
	var _shared = __webpack_require__(12);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _infoWasteDepot = __webpack_require__(330);
	
	var _infoWasteDepot2 = _interopRequireDefault(_infoWasteDepot);
	
	var _infoMarket = __webpack_require__(328);
	
	var _infoMarket2 = _interopRequireDefault(_infoMarket);
	
	var _infoMining = __webpack_require__(329);
	
	var _infoMining2 = _interopRequireDefault(_infoMining);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var dashboardIcons = __webpack_require__(324);
	var resourceIcons = __webpack_require__(63);
	
	var log = __webpack_require__(7)();
	
	var fabric = __webpack_require__(795).fabric;
	
	var INACTIVE_OPACITY = 0.25;
	var UNDER_CONSTRUCTION_OPACITY = 0.5;
	
	var BusinessModel = function () {
	    function BusinessModel(options) {
	        _classCallCheck(this, BusinessModel);
	
	        if (_utils2.default.isNull(options)) throw new _appError2.default({ exception: new Error("Options for BusinessModel cannot be null") });
	
	        this.id = options.id || _utils2.default.generateElementId("business-model-canvas-");
	
	        this.containerElement = $(options.containerElement);
	        this.availableCanvasSize = options.availableCanvasSize;
	        this.onCanvasSizeChanged = options.onCanvasSizeChanged;
	        this.roundOverview = options.roundOverview;
	        this.team = options.team;
	        this.factories = options.factories;
	        this.view = options.view;
	
	        this.layoutData = _utils2.default.isNotNull(options.layoutData) ? options.layoutData : _default2.default;
	
	        this.sectorsGroup = null;
	        this.sectors = [];
	
	        this.infoIcons = [];
	        this.infoIconsVisible = _utils2.default.isNotNull(options.infoIconsVisible) ? options.infoIconsVisible : false;
	
	        this.employeeSpotGroup = null;
	        this.employeeSpots = [];
	
	        this.canvasRendered = false;
	        this.onRenderComplete = options.onRenderComplete;
	        this.onInfoScreenRequested = options.onInfoScreenRequested;
	        this.onAssignEmployee = options.onAssignEmployee;
	
	        this.debugGroup = null;
	
	        this.shouldAbortAnimations = false;
	
	        this.onInactiveSpotClick = options.onInactiveSpotClick;
	        this.onAssignMineEmployee = options.onAssignMineEmployee;
	        this.onAssignMicrochipEmployee = options.onAssignMicrochipEmployee;
	        this.onAssignSecondaryEmployee = options.onAssignSecondaryEmployee;
	        this.onAssignWasteRecycleEmployee = options.onAssignWasteRecycleEmployee;
	        this.onAssignReuseEmployee = options.onAssignReuseEmployee;
	        this.onAssignRentalEmployee = options.onAssignRentalEmployee;
	    }
	
	    _createClass(BusinessModel, [{
	        key: "render",
	        value: function render() {
	            log.info("Rendering business model for layout %o", this.layoutData);
	
	            this.createCanvas();
	
	            this.debugGroup = new fabric.Group([], {
	                hasBorders: false,
	                hasControls: false,
	                selectable: false,
	                evented: false,
	                reference: false,
	                movable: false
	            });
	
	            this.canvas.add(this.debugGroup);
	
	            this.sectorsGroup = new fabric.Group([], {
	                hasBorders: false,
	                hasControls: false,
	                selectable: false,
	                evented: false,
	                reference: false,
	                movable: false,
	
	                objectCaching: false
	            });
	
	            this.employeeSpotGroup = new fabric.Group([], {
	                hasBorders: false,
	                hasControls: false,
	                selectable: false,
	                reference: false,
	                movable: false,
	
	                objectCaching: false,
	                hoverCursor: "pointer"
	            });
	
	            this.canvas.add(this.sectorsGroup);
	            this.canvas.add(this.employeeSpotGroup);
	
	            this.renderAll();
	        }
	    }, {
	        key: "renderAll",
	        value: function () {
	            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                this.setUpAutoResize();
	
	                                _context.next = 3;
	                                return Promise.all([this.setUpMine(), this.setUpMicrochipFactory(), this.setUpSecondaryFactory(), this.setUpMarket(), this.setUpWasteDepot(), this.setUpWasteRecycling(), this.setUpReuseFacility(), this.setUpRental()]);
	
	                            case 3:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function renderAll() {
	                return _ref.apply(this, arguments);
	            }
	
	            return renderAll;
	        }()
	    }, {
	        key: "_checkRenderComplete",
	        value: function _checkRenderComplete() {
	            if (this.hasRendered()) {
	                // this.sectorsGroup.addWithUpdate();
	                // this.sectorsGroup.setCoords();
	                // this.sectorsGroup.bringToFront();
	
	                this.debugGroup.bringToFront();
	
	                this.canvas.renderAll();
	
	                if (_utils2.default.isFunction(this.onRenderComplete)) {
	                    this.onRenderComplete.call(this);
	                }
	            }
	        }
	    }, {
	        key: "hasRendered",
	        value: function hasRendered() {
	            var renderCompleted = this.canvasRendered;
	
	            var sectorsRendered = true;
	
	            for (var i = 0; i < this.sectors.length; i++) {
	                sectorsRendered = sectorsRendered && this.sectors[i].hasRendered;
	                if (!sectorsRendered) break;
	            }
	
	            renderCompleted = renderCompleted && sectorsRendered;
	
	            return renderCompleted;
	        }
	    }, {
	        key: "createCanvas",
	        value: function createCanvas() {
	            var _this = this;
	
	            log.info("Creating canvas for business model [%s]", this.id);
	
	            if (_utils2.default.isNotNull(this.canvasEl)) {
	                this.containerElement[0].removeChild(this.canvasEl.parentNode);
	                this.canvas = null;
	                this.canvasEl = null;
	            }
	
	            this.canvasEl = document.createElement("canvas");
	            this.canvasEl.id = this.id;
	
	            this.containerElement.append(this.canvasEl);
	
	            this.canvas = new fabric.Canvas(this.id, {
	                backgroundColor: this.layoutData.backgroundColor || "white",
	
	                width: this.layoutData.size.width,
	                height: this.layoutData.size.height,
	
	                imageSmoothingEnabled: false
	            });
	
	            this.canvas.selection = false;
	
	            if (!_utils2.default.isNullOrEmpty(this.layoutData.background)) {
	                this.setUpBackground().then(function () {
	                    _this.canvasRendered = true;
	                    _this._checkRenderComplete();
	                });
	            } else {
	                this.canvasRendered = true;
	            }
	
	            if (false) {
	                // this.addGridToCanvas(50);
	            }
	        }
	    }, {
	        key: "setUpBackground",
	        value: function setUpBackground() {
	            var _this2 = this;
	
	            if (!_utils2.default.isNullOrEmpty(this.layoutData.background)) {
	                var options = {
	                    top: -491,
	                    left: -341,
	
	                    evented: false,
	                    selectable: false,
	                    hasBorders: false,
	                    hasControls: false,
	                    reference: false
	                };
	
	                if (this.layoutData.background.endsWith("svg")) {
	                    return this.loadSvg(this.layoutData.background, options).then(function (fabricObj) {
	                        _this2.canvas.add(fabricObj);
	                        _this2.canvas.sendToBack(fabricObj);
	
	                        // fabricObj.scaleToWidth(this.canvas.width);
	                        fabricObj.setCoords();
	                        _this2.canvas.renderAll();
	
	                        return fabricObj;
	                    }).catch(function (err) {
	                        log.error("Failed to load background image - %o", err);
	                    });
	                } else {
	                    return this.loadImage(this.layoutData.background, options).then(function (fabricObj) {
	                        _this2.canvas.add(fabricObj);
	                        _this2.canvas.sendToBack(fabricObj);
	
	                        // fabricObj.scaleToWidth(this.canvas.width);
	                        fabricObj.setCoords();
	                        _this2.canvas.renderAll();
	
	                        return fabricObj;
	                    }).catch(function (err) {
	                        log.error("Failed to load background image - %o", err);
	                    });
	                }
	            }
	
	            return null;
	        }
	    }, {
	        key: "setUpMine",
	        value: function () {
	            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	                var _this3 = this;
	
	                var factoryName, mine, groupArray, result, groupArr, groupText, groupIcon, groupIcon2, group, groupBounds, background, totalGroup;
	                return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                factoryName = "mine";
	                                _context2.next = 3;
	                                return this.loadSvg(dashboardIcons("./mine.svg"), {
	                                    left: 24,
	                                    top: 528
	                                });
	
	                            case 3:
	                                mine = _context2.sent;
	                                _context2.next = 6;
	                                return this.createEmployeeSpot({
	                                    left: 274,
	                                    top: 683,
	                                    taken: this.getEmployeeCountForFactory(factoryName) >= 1,
	                                    enabled: true,
	                                    onAssignEmployee: function onAssignEmployee() {
	                                        _this3.onAssignMineEmployee.call(_this3);
	                                    },
	                                    namedGroup: "mine-1"
	                                });
	
	                            case 6:
	                                _context2.next = 8;
	                                return this.createEmployeeSpot({
	                                    left: 311,
	                                    top: 698,
	                                    taken: this.getEmployeeCountForFactory(factoryName) >= 2,
	                                    enabled: true,
	                                    onAssignEmployee: function onAssignEmployee() {
	                                        _this3.onAssignMineEmployee.call(_this3);
	                                    },
	                                    namedGroup: "mine-2"
	                                });
	
	                            case 8:
	                                groupArray = [mine];
	                                result = new fabric.Group(groupArray, {
	                                    objectCaching: false
	                                });
	
	                                // Set up production info
	
	                                groupArr = [];
	                                groupText = new fabric.Text(this.team.currentRound < 8 ? "+2" : "+1", {
	                                    originX: "center",
	                                    originY: "center",
	                                    left: 309,
	                                    top: 510,
	                                    fontFamily: "SpaceGrotesk-Bold",
	                                    fontSize: 20,
	                                    fill: "#ffffff"
	                                });
	
	                                groupArr.push(groupText);
	
	                                _context2.next = 15;
	                                return this.loadSvg(resourceIcons("./resource_white.svg"), {
	                                    left: 264,
	                                    top: 510,
	                                    originY: "center"
	                                });
	
	                            case 15:
	                                groupIcon = _context2.sent;
	
	                                groupIcon.scaleToWidth(28);
	                                groupIcon.scaleToHeight(27);
	                                groupArr.push(groupIcon);
	
	                                if (!(this.team.currentRound < 8)) {
	                                    _context2.next = 26;
	                                    break;
	                                }
	
	                                _context2.next = 22;
	                                return this.loadSvg(resourceIcons("./resource_white.svg"), {
	                                    left: 234,
	                                    top: 510,
	                                    originY: "center"
	                                });
	
	                            case 22:
	                                groupIcon2 = _context2.sent;
	
	                                groupIcon2.scaleToWidth(28);
	                                groupIcon2.scaleToHeight(27);
	                                groupArr.push(groupIcon2);
	
	                            case 26:
	                                group = new fabric.Group(groupArr, {});
	                                groupBounds = group.getBoundingRect();
	                                background = new fabric.Rect({
	                                    top: groupBounds.top - 7,
	                                    left: groupBounds.left - 14,
	                                    width: groupBounds.width + 28,
	                                    height: groupBounds.height + 14,
	                                    rx: 4,
	                                    ry: 4,
	                                    fill: "#f47a1b"
	                                });
	                                totalGroup = new fabric.Group([background, group], {});
	
	
	                                this.sectorsGroup.addWithUpdate(totalGroup);
	
	
	                                this.sectorsGroup.addWithUpdate(result);
	
	                                this.createInfoIcon({
	                                    left: 27,
	                                    top: 489,
	                                    backgroundColor: "#ffbe91",
	                                    onClick: function onClick() {
	                                        var container = $("<div>");
	
	                                        new _infoMining2.default({ container: container, mode: "info" }).render();
	
	                                        _shared2.default.Dialog.showMessageDialog({
	                                            title: "info.title",
	                                            message: container,
	                                            disposable: false,
	                                            extraModalContentClass: "info-mining-background-container"
	                                        });
	                                    }
	                                });
	
	                            case 33:
	                            case "end":
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function setUpMine() {
	                return _ref2.apply(this, arguments);
	            }
	
	            return setUpMine;
	        }()
	    }, {
	        key: "setUpMicrochipFactory",
	        value: function () {
	            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
	                var _this4 = this;
	
	                var groupArray, factoryName, factory, icon, upgrade, hasEfficiencyInvestment, hasSubstitutionInvestment, upgradeIcon, _upgradeIcon, redResource, yellowResource, purpleResource, result, groupText, groupIcon, group, groupBounds, background, totalGroup;
	
	                return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                    while (1) {
	                        switch (_context3.prev = _context3.next) {
	                            case 0:
	                                groupArray = [];
	                                factoryName = "microchip_factory";
	                                _context3.next = 4;
	                                return this.loadSvg(dashboardIcons("./factory.svg"), {
	                                    originX: "center",
	                                    originY: "center",
	                                    left: 430 + 134 / 2,
	                                    top: 324 + 143 / 2
	                                });
	
	                            case 4:
	                                factory = _context3.sent;
	                                _context3.next = 7;
	                                return this.loadSvg(resourceIcons("./microchip.svg"), {
	                                    originX: "center",
	                                    originY: "center",
	                                    left: 430 + 24 + 22,
	                                    top: 324 + 81 + 22
	                                });
	
	                            case 7:
	                                icon = _context3.sent;
	                                _context3.next = 10;
	                                return this.loadSvg(dashboardIcons("./factory_upgrade.svg"), {
	                                    originX: "left",
	                                    originY: "center",
	                                    left: 430 + 131,
	                                    top: 324 + 82
	                                });
	
	                            case 10:
	                                upgrade = _context3.sent;
	                                hasEfficiencyInvestment = _investmentsView2.default.hasPurchasedInvestment(this.team, { title: "microchip_efficiency" });
	                                hasSubstitutionInvestment = _investmentsView2.default.hasPurchasedInvestment(this.team, { title: "microchip_substitution" });
	
	                                upgrade.set({ opacity: hasEfficiencyInvestment || hasSubstitutionInvestment ? 1 : INACTIVE_OPACITY });
	
	                                groupArray.push(factory);
	                                groupArray.push(icon);
	                                groupArray.push(upgrade);
	
	                                if (!hasEfficiencyInvestment) {
	                                    _context3.next = 24;
	                                    break;
	                                }
	
	                                _context3.next = 20;
	                                return this.loadSvg(dashboardIcons("./resource_white with minus sign.svg"), {
	                                    originX: "center",
	                                    originY: "center",
	                                    left: 612,
	                                    top: 412
	                                });
	
	                            case 20:
	                                upgradeIcon = _context3.sent;
	
	                                groupArray.push(upgradeIcon);
	                                _context3.next = 29;
	                                break;
	
	                            case 24:
	                                if (!hasSubstitutionInvestment) {
	                                    _context3.next = 29;
	                                    break;
	                                }
	
	                                _context3.next = 27;
	                                return this.loadSvg(dashboardIcons("./resource_substitution.svg"), {
	                                    originX: "center",
	                                    originY: "center",
	                                    left: 612,
	                                    top: 412
	                                });
	
	                            case 27:
	                                _upgradeIcon = _context3.sent;
	
	                                groupArray.push(_upgradeIcon);
	
	                            case 29:
	                                _context3.next = 31;
	                                return this.loadSvg(resourceIcons("./resource_red.svg"), {
	                                    left: 574,
	                                    top: 435
	                                });
	
	                            case 31:
	                                redResource = _context3.sent;
	
	                                redResource.scaleToWidth(35);
	                                redResource.scaleToHeight(33);
	
	                                _context3.next = 36;
	                                return this.loadSvg(resourceIcons("./resource_yellow.svg"), {
	                                    left: 612,
	                                    top: 435
	                                });
	
	                            case 36:
	                                yellowResource = _context3.sent;
	
	                                yellowResource.scaleToWidth(35);
	                                yellowResource.scaleToHeight(33);
	
	                                _context3.next = 41;
	                                return this.loadSvg(resourceIcons("./resource_purple.svg"), {
	                                    left: 649,
	                                    top: 435
	                                });
	
	                            case 41:
	                                purpleResource = _context3.sent;
	
	                                purpleResource.scaleToWidth(35);
	                                purpleResource.scaleToHeight(33);
	
	                                _context3.next = 46;
	                                return this.createEmployeeSpot({
	                                    left: 472,
	                                    top: 484,
	                                    taken: this.getEmployeeCountForFactory(factoryName) >= 1,
	                                    enabled: this.canEmployMicrochipFactory(),
	                                    onAssignEmployee: function onAssignEmployee() {
	                                        _this4.onAssignMicrochipEmployee.call(_this4);
	                                    },
	                                    namedGroup: "microchip-1"
	                                });
	
	                            case 46:
	                                _context3.next = 48;
	                                return this.createEmployeeSpot({
	                                    left: 439,
	                                    top: 499,
	                                    taken: this.getEmployeeCountForFactory(factoryName) >= 2,
	                                    enabled: this.canEmployMicrochipFactory(),
	                                    onAssignEmployee: function onAssignEmployee() {
	                                        _this4.onAssignMicrochipEmployee.call(_this4);
	                                    }
	                                });
	
	                            case 48:
	                                groupArray.push(yellowResource);
	                                groupArray.push(redResource);
	                                groupArray.push(purpleResource);
	
	                                result = new fabric.Group(groupArray, {
	                                    objectCaching: false
	                                });
	
	                                // Set up production info
	
	                                groupText = new fabric.Text("+1", {
	                                    originX: "center",
	                                    originY: "center",
	                                    left: 718 + 37 * 0.5,
	                                    top: 311 + 44 * 0.5,
	                                    fontFamily: "SpaceGrotesk-Bold",
	                                    fontSize: 20,
	                                    fill: "#ffffff"
	                                });
	                                _context3.next = 55;
	                                return this.loadSvg(resourceIcons("./microchip.svg"), {
	                                    left: 688,
	                                    top: 317
	                                });
	
	                            case 55:
	                                groupIcon = _context3.sent;
	
	                                groupIcon.scaleToWidth(30);
	                                groupIcon.scaleToHeight(30);
	
	                                group = new fabric.Group([groupText, groupIcon], {});
	                                groupBounds = group.getBoundingRect();
	                                background = new fabric.Rect({
	                                    top: groupBounds.top - 7,
	                                    left: groupBounds.left - 14,
	                                    width: groupBounds.width + 28,
	                                    height: groupBounds.height + 14,
	                                    rx: 4,
	                                    ry: 4,
	                                    fill: "#5FB6CD"
	                                });
	                                totalGroup = new fabric.Group([background, group], {});
	
	
	                                this.sectorsGroup.addWithUpdate(totalGroup);
	
	
	                                this.sectorsGroup.addWithUpdate(result);
	
	                                this.createInfoIcon({
	                                    left: 376,
	                                    top: 308,
	                                    backgroundColor: "#C8E3EF",
	                                    onClick: function onClick() {
	                                        var investment = _investmentsView2.default.getPurchasedInvestment(_this4.team, { title: "microchip_factory" });
	
	                                        _this4.view.showInvestmentDialog(investment, true);
	                                    }
	                                });
	
	                            case 65:
	                            case "end":
	                                return _context3.stop();
	                        }
	                    }
	                }, _callee3, this);
	            }));
	
	            function setUpMicrochipFactory() {
	                return _ref3.apply(this, arguments);
	            }
	
	            return setUpMicrochipFactory;
	        }()
	    }, {
	        key: "setUpSecondaryFactory",
	        value: function () {
	            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
	                var _this5 = this;
	
	                var factoryName, hasPhoneInvestment, hasBikeInvestment, factory, iconName, icon, upgrade, groupArray, hasEfficiencyInvestment, hasSubstitutionInvestment, upgradeIcon, _upgradeIcon2, microchipResource, plusText, yellowResource, _hasEfficiencyInvestment, _hasSubstitutionInvestment, _upgradeIcon3, _upgradeIcon4, _microchipResource, _plusText, redResource, purpleResource, result, groupText, groupIconResourceIcon, groupIcon, group, groupBounds, background, totalGroup, _factory, _groupArray, _result, hasUpgradeInvestment;
	
	                return regeneratorRuntime.wrap(function _callee4$(_context4) {
	                    while (1) {
	                        switch (_context4.prev = _context4.next) {
	                            case 0:
	                                factoryName = "secondary_factory";
	                                hasPhoneInvestment = _investmentsView2.default.hasPurchasedInvestment(this.team, { title: "phone_factory" });
	                                hasBikeInvestment = _investmentsView2.default.hasPurchasedInvestment(this.team, { title: "bike_factory" });
	
	                                if (!(hasPhoneInvestment || hasBikeInvestment)) {
	                                    _context4.next = 104;
	                                    break;
	                                }
	
	                                _context4.next = 6;
	                                return this.loadSvg(dashboardIcons("./factory.svg"), {
	                                    left: 430,
	                                    top: 524
	                                });
	
	                            case 6:
	                                factory = _context4.sent;
	                                iconName = hasPhoneInvestment ? "./mobile phone.svg" : "./bike.svg";
	                                _context4.next = 10;
	                                return this.loadSvg(resourceIcons(iconName), {
	                                    originX: "center",
	                                    originY: "center",
	                                    left: 472,
	                                    top: 626
	                                });
	
	                            case 10:
	                                icon = _context4.sent;
	                                _context4.next = 13;
	                                return this.loadSvg(dashboardIcons("./factory_upgrade.svg"), {
	                                    left: 561,
	                                    top: 559
	                                });
	
	                            case 13:
	                                upgrade = _context4.sent;
	                                _context4.next = 16;
	                                return this.createEmployeeSpot({
	                                    left: 472,
	                                    top: 682,
	                                    taken: this.getEmployeeCountForFactory(factoryName) >= 1,
	                                    enabled: this.canEmploySecondaryFactory(),
	                                    onAssignEmployee: function onAssignEmployee() {
	                                        _this5.onAssignSecondaryEmployee.call(_this5);
	                                    }
	                                });
	
	                            case 16:
	                                _context4.next = 18;
	                                return this.createEmployeeSpot({
	                                    left: 439,
	                                    top: 698,
	                                    taken: this.getEmployeeCountForFactory(factoryName) >= 2,
	                                    enabled: this.canEmploySecondaryFactory(),
	                                    onAssignEmployee: function onAssignEmployee() {
	                                        _this5.onAssignSecondaryEmployee.call(_this5);
	                                    }
	                                });
	
	                            case 18:
	                                groupArray = [factory, icon, upgrade];
	
	                                if (!hasPhoneInvestment) {
	                                    _context4.next = 52;
	                                    break;
	                                }
	
	                                hasEfficiencyInvestment = _investmentsView2.default.hasPurchasedInvestment(this.team, { title: "phone_efficiency" });
	                                hasSubstitutionInvestment = _investmentsView2.default.hasPurchasedInvestment(this.team, { title: "phone_substitution" });
	
	
	                                upgrade.set({ opacity: hasEfficiencyInvestment || hasSubstitutionInvestment ? 1 : INACTIVE_OPACITY });
	
	                                if (!hasEfficiencyInvestment) {
	                                    _context4.next = 30;
	                                    break;
	                                }
	
	                                _context4.next = 26;
	                                return this.loadSvg(dashboardIcons("./resource_white with minus sign.svg"), {
	                                    originX: "center",
	                                    originY: "center",
	                                    left: 612,
	                                    top: 611
	                                });
	
	                            case 26:
	                                upgradeIcon = _context4.sent;
	
	                                groupArray.push(upgradeIcon);
	                                _context4.next = 35;
	                                break;
	
	                            case 30:
	                                if (!hasSubstitutionInvestment) {
	                                    _context4.next = 35;
	                                    break;
	                                }
	
	                                _context4.next = 33;
	                                return this.loadSvg(dashboardIcons("./resource_substitution.svg"), {
	                                    originX: "center",
	                                    originY: "center",
	                                    left: 612,
	                                    top: 611
	                                });
	
	                            case 33:
	                                _upgradeIcon2 = _context4.sent;
	
	                                groupArray.push(_upgradeIcon2);
	
	                            case 35:
	                                _context4.next = 37;
	                                return this.loadSvg(resourceIcons("./microchip.svg"), {
	                                    left: 578,
	                                    top: 637
	                                });
	
	                            case 37:
	                                microchipResource = _context4.sent;
	
	                                microchipResource.scaleToWidth(31);
	                                microchipResource.scaleToHeight(32);
	
	                                plusText = new fabric.Textbox("+", {
	                                    width: 13,
	                                    height: 13,
	                                    originX: "center",
	                                    originY: "center",
	                                    left: 624,
	                                    top: 655,
	
	                                    fontFamily: "SpaceGrotesk-Bold",
	                                    fontSize: 26,
	                                    textAlign: "center",
	                                    stroke: "#162957"
	                                });
	                                _context4.next = 43;
	                                return this.loadSvg(resourceIcons("./resource_yellow.svg"), {
	                                    left: 634,
	                                    top: 636
	                                });
	
	                            case 43:
	                                yellowResource = _context4.sent;
	
	                                yellowResource.scaleToWidth(35);
	                                yellowResource.scaleToHeight(33);
	
	                                groupArray.push(microchipResource);
	                                groupArray.push(plusText);
	                                groupArray.push(yellowResource);
	
	                                this.createInfoIcon({
	                                    left: 381,
	                                    top: 522,
	                                    backgroundColor: "#C8E3EF",
	                                    onClick: function onClick() {
	                                        var investment = _investmentsView2.default.getPurchasedInvestment(_this5.team, { title: "phone_factory" });
	
	                                        _this5.view.showInvestmentDialog(investment, true);
	                                    }
	                                });
	                                _context4.next = 89;
	                                break;
	
	                            case 52:
	                                if (!hasBikeInvestment) {
	                                    _context4.next = 89;
	                                    break;
	                                }
	
	                                _hasEfficiencyInvestment = _investmentsView2.default.hasPurchasedInvestment(this.team, { title: "bike_efficiency" });
	                                _hasSubstitutionInvestment = _investmentsView2.default.hasPurchasedInvestment(this.team, { title: "bike_substitution" });
	
	
	                                upgrade.set({ opacity: _hasEfficiencyInvestment || _hasSubstitutionInvestment ? 1 : INACTIVE_OPACITY });
	
	                                if (!_hasEfficiencyInvestment) {
	                                    _context4.next = 63;
	                                    break;
	                                }
	
	                                _context4.next = 59;
	                                return this.loadSvg(dashboardIcons("./resource_white with minus sign.svg"), {
	                                    originX: "center",
	                                    originY: "center",
	                                    left: 612,
	                                    top: 611
	                                });
	
	                            case 59:
	                                _upgradeIcon3 = _context4.sent;
	
	                                groupArray.push(_upgradeIcon3);
	                                _context4.next = 68;
	                                break;
	
	                            case 63:
	                                if (!_hasSubstitutionInvestment) {
	                                    _context4.next = 68;
	                                    break;
	                                }
	
	                                _context4.next = 66;
	                                return this.loadSvg(dashboardIcons("./resource_substitution.svg"), {
	                                    originX: "center",
	                                    originY: "center",
	                                    left: 612,
	                                    top: 611
	                                });
	
	                            case 66:
	                                _upgradeIcon4 = _context4.sent;
	
	                                groupArray.push(_upgradeIcon4);
	
	                            case 68:
	                                _context4.next = 70;
	                                return this.loadSvg(resourceIcons("./microchip.svg"), {
	                                    left: 578,
	                                    top: 637
	                                });
	
	                            case 70:
	                                _microchipResource = _context4.sent;
	
	                                _microchipResource.scaleToWidth(31);
	                                _microchipResource.scaleToHeight(32);
	
	                                _plusText = new fabric.Textbox("+", {
	                                    width: 13,
	                                    height: 13,
	                                    originX: "center",
	                                    originY: "center",
	                                    left: 624,
	                                    top: 655,
	
	                                    fontFamily: "SpaceGrotesk-Bold",
	                                    fontSize: 26,
	                                    textAlign: "center",
	                                    stroke: "#162957"
	                                });
	                                _context4.next = 76;
	                                return this.loadSvg(resourceIcons("./resource_red.svg"), {
	                                    left: 634,
	                                    top: 636
	                                });
	
	                            case 76:
	                                redResource = _context4.sent;
	
	                                redResource.scaleToWidth(35);
	                                redResource.scaleToHeight(33);
	
	                                _context4.next = 81;
	                                return this.loadSvg(resourceIcons("./resource_purple.svg"), {
	                                    left: 674,
	                                    top: 636
	                                });
	
	                            case 81:
	                                purpleResource = _context4.sent;
	
	                                purpleResource.scaleToWidth(35);
	                                purpleResource.scaleToHeight(33);
	
	                                groupArray.push(_microchipResource);
	                                groupArray.push(_plusText);
	                                groupArray.push(redResource);
	                                groupArray.push(purpleResource);
	
	                                this.createInfoIcon({
	                                    left: 381,
	                                    top: 522,
	                                    backgroundColor: "#C8E3EF",
	                                    onClick: function onClick() {
	                                        var investment = _investmentsView2.default.getPurchasedInvestment(_this5.team, { title: "bike_factory" });
	
	                                        _this5.view.showInvestmentDialog(investment, true);
	                                    }
	                                });
	
	                            case 89:
	                                result = new fabric.Group(groupArray, {
	                                    objectCaching: false
	                                });
	
	                                // Set up production info
	
	                                groupText = new fabric.Text("+1", {
	                                    originX: "center",
	                                    originY: "center",
	                                    left: 733,
	                                    top: 517,
	                                    fontFamily: "SpaceGrotesk-Bold",
	                                    fontSize: 20,
	                                    fill: "#ffffff"
	                                });
	                                groupIconResourceIcon = hasPhoneInvestment ? "./mobile phone.svg" : "./bike.svg";
	                                _context4.next = 94;
	                                return this.loadSvg(resourceIcons(groupIconResourceIcon), {
	                                    originX: "right",
	                                    originY: "center",
	                                    left: 712,
	                                    top: 517
	                                });
	
	                            case 94:
	                                groupIcon = _context4.sent;
	
	                                groupIcon.scaleToHeight(30);
	
	                                group = new fabric.Group([groupText, groupIcon], {});
	                                groupBounds = group.getBoundingRect();
	                                background = new fabric.Rect({
	                                    top: groupBounds.top - 7,
	                                    left: groupBounds.left - 14,
	                                    width: groupBounds.width + 28,
	                                    height: groupBounds.height + 14,
	                                    rx: 4,
	                                    ry: 4,
	                                    fill: "#5FB6CD"
	                                });
	                                totalGroup = new fabric.Group([background, group], {});
	
	
	                                this.sectorsGroup.addWithUpdate(totalGroup);
	
	
	                                this.sectorsGroup.addWithUpdate(result);
	                                _context4.next = 111;
	                                break;
	
	                            case 104:
	                                _context4.next = 106;
	                                return this.loadSvg(dashboardIcons("./under construction_blue.svg"), {
	                                    left: 410,
	                                    top: 518
	                                });
	
	                            case 106:
	                                _factory = _context4.sent;
	
	                                _factory.set({ opacity: UNDER_CONSTRUCTION_OPACITY });
	
	                                _groupArray = [_factory];
	                                _result = new fabric.Group(_groupArray, {
	                                    objectCaching: false
	                                });
	
	
	                                this.sectorsGroup.addWithUpdate(_result);
	
	                            case 111:
	                                hasUpgradeInvestment = _investmentsView2.default.hasPurchasedInvestment(this.team, { title: "phone_efficiency" }) || _investmentsView2.default.hasPurchasedInvestment(this.team, { title: "phone_substitution" }) || _investmentsView2.default.hasPurchasedInvestment(this.team, { title: "bike_efficiency" }) || _investmentsView2.default.hasPurchasedInvestment(this.team, { title: "bike_substitution" });
	                                _context4.next = 114;
	                                return this.createVictoryPoint({
	                                    points: 3,
	                                    left: 716,
	                                    top: 554,
	                                    active: hasUpgradeInvestment
	                                });
	
	                            case 114:
	                            case "end":
	                                return _context4.stop();
	                        }
	                    }
	                }, _callee4, this);
	            }));
	
	            function setUpSecondaryFactory() {
	                return _ref4.apply(this, arguments);
	            }
	
	            return setUpSecondaryFactory;
	        }()
	    }, {
	        key: "setUpMarket",
	        value: function () {
	            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
	                var _this6 = this;
	
	                var groupArray, market, microchip, hasPhoneInvestment, hasBikeInvestment, secondaryResource, _secondaryResource, microchipText, product, secondaryResourceText, groupArr, coinIcon, usePhaseGainsText, microchipIcon, productSetting, _coinIcon, _usePhaseGainsText, _microchipIcon, group, groupBounds, background, totalGroup, result;
	
	                return regeneratorRuntime.wrap(function _callee5$(_context5) {
	                    while (1) {
	                        switch (_context5.prev = _context5.next) {
	                            case 0:
	                                groupArray = [];
	                                _context5.next = 3;
	                                return this.loadSvg(dashboardIcons("./market.svg"), {
	                                    left: 811,
	                                    top: 83
	                                });
	
	                            case 3:
	                                market = _context5.sent;
	
	                                groupArray.push(market);
	
	                                _context5.next = 7;
	                                return this.loadSvg(resourceIcons("./microchip.svg"), {
	                                    originX: "center",
	                                    originY: "center",
	                                    left: 1043,
	                                    top: 206
	                                });
	
	                            case 7:
	                                microchip = _context5.sent;
	
	                                microchip.scaleToWidth(31);
	                                microchip.scaleToHeight(31);
	                                groupArray.push(microchip);
	
	                                hasPhoneInvestment = _investmentsView2.default.hasPurchasedInvestment(this.team, { title: "phone_factory" });
	                                hasBikeInvestment = _investmentsView2.default.hasPurchasedInvestment(this.team, { title: "bike_factory" });
	
	                                if (!hasPhoneInvestment) {
	                                    _context5.next = 21;
	                                    break;
	                                }
	
	                                _context5.next = 16;
	                                return this.loadSvg(resourceIcons("./mobile phone.svg"), {
	                                    originX: "center",
	                                    originY: "center",
	                                    left: 1043,
	                                    top: 248
	                                });
	
	                            case 16:
	                                secondaryResource = _context5.sent;
	
	                                secondaryResource.scaleToHeight(40);
	                                groupArray.push(secondaryResource);
	                                _context5.next = 27;
	                                break;
	
	                            case 21:
	                                if (!hasBikeInvestment) {
	                                    _context5.next = 27;
	                                    break;
	                                }
	
	                                _context5.next = 24;
	                                return this.loadSvg(resourceIcons("./bike.svg"), {
	                                    originX: "center",
	                                    originY: "center",
	                                    left: 1043,
	                                    top: 248
	                                });
	
	                            case 24:
	                                _secondaryResource = _context5.sent;
	
	                                _secondaryResource.scaleToWidth(31);
	                                groupArray.push(_secondaryResource);
	
	                            case 27:
	
	                                // left: 1067
	                                microchipText = new fabric.Text("" + this.getMarketProductCount("microchip"), {
	                                    originX: "left",
	                                    originY: "center",
	                                    left: 1067,
	                                    top: 206,
	                                    fontFamily: "SpaceGrotesk-Bold",
	                                    fontSize: 20,
	                                    fill: "#162957"
	                                });
	
	                                groupArray.push(microchipText);
	
	                                if (hasPhoneInvestment || hasBikeInvestment) {
	                                    product = hasPhoneInvestment ? "phone" : "bike";
	                                    secondaryResourceText = new fabric.Text("" + this.getMarketProductCount(product), {
	                                        originX: "left",
	                                        originY: "center",
	                                        left: 1067,
	                                        top: 248,
	                                        fontFamily: "SpaceGrotesk-Bold",
	                                        fontSize: 20,
	                                        fill: "#162957"
	                                    });
	
	                                    groupArray.push(secondaryResourceText);
	                                }
	
	                                // product info
	                                groupArr = [];
	                                _context5.next = 33;
	                                return this.loadSvg(dashboardIcons("./coins_white.svg"), {
	                                    originX: "center",
	                                    originY: "center",
	                                    left: 1042,
	                                    top: 49
	                                });
	
	                            case 33:
	                                coinIcon = _context5.sent;
	
	                                groupArr.push(coinIcon);
	
	                                usePhaseGainsText = new fabric.Text("+2/", {
	                                    originX: "center",
	                                    originY: "center",
	                                    left: 1080,
	                                    top: 49,
	                                    fontFamily: "SpaceGrotesk-Bold",
	                                    fontSize: 20,
	                                    fill: "#ffffff"
	                                });
	
	                                groupArr.push(usePhaseGainsText);
	
	                                _context5.next = 39;
	                                return this.loadSvg(resourceIcons("./microchip.svg"), {
	                                    originX: "center",
	                                    originY: "center",
	                                    left: 1116,
	                                    top: 49
	                                });
	
	                            case 39:
	                                microchipIcon = _context5.sent;
	
	                                microchipIcon.scaleToWidth(30);
	                                groupArr.push(microchipIcon);
	
	                                if (!(hasPhoneInvestment || hasBikeInvestment)) {
	                                    _context5.next = 56;
	                                    break;
	                                }
	
	                                productSetting = {
	                                    resourceIcon: "./mobile phone.svg",
	                                    price: 5,
	                                    scaleToWidth: 22
	                                };
	
	
	                                if (hasBikeInvestment) {
	                                    productSetting.resourceIcon = "./bike.svg";
	                                    productSetting.price = 7;
	                                    productSetting.scaleToWidth = 30;
	                                }
	
	                                _context5.next = 47;
	                                return this.loadSvg(dashboardIcons("./coins_white.svg"), {
	                                    originX: "center",
	                                    originY: "center",
	                                    left: 1042,
	                                    top: 88
	                                });
	
	                            case 47:
	                                _coinIcon = _context5.sent;
	
	                                groupArr.push(_coinIcon);
	
	                                _usePhaseGainsText = new fabric.Text("+" + productSetting.price + "/", {
	                                    originX: "center",
	                                    originY: "center",
	                                    left: 1080,
	                                    top: 88,
	                                    fontFamily: "SpaceGrotesk-Bold",
	                                    fontSize: 20,
	                                    fill: "#ffffff"
	                                });
	
	                                groupArr.push(_usePhaseGainsText);
	
	                                _context5.next = 53;
	                                return this.loadSvg(resourceIcons(productSetting.resourceIcon), {
	                                    originX: "center",
	                                    originY: "center",
	                                    left: 1116,
	                                    top: 88
	                                });
	
	                            case 53:
	                                _microchipIcon = _context5.sent;
	
	                                _microchipIcon.scaleToWidth(productSetting.scaleToWidth);
	                                groupArr.push(_microchipIcon);
	
	                            case 56:
	                                group = new fabric.Group(groupArr, {});
	                                groupBounds = group.getBoundingRect();
	                                background = new fabric.Rect({
	                                    top: groupBounds.top - 11,
	                                    left: groupBounds.left - 13,
	                                    width: groupBounds.width + 26,
	                                    height: groupBounds.height + 22,
	                                    rx: 4,
	                                    ry: 4,
	                                    fill: "#dc4a67"
	                                });
	                                totalGroup = new fabric.Group([background, group], {});
	
	                                groupArray.push(totalGroup);
	                                result = new fabric.Group(groupArray, {
	                                    objectCaching: false
	                                });
	
	
	                                this.sectorsGroup.addWithUpdate(result);
	
	                                this.createInfoIcon({
	                                    left: 813,
	                                    top: 22,
	                                    backgroundColor: "#f1afb4",
	                                    onClick: function onClick() {
	                                        var container = $("<div>");
	
	                                        var type = undefined;
	                                        var hasPhoneInvestment = _investmentsView2.default.hasPurchasedInvestment(_this6.team, { title: "phone_factory" });
	                                        var hasBikeInvestment = _investmentsView2.default.hasPurchasedInvestment(_this6.team, { title: "bike_factory" });
	
	                                        if (hasPhoneInvestment) {
	                                            type = "phone";
	                                        } else if (hasBikeInvestment) {
	                                            type = "bike";
	                                        }
	
	                                        new _infoMarket2.default({
	                                            container: container,
	                                            secondaryType: type,
	                                            market: JSON.parse(_this6.roundOverview.currentRoundData.market)
	                                        }).render();
	
	                                        _shared2.default.Dialog.showMessageDialog({
	                                            title: "info.title",
	                                            message: container,
	                                            disposable: false,
	                                            extraModalContentClass: "info-market-background-container"
	                                        });
	                                    }
	                                });
	
	                            case 64:
	                            case "end":
	                                return _context5.stop();
	                        }
	                    }
	                }, _callee5, this);
	            }));
	
	            function setUpMarket() {
	                return _ref5.apply(this, arguments);
	            }
	
	            return setUpMarket;
	        }()
	    }, {
	        key: "setUpWasteDepot",
	        value: function () {
	            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
	                var wasteDepot, groupArray, result;
	                return regeneratorRuntime.wrap(function _callee6$(_context6) {
	                    while (1) {
	                        switch (_context6.prev = _context6.next) {
	                            case 0:
	                                _context6.next = 2;
	                                return this.loadSvg(dashboardIcons("./waste depot.svg"), {
	                                    left: 27,
	                                    top: 272
	                                });
	
	                            case 2:
	                                wasteDepot = _context6.sent;
	                                groupArray = [wasteDepot];
	                                result = new fabric.Group(groupArray, {
	                                    objectCaching: false
	                                });
	
	
	                                this.sectorsGroup.addWithUpdate(result);
	
	                                this.createInfoIcon({
	                                    left: 26,
	                                    top: 292,
	                                    backgroundColor: "#ffe2a1",
	                                    onClick: function onClick() {
	                                        var container = $("<div>");
	
	                                        new _infoWasteDepot2.default({ container: container }).render();
	
	                                        _shared2.default.Dialog.showMessageDialog({
	                                            title: "info.title",
	                                            message: container,
	                                            disposable: false,
	                                            extraModalContentClass: "info-waste-depot-background-container"
	                                        });
	                                    }
	                                });
	
	                            case 7:
	                            case "end":
	                                return _context6.stop();
	                        }
	                    }
	                }, _callee6, this);
	            }));
	
	            function setUpWasteDepot() {
	                return _ref6.apply(this, arguments);
	            }
	
	            return setUpWasteDepot;
	        }()
	    }, {
	        key: "setUpWasteRecycling",
	        value: function () {
	            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
	                var _this7 = this;
	
	                var factoryName, hasInvestment, wasteRecycling, production, groupArray, result, _wasteRecycling, _groupArray2, _result2;
	
	                return regeneratorRuntime.wrap(function _callee7$(_context7) {
	                    while (1) {
	                        switch (_context7.prev = _context7.next) {
	                            case 0:
	                                factoryName = "waste_recycling";
	                                hasInvestment = _investmentsView2.default.hasPurchasedInvestment(this.team, { title: "waste_recycling" });
	
	                                if (!hasInvestment) {
	                                    _context7.next = 19;
	                                    break;
	                                }
	
	                                _context7.next = 5;
	                                return this.loadSvg(dashboardIcons("./waste recycling.svg"), {
	                                    left: 28,
	                                    top: 30
	                                });
	
	                            case 5:
	                                wasteRecycling = _context7.sent;
	                                _context7.next = 8;
	                                return this.loadSvg(dashboardIcons("./waste_recycling_resources.svg"), {
	                                    left: 223,
	                                    top: 22
	                                });
	
	                            case 8:
	                                production = _context7.sent;
	                                _context7.next = 11;
	                                return this.createEmployeeSpot({
	                                    left: 121,
	                                    top: 254,
	                                    taken: this.getEmployeeCountForFactory(factoryName) >= 1,
	                                    enabled: true,
	                                    onAssignEmployee: function onAssignEmployee() {
	                                        _this7.onAssignWasteRecycleEmployee.call(_this7);
	                                    }
	                                });
	
	                            case 11:
	                                _context7.next = 13;
	                                return this.createEmployeeSpot({
	                                    left: 88,
	                                    top: 272,
	                                    taken: this.getEmployeeCountForFactory(factoryName) >= 2,
	                                    enabled: true,
	                                    onAssignEmployee: function onAssignEmployee() {
	                                        _this7.onAssignWasteRecycleEmployee.call(_this7);
	                                    }
	                                });
	
	                            case 13:
	                                groupArray = [wasteRecycling, production];
	                                result = new fabric.Group(groupArray, {
	                                    objectCaching: false
	                                });
	
	
	                                this.sectorsGroup.addWithUpdate(result);
	
	                                this.createInfoIcon({
	                                    left: 26,
	                                    top: 22,
	                                    backgroundColor: "#FBE3A9",
	                                    onClick: function onClick() {
	                                        var investment = _investmentsView2.default.getPurchasedInvestment(_this7.team, { title: "waste_recycling" });
	
	                                        _this7.view.showInvestmentDialog(investment, true);
	                                    }
	                                });
	                                _context7.next = 26;
	                                break;
	
	                            case 19:
	                                _context7.next = 21;
	                                return this.loadSvg(dashboardIcons("./under construction_yellow.svg"), {
	                                    left: 41,
	                                    top: 28
	                                });
	
	                            case 21:
	                                _wasteRecycling = _context7.sent;
	
	                                _wasteRecycling.set({ opacity: UNDER_CONSTRUCTION_OPACITY });
	
	                                _groupArray2 = [_wasteRecycling];
	                                _result2 = new fabric.Group(_groupArray2, {
	                                    objectCaching: false
	                                });
	
	
	                                this.sectorsGroup.addWithUpdate(_result2);
	
	                            case 26:
	                            case "end":
	                                return _context7.stop();
	                        }
	                    }
	                }, _callee7, this);
	            }));
	
	            function setUpWasteRecycling() {
	                return _ref7.apply(this, arguments);
	            }
	
	            return setUpWasteRecycling;
	        }()
	    }, {
	        key: "setUpReuseFacility",
	        value: function () {
	            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
	                var _this8 = this;
	
	                var factoryName, hasInvestment, groupArray, hasPhoneInvestment, hasBikeInvestment, reuseFacility, hasProductRefurbishingInvestment, upgrade, upgradeIcon, _upgradeIcon5, purpleResource, groupArr, usePhaseGainsText, microchipIcon, productSetting, _usePhaseGainsText2, _microchipIcon2, group, groupBounds, background, totalGroup, result, _reuseFacility, _groupArray3, _result3;
	
	                return regeneratorRuntime.wrap(function _callee8$(_context8) {
	                    while (1) {
	                        switch (_context8.prev = _context8.next) {
	                            case 0:
	                                factoryName = "reuse_facility";
	                                hasInvestment = _investmentsView2.default.hasPurchasedInvestment(this.team, { title: "microchip_reuse" });
	                                groupArray = [];
	
	                                if (!hasInvestment) {
	                                    _context8.next = 67;
	                                    break;
	                                }
	
	                                hasPhoneInvestment = _investmentsView2.default.hasPurchasedInvestment(this.team, { title: "phone_factory" });
	                                hasBikeInvestment = _investmentsView2.default.hasPurchasedInvestment(this.team, { title: "bike_factory" });
	                                _context8.next = 8;
	                                return this.loadSvg(dashboardIcons("./facility with car.svg"), {
	                                    left: 400,
	                                    top: 87
	                                });
	
	                            case 8:
	                                reuseFacility = _context8.sent;
	
	                                groupArray.push(reuseFacility);
	
	                                hasProductRefurbishingInvestment = _investmentsView2.default.hasPurchasedInvestment(this.team, { title: "product_refurbishing" });
	                                _context8.next = 13;
	                                return this.loadSvg(dashboardIcons("./facility upgrade.svg"), {
	                                    left: 627,
	                                    top: 129
	                                });
	
	                            case 13:
	                                upgrade = _context8.sent;
	
	                                upgrade.set({ opacity: hasProductRefurbishingInvestment ? 1 : INACTIVE_OPACITY });
	                                groupArray.push(upgrade);
	
	                                if (!hasProductRefurbishingInvestment) {
	                                    _context8.next = 35;
	                                    break;
	                                }
	
	                                if (!hasPhoneInvestment) {
	                                    _context8.next = 24;
	                                    break;
	                                }
	
	                                _context8.next = 20;
	                                return this.loadSvg(resourceIcons("./mobile-phone-green.svg"), {
	                                    originX: "center",
	                                    originY: "center",
	                                    left: 680,
	                                    top: 182
	                                });
	
	                            case 20:
	                                upgradeIcon = _context8.sent;
	
	                                groupArray.push(upgradeIcon);
	                                _context8.next = 29;
	                                break;
	
	                            case 24:
	                                if (!hasBikeInvestment) {
	                                    _context8.next = 29;
	                                    break;
	                                }
	
	                                _context8.next = 27;
	                                return this.loadSvg(resourceIcons("./bike.svg"), {
	                                    originX: "center",
	                                    originY: "center",
	                                    left: 680,
	                                    top: 182
	                                });
	
	                            case 27:
	                                _upgradeIcon5 = _context8.sent;
	
	                                groupArray.push(_upgradeIcon5);
	
	                            case 29:
	                                _context8.next = 31;
	                                return this.loadSvg(resourceIcons("./resource_purple.svg"), {
	                                    left: 639,
	                                    top: 203
	                                });
	
	                            case 31:
	                                purpleResource = _context8.sent;
	
	                                purpleResource.scaleToWidth(35);
	                                purpleResource.scaleToHeight(33);
	                                groupArray.push(purpleResource);
	
	                            case 35:
	                                _context8.next = 37;
	                                return this.createEmployeeSpot({
	                                    left: 680,
	                                    top: 245,
	                                    taken: this.getEmployeeCountForFactory(factoryName) >= 1,
	                                    enabled: this.canEmployReuseFacility(),
	                                    onAssignEmployee: function onAssignEmployee() {
	                                        _this8.onAssignReuseEmployee.call(_this8);
	                                    }
	                                });
	
	                            case 37:
	                                _context8.next = 39;
	                                return this.createEmployeeSpot({
	                                    left: 717,
	                                    top: 260,
	                                    taken: this.getEmployeeCountForFactory(factoryName) >= 2,
	                                    enabled: this.canEmployReuseFacility(),
	                                    onAssignEmployee: function onAssignEmployee() {
	                                        _this8.onAssignReuseEmployee.call(_this8);
	                                    }
	                                });
	
	                            case 39:
	                                groupArr = [];
	                                usePhaseGainsText = new fabric.Text("+1", {
	                                    originX: "center",
	                                    originY: "center",
	                                    left: 682,
	                                    top: 49,
	                                    fontFamily: "SpaceGrotesk-Bold",
	                                    fontSize: 20,
	                                    fill: "#ffffff"
	                                });
	
	                                groupArr.push(usePhaseGainsText);
	
	                                _context8.next = 44;
	                                return this.loadSvg(resourceIcons("./microchip-green.svg"), {
	                                    originX: "center",
	                                    originY: "center",
	                                    left: 646,
	                                    top: 49
	                                });
	
	                            case 44:
	                                microchipIcon = _context8.sent;
	
	                                microchipIcon.scaleToWidth(30);
	                                groupArr.push(microchipIcon);
	
	                                if (!(hasPhoneInvestment || hasBikeInvestment)) {
	                                    _context8.next = 57;
	                                    break;
	                                }
	
	                                productSetting = {
	                                    resourceIcon: "./mobile-phone-green.svg",
	                                    scaleToWidth: 22
	                                };
	
	
	                                if (hasBikeInvestment) {
	                                    productSetting.resourceIcon = "./bike.svg";
	                                    productSetting.price = 7;
	                                    productSetting.scaleToWidth = 30;
	                                }
	
	                                _usePhaseGainsText2 = new fabric.Text("+1", {
	                                    originX: "center",
	                                    originY: "center",
	                                    left: 682,
	                                    top: 88,
	                                    fontFamily: "SpaceGrotesk-Bold",
	                                    fontSize: 20,
	                                    fill: "#ffffff"
	                                });
	
	                                groupArr.push(_usePhaseGainsText2);
	
	                                _context8.next = 54;
	                                return this.loadSvg(resourceIcons(productSetting.resourceIcon), {
	                                    originX: "center",
	                                    originY: "center",
	                                    left: 646,
	                                    top: 88
	                                });
	
	                            case 54:
	                                _microchipIcon2 = _context8.sent;
	
	                                _microchipIcon2.scaleToWidth(productSetting.scaleToWidth);
	                                groupArr.push(_microchipIcon2);
	
	                            case 57:
	                                group = new fabric.Group(groupArr, {});
	                                groupBounds = group.getBoundingRect();
	                                background = new fabric.Rect({
	                                    top: groupBounds.top - 11,
	                                    left: groupBounds.left - 13,
	                                    width: groupBounds.width + 26,
	                                    height: groupBounds.height + 22,
	                                    rx: 4,
	                                    ry: 4,
	                                    fill: "#aec902"
	                                });
	                                totalGroup = new fabric.Group([background, group], {});
	
	                                groupArray.push(totalGroup);
	                                result = new fabric.Group(groupArray, {
	                                    objectCaching: false
	                                });
	
	
	                                this.sectorsGroup.addWithUpdate(result);
	
	                                this.createInfoIcon({
	                                    left: 383,
	                                    top: 22,
	                                    backgroundColor: "#e7efa7",
	                                    onClick: function onClick() {
	                                        var investment = _investmentsView2.default.getPurchasedInvestment(_this8.team, { title: "microchip_reuse" });
	
	                                        _this8.view.showInvestmentDialog(investment, true);
	                                    }
	                                });
	                                _context8.next = 74;
	                                break;
	
	                            case 67:
	                                _context8.next = 69;
	                                return this.loadSvg(dashboardIcons("./under construction_lightgreen.svg"), {
	                                    left: 436,
	                                    top: 30
	                                });
	
	                            case 69:
	                                _reuseFacility = _context8.sent;
	
	                                _reuseFacility.set({ opacity: UNDER_CONSTRUCTION_OPACITY });
	
	                                _groupArray3 = [_reuseFacility];
	                                _result3 = new fabric.Group(_groupArray3, {
	                                    objectCaching: false
	                                });
	
	
	                                this.sectorsGroup.addWithUpdate(_result3);
	
	                            case 74:
	                                _context8.next = 76;
	                                return this.createVictoryPoint({
	                                    points: 3,
	                                    left: 721,
	                                    top: 20,
	                                    active: _investmentsView2.default.hasPurchasedInvestment(this.team, { title: "product_refurbishing" })
	                                });
	
	                            case 76:
	                            case "end":
	                                return _context8.stop();
	                        }
	                    }
	                }, _callee8, this);
	            }));
	
	            function setUpReuseFacility() {
	                return _ref8.apply(this, arguments);
	            }
	
	            return setUpReuseFacility;
	        }()
	    }, {
	        key: "setUpRental",
	        value: function () {
	            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
	                var _this9 = this;
	
	                var factoryName, hasInvestment, groupArray, rentalFacility, hasRepairWorkshop, upgrade, upgradeIcon, rentalPhaseText, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref10, _ref11, index, phase, xPos, yPosCenter, phaseIndexText, productIconSetting, productIcon, phaseCountText, nextIcon, wasteIcon, groupArr, usePhaseGainsText, group, groupBounds, coinsIcon, background, totalGroup, previousIcon, linePoints, lines, minusSign, resourceCostIcon, result, _rentalFacility, _groupArray4, _result4;
	
	                return regeneratorRuntime.wrap(function _callee9$(_context9) {
	                    while (1) {
	                        switch (_context9.prev = _context9.next) {
	                            case 0:
	                                factoryName = "rental";
	                                hasInvestment = _investmentsView2.default.hasPurchasedInvestment(this.team, { title: "rental_maintenance" });
	                                groupArray = [];
	
	                                if (!hasInvestment) {
	                                    _context9.next = 109;
	                                    break;
	                                }
	
	                                _context9.next = 6;
	                                return this.loadSvg(dashboardIcons("./rental service.svg"), {
	                                    left: 816,
	                                    top: 392
	                                });
	
	                            case 6:
	                                rentalFacility = _context9.sent;
	
	                                groupArray.push(rentalFacility);
	
	                                hasRepairWorkshop = _investmentsView2.default.hasPurchasedInvestment(this.team, { title: "repair_workshop" });
	                                _context9.next = 11;
	                                return this.loadSvg(dashboardIcons("./rental service upgrade.svg"), {
	                                    left: 1013,
	                                    top: 443
	                                });
	
	                            case 11:
	                                upgrade = _context9.sent;
	
	                                groupArray.push(upgrade);
	                                upgrade.set({ opacity: hasRepairWorkshop ? 1 : INACTIVE_OPACITY });
	
	                                if (!hasRepairWorkshop) {
	                                    _context9.next = 19;
	                                    break;
	                                }
	
	                                _context9.next = 17;
	                                return this.loadSvg(dashboardIcons("./rental service upgrade icon.svg"), {
	                                    originX: "center",
	                                    originY: "center",
	                                    left: 1080,
	                                    top: 483
	                                });
	
	                            case 17:
	                                upgradeIcon = _context9.sent;
	
	                                groupArray.push(upgradeIcon);
	
	                            case 19:
	                                _context9.next = 21;
	                                return this.createEmployeeSpot({
	                                    left: 851,
	                                    top: 539,
	                                    taken: this.getEmployeeCountForFactory(factoryName) >= 1,
	                                    enabled: this.canRentProducts(),
	                                    onAssignEmployee: function onAssignEmployee() {
	                                        _this9.onAssignRentalEmployee.call(_this9);
	                                    }
	                                });
	
	                            case 21:
	                                _context9.next = 23;
	                                return this.createEmployeeSpot({
	                                    left: 818,
	                                    top: 554,
	                                    taken: this.getEmployeeCountForFactory(factoryName) >= 2,
	                                    enabled: this.canRentProducts(),
	                                    onAssignEmployee: function onAssignEmployee() {
	                                        _this9.onAssignRentalEmployee.call(_this9);
	                                    }
	                                });
	
	                            case 23:
	                                rentalPhaseText = new fabric.Text("USE PHASE", {
	                                    originX: "center",
	                                    originY: "center",
	                                    left: 923,
	                                    top: 613,
	                                    fontFamily: "SpaceGrotesk-Bold",
	                                    fontSize: 14,
	                                    fill: "#162957"
	                                });
	
	                                groupArray.push(rentalPhaseText);
	
	                                _iteratorNormalCompletion = true;
	                                _didIteratorError = false;
	                                _iteratorError = undefined;
	                                _context9.prev = 28;
	                                _iterator = [1, 2, 3].entries()[Symbol.iterator]();
	
	                            case 30:
	                                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
	                                    _context9.next = 56;
	                                    break;
	                                }
	
	                                _ref10 = _step.value;
	                                _ref11 = _slicedToArray(_ref10, 2);
	                                index = _ref11[0];
	                                phase = _ref11[1];
	
	                                // 97 including ">"
	                                xPos = 794 + index * 97;
	                                yPosCenter = 664;
	                                phaseIndexText = new fabric.Text("" + phase, {
	                                    originX: "center",
	                                    originY: "center",
	                                    left: xPos + 27,
	                                    top: yPosCenter - 33,
	                                    fontFamily: "SpaceGrotesk-Bold",
	                                    fontSize: 14,
	                                    fill: "#162957"
	                                });
	
	                                groupArray.push(phaseIndexText);
	
	                                productIconSetting = {
	                                    resourceIcon: "./mobile phone.svg",
	                                    scaleToWidth: 24
	                                };
	
	                                if (_investmentsView2.default.hasPurchasedInvestment(this.team, { title: "bike_factory" })) {
	                                    productIconSetting.resourceIcon = "./bike.svg";
	                                    productIconSetting.scaleToWidth = 34;
	                                }
	
	                                _context9.next = 43;
	                                return this.loadSvg(resourceIcons(productIconSetting.resourceIcon), {
	                                    originX: "center",
	                                    originY: "center",
	                                    left: xPos + 27,
	                                    top: yPosCenter
	                                });
	
	                            case 43:
	                                productIcon = _context9.sent;
	
	                                productIcon.scaleToWidth(productIconSetting.scaleToWidth);
	                                groupArray.push(productIcon);
	
	                                phaseCountText = new fabric.Text("" + this.getRentalProductCountForPhase(phase), {
	                                    originX: "center",
	                                    originY: "center",
	                                    left: xPos + 66,
	                                    top: yPosCenter,
	                                    fontFamily: "SpaceGrotesk-Bold",
	                                    fontSize: 18,
	                                    fill: "#162957"
	                                });
	
	                                groupArray.push(phaseCountText);
	
	                                _context9.next = 50;
	                                return this.loadSvg(dashboardIcons("./arrow_green.svg"), {
	                                    originX: "right",
	                                    originY: "center",
	                                    left: xPos + 97,
	                                    top: yPosCenter
	                                });
	
	                            case 50:
	                                nextIcon = _context9.sent;
	
	                                nextIcon.scaleToHeight(15);
	                                groupArray.push(nextIcon);
	
	                            case 53:
	                                _iteratorNormalCompletion = true;
	                                _context9.next = 30;
	                                break;
	
	                            case 56:
	                                _context9.next = 62;
	                                break;
	
	                            case 58:
	                                _context9.prev = 58;
	                                _context9.t0 = _context9["catch"](28);
	                                _didIteratorError = true;
	                                _iteratorError = _context9.t0;
	
	                            case 62:
	                                _context9.prev = 62;
	                                _context9.prev = 63;
	
	                                if (!_iteratorNormalCompletion && _iterator.return) {
	                                    _iterator.return();
	                                }
	
	                            case 65:
	                                _context9.prev = 65;
	
	                                if (!_didIteratorError) {
	                                    _context9.next = 68;
	                                    break;
	                                }
	
	                                throw _iteratorError;
	
	                            case 68:
	                                return _context9.finish(65);
	
	                            case 69:
	                                return _context9.finish(62);
	
	                            case 70:
	                                _context9.next = 72;
	                                return this.loadSvg(dashboardIcons("./garbage container_white.svg"), {
	                                    originX: "center",
	                                    originY: "center",
	                                    left: 1112,
	                                    top: 663
	                                });
	
	                            case 72:
	                                wasteIcon = _context9.sent;
	
	                                groupArray.push(wasteIcon);
	
	                                // Set up rental info
	                                groupArr = [];
	                                usePhaseGainsText = new fabric.Text("+" + (_investmentsView2.default.hasPurchasedInvestment(this.team, { title: "phone_factory" }) ? 3 : 4) + "/ USE PHASE", {
	                                    originX: "right",
	                                    originY: "center",
	                                    left: 1132,
	                                    top: 556,
	                                    fontFamily: "SpaceGrotesk-Bold",
	                                    fontSize: 20,
	                                    fill: "#ffffff"
	                                });
	
	                                groupArr.push(usePhaseGainsText);
	
	                                group = new fabric.Group(groupArr, {});
	                                groupBounds = group.getBoundingRect();
	                                _context9.next = 81;
	                                return this.loadSvg(dashboardIcons("./coins_white.svg"), {
	                                    originX: "right",
	                                    originY: "center",
	                                    top: 556,
	                                    left: groupBounds.left - 5
	                                });
	
	                            case 81:
	                                coinsIcon = _context9.sent;
	
	                                group.addWithUpdate(coinsIcon);
	
	                                groupBounds = group.getBoundingRect();
	                                background = new fabric.Rect({
	                                    top: groupBounds.top - 7,
	                                    left: groupBounds.left - 13,
	                                    width: groupBounds.width + 26,
	                                    height: groupBounds.height + 14,
	                                    rx: 4,
	                                    ry: 4,
	                                    fill: "#73b858"
	                                });
	                                totalGroup = new fabric.Group([background, group], {});
	
	                                groupArray.push(totalGroup);
	
	                                if (!hasRepairWorkshop) {
	                                    _context9.next = 104;
	                                    break;
	                                }
	
	                                _context9.next = 90;
	                                return this.loadSvg(dashboardIcons("./arrow_green.svg"), {
	                                    originX: "center",
	                                    originY: "center",
	                                    left: 923,
	                                    top: 705
	                                });
	
	                            case 90:
	                                previousIcon = _context9.sent;
	
	                                previousIcon.scaleToHeight(15);
	                                previousIcon.set("flipX", true);
	                                groupArray.push(previousIcon);
	
	                                linePoints = [{ x: 827, y: 686 }, { x: 827, y: 705 }, { x: 1017, y: 705 }, { x: 1017, y: 686 }];
	                                lines = this.drawLine(linePoints, {
	                                    stroke: "#589045"
	                                });
	
	                                groupArray = groupArray.concat(lines);
	
	                                minusSign = new fabric.Text("-", {
	                                    originX: "center",
	                                    originY: "center",
	                                    left: 1029,
	                                    top: 696,
	                                    fontFamily: "SpaceGrotesk-Bold",
	                                    fontSize: 20,
	                                    fill: "#162957"
	                                });
	
	                                groupArray.push(minusSign);
	
	                                _context9.next = 101;
	                                return this.loadSvg(resourceIcons("./resource_red.svg"), {
	                                    originX: "center",
	                                    originY: "center",
	                                    left: 1049,
	                                    top: 694
	                                });
	
	                            case 101:
	                                resourceCostIcon = _context9.sent;
	
	                                resourceCostIcon.scaleToHeight(22);
	                                groupArray.push(resourceCostIcon);
	
	                            case 104:
	                                result = new fabric.Group(groupArray, {
	                                    objectCaching: false
	                                });
	
	
	                                this.sectorsGroup.addWithUpdate(result);
	
	                                this.createInfoIcon({
	                                    left: 814,
	                                    top: 339,
	                                    backgroundColor: "#d1edb7",
	                                    onClick: function onClick() {
	                                        var investment = _investmentsView2.default.getPurchasedInvestment(_this9.team, { title: "rental_maintenance" });
	
	                                        _this9.view.showInvestmentDialog(investment, true);
	                                    }
	                                });
	                                _context9.next = 116;
	                                break;
	
	                            case 109:
	                                _context9.next = 111;
	                                return this.loadSvg(dashboardIcons("./under construction_green.svg"), {
	                                    left: 808,
	                                    top: 369
	                                });
	
	                            case 111:
	                                _rentalFacility = _context9.sent;
	
	                                _rentalFacility.set({ opacity: UNDER_CONSTRUCTION_OPACITY });
	
	                                _groupArray4 = [_rentalFacility];
	                                _result4 = new fabric.Group(_groupArray4, {
	                                    objectCaching: false
	                                });
	
	
	                                this.sectorsGroup.addWithUpdate(_result4);
	
	                            case 116:
	                                _context9.next = 118;
	                                return this.createVictoryPoint({
	                                    points: 4,
	                                    left: 1102,
	                                    top: 343,
	                                    active: _investmentsView2.default.hasPurchasedInvestment(this.team, { title: "repair_workshop" })
	                                });
	
	                            case 118:
	                            case "end":
	                                return _context9.stop();
	                        }
	                    }
	                }, _callee9, this, [[28, 58, 62, 70], [63,, 65, 69]]);
	            }));
	
	            function setUpRental() {
	                return _ref9.apply(this, arguments);
	            }
	
	            return setUpRental;
	        }()
	    }, {
	        key: "createInfoIcon",
	        value: function createInfoIcon(infoIcon) {
	            var _this10 = this;
	
	            infoIcon = _extends({}, infoIcon, this.layoutData.infoSettings); // merging two objects
	
	            var infoIconBackground = new fabric.Circle({
	                radius: infoIcon.radius,
	                fill: infoIcon.backgroundColor,
	                left: infoIcon.left,
	                top: infoIcon.top
	            });
	
	            var infoIconText = new fabric.Textbox("i", {
	                width: infoIconBackground.radius * 2,
	                height: infoIconBackground.radius * 2,
	                originX: "center",
	                originY: "center",
	                left: infoIcon.left + infoIconBackground.radius,
	                top: infoIcon.top + infoIconBackground.radius,
	
	                fontFamily: infoIcon.text.fontFamily,
	                fontSize: infoIcon.text.fontSize,
	                textAlign: infoIcon.text.alignment,
	                stroke: infoIcon.text.color
	            });
	
	            var infoIconGroup = new fabric.Group([infoIconBackground, infoIconText], {
	                hasBorders: false,
	                hasControls: false,
	                selectable: false,
	                reference: false,
	                moveable: false,
	                visible: true,
	                hoverCursor: "pointer"
	            });
	
	            this.infoIcons.push(infoIconGroup);
	            this.canvas.add(infoIconGroup);
	
	            infoIconGroup.on("mousedown", function (options) {
	                if (infoIcon.onClick) {
	                    infoIcon.onClick.call(_this10);
	                }
	            });
	        }
	    }, {
	        key: "drawLine",
	        value: function drawLine(linePoints, options) {
	            var lines = [];
	
	            for (var i = 0; i < linePoints.length - 1; ++i) {
	                var pointA = linePoints[i];
	                var pointB = linePoints[i + 1];
	
	                var line = new fabric.Line([pointA.x, pointA.y, pointB.x, pointB.y], {
	                    originX: "center",
	                    originY: "center",
	                    stroke: options.stroke || "#589045",
	                    strokeWidth: options.strokeWidth || 2,
	                    hasControls: false,
	                    hasBorders: false,
	                    lockMovementX: true,
	                    lockMovementY: true,
	                    hoverCursor: "default"
	                });
	                lines.push(line);
	            }
	            return lines;
	        }
	    }, {
	        key: "createVictoryPoint",
	        value: function () {
	            var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(vp) {
	                var image, pointsText, group;
	                return regeneratorRuntime.wrap(function _callee10$(_context10) {
	                    while (1) {
	                        switch (_context10.prev = _context10.next) {
	                            case 0:
	                                _context10.next = 2;
	                                return this.loadSvg(resourceIcons("./trophy.svg"), {
	                                    left: vp.left,
	                                    top: vp.top
	                                });
	
	                            case 2:
	                                image = _context10.sent;
	                                pointsText = new fabric.Textbox("" + vp.points, {
	                                    originX: "center",
	                                    originY: "center",
	                                    left: vp.left + image.width / 2,
	                                    top: vp.top + image.width / 2 - 8,
	                                    width: image.width,
	                                    height: image.width,
	                                    fontFamily: "SpaceGrotesk-Bold",
	                                    fontSize: 20,
	                                    textAlign: "center"
	                                });
	                                group = new fabric.Group([image, pointsText], {
	                                    hasBorders: false,
	                                    hasControls: false,
	                                    selectable: false,
	                                    reference: false,
	                                    moveable: false,
	                                    visible: true,
	                                    hoverCursor: "default"
	                                });
	
	                                group.set({ opacity: vp.active ? 1 : INACTIVE_OPACITY });
	
	                                this.canvas.add(group);
	
	                            case 7:
	                            case "end":
	                                return _context10.stop();
	                        }
	                    }
	                }, _callee10, this);
	            }));
	
	            function createVictoryPoint(_x) {
	                return _ref12.apply(this, arguments);
	            }
	
	            return createVictoryPoint;
	        }()
	    }, {
	        key: "createEmployeeSpot",
	        value: function () {
	            var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(spot) {
	                var _this11 = this;
	
	                var group, employeeSpot, employee, freeEmployees;
	                return regeneratorRuntime.wrap(function _callee11$(_context11) {
	                    while (1) {
	                        switch (_context11.prev = _context11.next) {
	                            case 0:
	                                group = new fabric.Group([], {
	                                    hasBorders: false,
	                                    hasControls: false,
	                                    selectable: false,
	                                    reference: false,
	                                    moveable: false,
	                                    visible: true,
	                                    hoverCursor: spot.taken ? "default" : "pointer"
	                                });
	                                _context11.next = 3;
	                                return this.loadSvg(dashboardIcons("./employee_spot.svg"), {
	                                    left: spot.left,
	                                    top: spot.top
	                                });
	
	                            case 3:
	                                employeeSpot = _context11.sent;
	
	                                group.addWithUpdate(employeeSpot);
	
	                                if (!spot.taken) {
	                                    _context11.next = 12;
	                                    break;
	                                }
	
	                                _context11.next = 8;
	                                return this.loadSvg(resourceIcons("./employee.svg"), {
	                                    originX: "center",
	                                    originY: "bottom",
	                                    left: spot.left + employeeSpot.width / 2,
	                                    top: spot.top + employeeSpot.height / 2
	                                });
	
	                            case 8:
	                                employee = _context11.sent;
	
	
	                                group.addWithUpdate(employee);
	                                _context11.next = 14;
	                                break;
	
	                            case 12:
	                                freeEmployees = this.getFreeEmployees();
	
	                                if (freeEmployees > 0 && spot.enabled) {
	                                    group.on("mousedown", function (options) {
	                                        log.info("On mouse down on employee spot");
	                                        spot.onAssignEmployee.call(_this11);
	                                    });
	                                } else {
	                                    group.set({ opacity: INACTIVE_OPACITY });
	                                    group.hoverCursor = "default";
	
	                                    group.on("mousedown", function (options) {
	                                        _this11.onInactiveSpotClick.call(_this11);
	                                    });
	                                }
	
	                            case 14:
	
	                                group.namedGroup = spot.namedGroup;
	                                group.spotCanBeUsed = !spot.taken && spot.enabled && this.getFreeEmployees() > 0;
	
	                                this.employeeSpots.push(group);
	                                this.canvas.add(group);
	
	                                // this.employeeSpotGroup.addWithUpdate(group);
	
	                            case 18:
	                            case "end":
	                                return _context11.stop();
	                        }
	                    }
	                }, _callee11, this);
	            }));
	
	            function createEmployeeSpot(_x2) {
	                return _ref13.apply(this, arguments);
	            }
	
	            return createEmployeeSpot;
	        }()
	    }, {
	        key: "enableTutorialNamedEmployeeSpot",
	        value: function enableTutorialNamedEmployeeSpot(namedGroup) {
	            var _this12 = this;
	
	            var _loop = function _loop(group) {
	                if (group.namedGroup !== namedGroup) {
	                    group.set({ opacity: INACTIVE_OPACITY });
	                    group.hoverCursor = "default";
	                    group.off("mousedown");
	                } else {
	                    var delay = 10000;
	                    var duration = 500;
	                    var scale = 1.5;
	                    var pulseInterval = -1;
	
	                    var pulse = function pulse(up) {
	                        try {
	                            var position = group.translateToGivenOrigin({
	                                x: group.left,
	                                y: group.top
	                            }, group.originX, group.originY, "center", "bottom");
	                            group.originX = "center";
	                            group.originY = "bottom";
	                            group.left = position.x;
	                            group.top = position.y;
	
	                            if (up) {
	                                group.animate({
	                                    scaleX: scale,
	                                    scaleY: scale
	                                }, {
	                                    duration: duration,
	                                    onChange: _this12.canvas.renderAll.bind(_this12.canvas)
	                                });
	                            } else {
	                                group.animate({
	                                    scaleX: 1,
	                                    scaleY: 1
	                                }, {
	                                    duration: duration,
	                                    onChange: _this12.canvas.renderAll.bind(_this12.canvas)
	                                });
	                            }
	                        } catch (error) {
	                            clearInterval(pulseInterval);
	                        }
	                    };
	
	                    setTimeout(function () {
	                        pulseInterval = setInterval(function () {
	                            pulse(Math.floor(Date.now() / duration) % 2 === 0);
	                        }, duration);
	                        pulse(Math.floor(Date.now() / duration) % 2 === 0);
	
	                        var textInfo = _this12.layoutData.infoSettings.text;
	                        var position = group.translateToGivenOrigin({
	                            x: group.left,
	                            y: group.top
	                        }, group.originX, group.originY, "center", "bottom");
	
	                        var clickText = new fabric.Textbox("Click!", {
	                            originX: "center",
	                            originY: "center",
	                            left: position.x,
	                            top: position.y - 17,
	                            fontFamily: textInfo.fontFamily,
	                            fontSize: 12,
	                            textAlign: textInfo.alignment,
	                            stroke: "#162957"
	                        });
	
	                        group.addWithUpdate(clickText);
	                    }, Math.max(delay - duration, 0));
	                }
	            };
	
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = this.employeeSpots[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var group = _step2.value;
	
	                    _loop(group);
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	
	            this.canvas.requestRenderAll();
	        }
	    }, {
	        key: "drawDebugInfo",
	        value: function drawDebugInfo(text, position, color) {
	            var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	
	            if (false) {
	                var debugText = new fabric.Textbox(text, {
	                    originX: "center",
	                    originY: "center",
	                    left: position.x + offset,
	                    top: position.y + offset,
	
	                    fontFamily: "Rubik",
	                    fontSize: 24,
	                    textAlign: "center",
	                    stroke: color,
	                    fill: color
	                });
	
	                this.debugGroup.addWithUpdate(debugText);
	            }
	        }
	    }, {
	        key: "getSectorForKey",
	        value: function getSectorForKey(key) {
	            for (var i = 0; i < this.sectors.length; i++) {
	                var sector = this.sectors[i];
	
	                if (sector.key === key) {
	                    return sector;
	                }
	            }
	
	            log.error("Failed to find sector for key [%s]", key);
	
	            return null;
	        }
	    }, {
	        key: "loadSvg",
	        value: function loadSvg(source, svgOptions, fromString) {
	            return new Promise(function (resolve, reject) {
	                function onComplete(objects, options) {
	                    if (_utils2.default.isNotNull(svgOptions)) {
	                        options = _extends({}, options, svgOptions);
	                    }
	
	                    var obj = fabric.util.groupSVGElements(objects, options);
	
	                    obj.originX = options.originX || "left";
	                    obj.originY = options.originY || "top";
	                    obj.top = options.top || 0;
	                    obj.left = options.left || 0;
	
	                    obj.width = options.width || obj.width;
	                    obj.height = options.height || obj.height;
	
	                    // obj.evented = that.evented;
	                    // obj.setCoords();
	
	                    resolve(obj);
	                }
	
	                function addSvgProperties(el, obj) {
	                    obj.id = el.getAttribute("id");
	                }
	
	                if (fromString) {
	                    fabric.loadSVGFromString(source, onComplete, addSvgProperties);
	                } else {
	                    fabric.loadSVGFromURL(source, onComplete, addSvgProperties);
	                }
	            });
	        }
	    }, {
	        key: "loadImage",
	        value: function loadImage(source, options) {
	            return new Promise(function (resolve, reject) {
	                var img = new Image();
	                img.src = "";
	                img.onload = function () {
	                    var fabricImage = new fabric.Image(this, options);
	                    resolve(fabricImage);
	                };
	                img.onerror = reject;
	                img.src = source;
	            });
	        }
	    }, {
	        key: "reset",
	        value: function reset() {
	            this.abortAnimations();
	        }
	    }, {
	        key: "abortAnimations",
	        value: function abortAnimations() {
	            this.shouldAbortAnimations = true;
	
	            for (var i = 0; i < this.sectors.length; i++) {
	                this.sectors[i].abortAnimations();
	            }
	        }
	    }, {
	        key: "addGridToCanvas",
	        value: function addGridToCanvas(gridSize) {
	            var width = this.canvas.width,
	                height = this.canvas.height;
	
	            var gridGroup = [];
	
	            for (var i = 0; i < width / gridSize; i++) {
	                var x = i * gridSize;
	
	                gridGroup.push(new fabric.Line([x, 0, x, height], { stroke: "#ddd" }));
	
	                gridGroup.push(new fabric.Text(x + "", {
	                    left: x,
	                    top: 0,
	                    textAlign: "center",
	                    fontSize: 10,
	                    fontFamily: "Helvetica Nue, Helvetica, Sans-Serif, Arial, Trebuchet MS"
	                }));
	            }
	
	            for (var _i = 0; _i < height / gridSize; _i++) {
	                var y = _i * gridSize;
	
	                gridGroup.push(new fabric.Line([0, y, width, y], { stroke: "#ddd" }));
	
	                gridGroup.push(new fabric.Text(y + "", {
	                    left: 0,
	                    top: y,
	                    textAlign: "center",
	                    fontSize: 10,
	                    fontFamily: "Helvetica Nue, Helvetica, Sans-Serif, Arial, Trebuchet MS"
	                }));
	            }
	
	            this.canvas.add(new fabric.Group(gridGroup, {
	                hasBorders: false,
	                hasControls: false,
	                selectable: false,
	                evented: false,
	                reference: false,
	                movable: false
	            }));
	        }
	    }, {
	        key: "destroy",
	        value: function destroy() {
	            this.canvas.clear();
	            this.canvas.dispose();
	            this.canvas = null;
	        }
	    }, {
	        key: "setUpAutoResize",
	        value: function setUpAutoResize() {
	            this.fitToContainer();
	
	            var resizeFunction = _utils2.default.debounce(this.fitToContainer, 250, false, this);
	            window.addEventListener("resize", resizeFunction, false);
	        }
	    }, {
	        key: "fitToContainer",
	        value: function fitToContainer(e) {
	            // Note: using fabric canvas zoom causes blurriness for some reason, manually resize canvas doesn't (not sure if this breaks something else though)
	            // Note²: using `imageSmoothingEnabled: false` has an even better result (event with the fabricjs zooming)
	            // Best to worst quality (sharpness):
	            //    1. imageSmoothingEnabled: false with fabricjs zooming
	            //    2. imageSmoothingEnabled: false with manual canvas scaling
	            //    3. imageSmoothingEnabled: true (default) with manual canvas scaling
	            //    4. imageSmoothingEnabled: true (default) with fabricjs zooming
	            var $window = $(window);
	            // let containerWidth = Math.min(this.layoutData.size.width, this.containerElement.width());
	            // let windowHeight = Math.min(this.layoutData.size.height, $window.height());
	            var containerWidth = Math.min(this.layoutData.size.width, this.containerElement.width());
	            var windowHeight = Math.min(this.layoutData.size.height, this.containerElement.height());
	
	            if (_utils2.default.isFunction(this.availableCanvasSize)) {
	                var availableSize = this.availableCanvasSize(this);
	                containerWidth = _utils2.default.isNotNull(availableSize.width) ? availableSize.width : containerWidth;
	                windowHeight = _utils2.default.isNotNull(availableSize.height) ? availableSize.height : windowHeight;
	            }
	
	            var scaleRatio = Math.min(containerWidth / this.layoutData.size.width, windowHeight / this.layoutData.size.height);
	
	            log.debug("Resizing canvas to fit container:\nWidth: %f\nHeight: %f\nScale: %f", this.containerElement.width(), this.containerElement.height(), scaleRatio);
	
	            if (scaleRatio > 0) {
	                var oldWidth = this.canvas.width,
	                    oldHeight = this.canvas.height;
	
	                var newWidth = this.layoutData.size.width * scaleRatio,
	                    newHeight = this.layoutData.size.height * scaleRatio;
	
	                this.canvas.setDimensions({ width: newWidth, height: newHeight });
	                this.canvas.setZoom(scaleRatio);
	
	                if (_utils2.default.isFunction(this.onCanvasSizeChanged)) {
	                    this.onCanvasSizeChanged(oldWidth, oldHeight, newWidth, newHeight);
	                }
	            }
	
	            // let initialWidth = this.layoutData.size.width;
	            // let initialHeight = this.layoutData.size.height;
	            //
	            // let $container = this.containerElement;
	            //
	            // let containerElement = this.containerElement.find(".canvas-container");
	            //
	            // resizeCanvas($container.find("canvas").get(0));
	            // resizeCanvas($container.find("canvas").get(1));
	            //
	            // function resizeCanvas(canvas)
	            // {
	            //   let newWidth = null;
	            //   let newHeight = null;
	            //
	            //   let $window = $(window);
	            //   let windowWidth = $window.width(),
	            //     windowHeight = $window.height(),
	            //     windowRatio = windowWidth / windowHeight;
	            //
	            //   let width = Math.min($container.width(), initialWidth);
	            //   let height = initialHeight / initialWidth * width;
	            //
	            //   let wratio = width / height;
	            //   let ratio = initialWidth / initialHeight;
	            //
	            //   if(windowRatio < wratio)
	            //   {
	            //     newWidth = width;
	            //     newHeight = width / ratio;
	            //   }
	            //   else
	            //   {
	            //     height = Math.max(windowHeight, initialHeight);
	            //     width = initialWidth / initialHeight * height;
	            //
	            //     newWidth = width;
	            //     newHeight = height;
	            //   }
	            //
	            //   if(newWidth !== null && newHeight !== null)
	            //   {
	            //     canvas.style.width = newWidth + "px";
	            //     canvas.style.height = newHeight + "px";
	            //
	            //     containerElement.css("width", newWidth + "px");
	            //     containerElement.css("height", newHeight + "px");
	            //   }
	            // }
	        }
	    }, {
	        key: "getFactoryForKey",
	        value: function getFactoryForKey(key) {
	            if (_utils2.default.isNull(key)) return null;
	
	            return this.factories.find(function (f) {
	                return f.key === key;
	            });
	        }
	    }, {
	        key: "getFactoryForName",
	        value: function getFactoryForName(name) {
	            if (_utils2.default.isNull(name)) return null;
	
	            return this.factories.find(function (f) {
	                return f.name === name;
	            });
	        }
	    }, {
	        key: "getFreeEmployees",
	        value: function getFreeEmployees() {
	            return this.roundOverview.currentRoundData.employees - this.roundOverview.currentRoundData.usedEmployees;
	        }
	    }, {
	        key: "getEmployeeCountForFactory",
	        value: function getEmployeeCountForFactory(factoryName) {
	            var _this13 = this;
	
	            try {
	                var factoryRoundData = this.team.factoryRoundData.find(function (e) {
	                    return e.roundIndex === _this13.team.currentRound && e.factoryKey === _this13.getFactoryForName(factoryName).key;
	                });
	
	                return factoryRoundData !== undefined ? factoryRoundData.usedEmployees : 0;
	            } catch (e) {
	                log.error(e);
	            }
	            return 0;
	        }
	    }, {
	        key: "canEmployMicrochipFactory",
	        value: function canEmployMicrochipFactory() {
	            var red = this.roundOverview.currentRoundData.resourceRed;
	            var yellow = this.roundOverview.currentRoundData.resourceYellow;
	            var purple = this.roundOverview.currentRoundData.resourcePurple;
	
	            if (_investmentsView2.default.hasPurchasedInvestment(this.team, { title: "microchip_efficiency" })) {
	                return Math.min(red, 1) + Math.min(yellow, 1) + Math.min(purple, 1) >= 2;
	            }
	
	            if (_investmentsView2.default.hasPurchasedInvestment(this.team, { title: "microchip_substitution" })) {
	                return Math.min(red, 2) + Math.min(yellow, 2) + Math.min(purple, 2) >= 3;
	            }
	
	            return red > 0 && yellow > 0 && purple > 0;
	        }
	    }, {
	        key: "canEmploySecondaryFactory",
	        value: function canEmploySecondaryFactory() {
	            if (this.roundOverview.currentRoundData.resourceMicrochip > 0) {
	                if (_investmentsView2.default.hasPurchasedInvestment(this.team, { title: "phone_factory" })) {
	                    if (_investmentsView2.default.hasPurchasedInvestment(this.team, { title: "phone_efficiency" })) {
	                        return true;
	                    }
	
	                    if (_investmentsView2.default.hasPurchasedInvestment(this.team, { title: "phone_substitution" })) {
	                        return this.roundOverview.currentRoundData.resourceRed > 0 || this.roundOverview.currentRoundData.resourceYellow > 0 || this.roundOverview.currentRoundData.resourcePurple > 0;
	                    }
	
	                    return this.roundOverview.currentRoundData.resourceYellow > 0;
	                }
	
	                if (_investmentsView2.default.hasPurchasedInvestment(this.team, { title: "bike_factory" })) {
	                    if (_investmentsView2.default.hasPurchasedInvestment(this.team, { title: "bike_efficiency" })) {
	                        return this.roundOverview.currentRoundData.resourceRed > 0 || this.roundOverview.currentRoundData.resourcePurple > 0;
	                    }
	
	                    if (_investmentsView2.default.hasPurchasedInvestment(this.team, { title: "bike_substitution" })) {
	                        var red = Math.min(this.roundOverview.currentRoundData.resourceRed, 2);
	                        var yellow = Math.min(this.roundOverview.currentRoundData.resourceYellow, 1);
	                        var purple = Math.min(this.roundOverview.currentRoundData.resourcePurple, 2);
	
	                        return red + yellow + purple >= 2;
	                    }
	
	                    return this.roundOverview.currentRoundData.resourceRed > 0 && this.roundOverview.currentRoundData.resourcePurple > 0;
	                }
	            }
	
	            return false;
	        }
	    }, {
	        key: "canEmployReuseFacility",
	        value: function canEmployReuseFacility() {
	            if (this.getMarketProductCount("microchip") > 0) {
	                return true;
	            }
	
	            if (_investmentsView2.default.hasPurchasedInvestment(this.team, { title: "product_refurbishing" })) {
	                if (_investmentsView2.default.hasPurchasedInvestment(this.team, { title: "phone_factory" })) {
	                    return this.getMarketProductCount("phone") > 0 && this.roundOverview.currentRoundData.resourcePurple > 0;
	                }
	
	                if (_investmentsView2.default.hasPurchasedInvestment(this.team, { title: "bike_factory" })) {
	                    return this.getMarketProductCount("bike") > 0 && this.roundOverview.currentRoundData.resourcePurple > 0;
	                }
	            }
	
	            return false;
	        }
	    }, {
	        key: "canRentProducts",
	        value: function canRentProducts() {
	            if (_investmentsView2.default.hasPurchasedInvestment(this.team, { title: "phone_factory" }) && this.roundOverview.currentRoundData.resourcePhone > 0) {
	                return true;
	            }
	
	            if (_investmentsView2.default.hasPurchasedInvestment(this.team, { title: "bike_factory" }) && this.roundOverview.currentRoundData.resourceBike > 0) {
	                return true;
	            }
	
	            var rental = JSON.parse(this.roundOverview.currentRoundData.rental);
	            if (rental) {
	                return rental.phase1 + rental.phase2 > 0 || rental.phase3 > 0 && this.roundOverview.currentRoundData.resourceRed > 0;
	            }
	            return false;
	        }
	    }, {
	        key: "getRentalProductCountForPhase",
	        value: function getRentalProductCountForPhase(phase) {
	            var rental = JSON.parse(this.roundOverview.currentRoundData.rental);
	
	            if (!rental) {
	                return 0;
	            }
	
	            switch (phase) {
	                case 1:
	                    return rental.phase1;
	                case 2:
	                    return rental.phase2;
	                case 3:
	                    return rental.phase3;
	            }
	            return 0;
	        }
	    }, {
	        key: "getMarketProductCount",
	        value: function getMarketProductCount(product) {
	            var market = JSON.parse(this.roundOverview.currentRoundData.market);
	
	            if (!market) {
	                return 0;
	            }
	
	            switch (product) {
	                case "microchip":
	                    return market.microchip || 0;
	                case "phone":
	                    return market.phone || 0;
	                case "bike":
	                    return market.bike || 0;
	            }
	
	            return 0;
	        }
	    }, {
	        key: "getFreeEmployeeSpotCount",
	        value: function getFreeEmployeeSpotCount() {
	            return this.employeeSpots.filter(function (group) {
	                return group.spotCanBeUsed;
	            }).length;
	        }
	    }, {
	        key: "income",
	        set: function set(value) {
	            if (!_utils2.default.isNumber(value)) {
	                value = parseInt(value);
	                value = _utils2.default.isNumber(value) ? value : 0;
	            }
	
	            this._income = value;
	        },
	        get: function get() {
	            return this._income;
	        }
	    }]);
	
	    return BusinessModel;
	}();
	
	exports.default = BusinessModel;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 327:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _gameView = __webpack_require__(13);
	
	var _gameView2 = _interopRequireDefault(_gameView);
	
	var _rankingScreen = __webpack_require__(808);
	
	var _rankingScreen2 = _interopRequireDefault(_rankingScreen);
	
	var _utils = __webpack_require__(4);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by fd on 2021-09-21 (10:00).
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var log = __webpack_require__(7)();
	
	__webpack_require__(759);
	
	var RankingScreen = function (_GameView) {
	    _inherits(RankingScreen, _GameView);
	
	    function RankingScreen(options) {
	        _classCallCheck(this, RankingScreen);
	
	        options.html = $(_rankingScreen2.default);
	
	        var _this = _possibleConstructorReturn(this, (RankingScreen.__proto__ || Object.getPrototypeOf(RankingScreen)).call(this, options));
	
	        _this.platform = options.platform || "student";
	        _this.hasAWinner = false;
	        _this.path = "ranking";
	        _this.team = options.team;
	        _this.teams = options.teams;
	        _this.roundOverview = options.roundOverview;
	        _this.roundIndex = options.roundIndex;
	
	        _this.factCount = 3;
	        _this.factIndex = Math.floor(Math.random() * 3);
	
	        setInterval(function () {
	            _this.showFact();
	        }, 1 * 60 * 1000);
	        return _this;
	    }
	
	    _createClass(RankingScreen, [{
	        key: "updateTeamList",
	        value: function updateTeamList(teamList) {
	            this.teams = teamList;
	
	            if (!this.hasRendered) {
	                this.render();
	            }
	
	            this.update();
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            _get(RankingScreen.prototype.__proto__ || Object.getPrototypeOf(RankingScreen.prototype), "render", this).call(this);
	            this._setUpEventListeners();
	
	            this.update();
	
	            this.onRender();
	
	            this.showFact();
	        }
	    }, {
	        key: "update",
	        value: function update() {
	            var winnerContainer = this.$element.find("#ranking-winner-container");
	
	            winnerContainer.hide();
	            $("#home-button-container").hide();
	
	            this.renderRankingTable();
	
	            if (this.hasAWinner) {
	                winnerContainer.show();
	            }
	
	            if (this.hasAWinner && this.platform === "student") {
	                // $("#home-button-container").show();
	            }
	        }
	    }, {
	        key: "show",
	        value: function show(darkMode) {
	            $("#btn-next-phase").prop("disabled", "disabled");
	
	            if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	                this.update();
	            }
	        }
	    }, {
	        key: "hide",
	        value: function hide() {
	            if (_utils2.default.isNotNull(this.$container) && this.$container.length) {
	                this.$container.hide();
	            }
	        }
	    }, {
	        key: "renderRankingTable",
	        value: function renderRankingTable() {
	            var container = this.$element.find(".ranking-table");
	            var base = this.$element.find("#ranking-cell-base");
	
	            container.find(".ranking-cell").remove();
	
	            log.info("RANKING SCREEN UPDATE");
	            log.info(this.teams);
	            log.info(this.team);
	
	            var sortedTeams = [];
	            var round = -1;
	            var allInSameRound = true;
	
	            if (this.team && this.team.currentRound) {
	                round = this.team.currentRound;
	            }
	
	            for (var i = 0; i < this.teams.length; i++) {
	                var team = this.teams[i];
	                var teamData = this.getCommonDataForTeam(team);
	                var roundScore = this.getCurrentRoundScore(teamData);
	
	                if (_utils2.default.isNotNull(roundScore)) {
	                    if (round === -1) {
	                        round = roundScore.round;
	                    } else if (round !== roundScore.round) {
	                        allInSameRound = false;
	                    }
	                } else {
	                    allInSameRound = false;
	                }
	            }
	
	            if (allInSameRound || this.platform === "teacher") {
	                this.$element.find("#ranking-waiting-container").hide();
	            } else {
	                this.$element.find("#ranking-waiting-container").show();
	            }
	
	            this.hasAWinner = allInSameRound && round === 11;
	
	            // gather the teamnames, VP's and credits
	            for (var _i = 0; _i < this.teams.length; _i++) {
	                var _team = this.teams[_i];
	                var _teamData = this.getCommonDataForTeam(_team);
	                var _roundScore = this.getCurrentRoundScore(_teamData);
	
	                if (_utils2.default.isNotNull(_roundScore)) {
	                    var tmpPoints = _roundScore.endPoints;
	                    var tmpCredits = _roundScore.endCredits;
	
	                    var ratio = Math.floor(tmpCredits / 5);
	                    var pointsFromCredits = ratio;
	                    var remainingCredits = tmpCredits - ratio * 5;
	
	                    var points = tmpPoints + pointsFromCredits;
	
	                    var sortedTeam = {
	                        teamName: _team,
	                        tmpPoints: tmpPoints,
	                        tmpCredits: tmpCredits,
	                        points: points,
	                        credits: remainingCredits,
	                        currentRound: _roundScore.round
	                    };
	
	                    sortedTeams.push(sortedTeam);
	                }
	            }
	
	            if (false) {
	                for (var _i2 = sortedTeams.length; _i2 < 35; ++_i2) {
	                    sortedTeams.push({
	                        teamName: "__DEV-TEAM__",
	                        tmpPoints: 0,
	                        tmpCredits: 0,
	                        points: 0,
	                        credits: 0,
	                        currentRound: round
	                    });
	                }
	            }
	
	            sortedTeams.sort(function (a, b) {
	                if (a.currentRound !== b.currentRound) {
	                    return b.currentRound - a.currentRound;
	                }
	
	                if (a.points < b.points) {
	                    return 1;
	                } else if (a.points > b.points) {
	                    return -1;
	                }
	
	                if (a.credits < b.credits) {
	                    return 1;
	                } else if (a.credits > b.credits) {
	                    return -1;
	                }
	
	                return 0;
	            });
	
	            log.info(sortedTeams);
	
	            for (var _i3 = 0; _i3 < sortedTeams.length; _i3++) {
	                var _team2 = sortedTeams[_i3];
	                var clone = base.clone();
	
	                clone.removeAttr("id");
	
	                if (_team2 === this.team) {
	                    clone.addClass("ranking-cell-own-team");
	                }
	
	                var teamLabel = clone.find(".ranking-cell-name");
	                var rankLabel = clone.find(".ranking-cell-icon > .ranking-label-container");
	                var rankTrophy = clone.find(".ranking-cell-icon > img");
	                var rankLoading = clone.find(".ranking-cell-icon > i");
	
	                teamLabel.text(_team2.teamName);
	
	                rankLabel.hide();
	                rankTrophy.hide();
	                rankLoading.hide();
	
	                if (this.hasAWinner && _i3 === 0) {
	                    rankTrophy.show();
	                } else if (_team2.currentRound !== round) {
	                    rankLoading.show();
	                } else {
	                    rankLabel.show();
	                    rankLabel.find("label").text(_i3 + 1);
	                }
	
	                clone.find(".ranking-cell-resource").hide();
	                clone.find(".ranking-cell-round").hide();
	
	                if (_team2.currentRound !== round) {
	                    // clone.addClass("not-in-same-round");
	                    clone.find(".ranking-cell-round").show();
	                    clone.find(".ranking-cell-round .current-round").text(_team2.currentRound + 1 + 1); // First because of null based, second because last known round is the finished round
	                } else {
	                    clone.find(".ranking-cell-resource").show();
	                    clone.find(".ranking-coins-label").text(_team2.tmpCredits);
	                    clone.find(".ranking-vp-label").text(_team2.tmpPoints).data("real-value", _team2.points);
	                }
	
	                container.append(clone);
	            }
	
	            clearTimeout(this.animationId);
	
	            if (this.hasAWinner) {
	                this.animationId = setTimeout(function () {
	                    var cellList = container.find(".ranking-cell");
	
	                    for (var _i4 = 0; _i4 < cellList.length; ++_i4) {
	                        var cell = $(cellList[_i4]);
	
	                        updatePointsAndVPs(cell);
	                    }
	                }, 2000);
	            }
	
	            function updatePointsAndVPs(cell) {
	                cell.addClass("updating");
	
	                setTimeout(function () {
	                    var coinsLabel = cell.find(".ranking-coins-label");
	                    var pointsLabel = cell.find(".ranking-vp-label");
	
	                    var currentCoins = parseInt(coinsLabel.text());
	                    var currentPoints = parseInt(pointsLabel.text());
	
	                    var points = pointsLabel.data("real-value");
	
	                    cell.removeClass("updating");
	
	                    if (currentPoints < points) {
	                        coinsLabel.text(currentCoins - 5);
	                        pointsLabel.text(currentPoints + 1);
	
	                        updatePointsAndVPs(cell);
	                    }
	                }, 100);
	            }
	        }
	    }, {
	        key: "getCurrentRoundScore",
	        value: function getCurrentRoundScore(teamData) {
	            if (_utils2.default.isNull(teamData) || _utils2.default.isNull(teamData.roundScores)) return null;
	
	            var roundScore = null;
	
	            for (var j = teamData.roundScores.length - 1; j >= 0; j--) {
	                if ((_utils2.default.isNull(this.roundIndex) || teamData.roundScores[j].round === this.roundIndex) && teamData.state.currentRound >= teamData.roundScores[j].round) {
	                    roundScore = teamData.roundScores[j];
	                    break;
	                }
	            }
	
	            return roundScore;
	        }
	    }, {
	        key: "_setUpEventListeners",
	        value: function _setUpEventListeners() {}
	    }, {
	        key: "getCommonDataForTeam",
	        value: function getCommonDataForTeam(teamName) {
	            if (_utils2.default.isNull(this.roundOverview) || _utils2.default.isNull(this.roundOverview.commonTeamData)) return null;
	
	            for (var i = 0; i < this.roundOverview.commonTeamData.length; i++) {
	                var teamData = this.roundOverview.commonTeamData[i];
	
	                if (teamData.teamName === teamName) {
	                    return teamData;
	                }
	            }
	
	            return null;
	        }
	    }, {
	        key: "showFact",
	        value: function showFact() {
	            ++this.factIndex;
	
	            var index = this.factIndex % this.factCount + 1;
	
	            var factTitle = _languageManager2.default.getValueForKey("serious_game.business_model.loading.fact." + index + ".title");
	            var factDescription = _languageManager2.default.getValueForKey("serious_game.business_model.loading.fact." + index + ".description");
	
	            this.$element.find(".current-fact-title").html(factTitle);
	            this.$element.find(".current-fact-description").html(factDescription);
	        }
	    }]);
	
	    return RankingScreen;
	}(_gameView2.default);
	
	module.exports = RankingScreen;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _gameView = __webpack_require__(13);
	
	var _gameView2 = _interopRequireDefault(_gameView);
	
	var _infoMarket = __webpack_require__(816);
	
	var _infoMarket2 = _interopRequireDefault(_infoMarket);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by fd on 2021-09-22 (13:39).
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	__webpack_require__(747);
	
	var InfoMarketView = function (_GameView) {
	    _inherits(InfoMarketView, _GameView);
	
	    function InfoMarketView(options) {
	        _classCallCheck(this, InfoMarketView);
	
	        options.html = $(_infoMarket2.default);
	
	        var _this = _possibleConstructorReturn(this, (InfoMarketView.__proto__ || Object.getPrototypeOf(InfoMarketView)).call(this, options));
	
	        _this.event = options.event;
	
	        _this.secondaryType = options.secondaryType || undefined;
	        _this.market = options.market || undefined;
	        return _this;
	    }
	
	    _createClass(InfoMarketView, [{
	        key: "render",
	        value: function render() {
	            _get(InfoMarketView.prototype.__proto__ || Object.getPrototypeOf(InfoMarketView.prototype), "render", this).call(this);
	
	            this.$element.find(".resource-microchip").show();
	            this.$element.find(".resource-phone").hide();
	            this.$element.find(".resource-bike").hide();
	
	            if (this.secondaryType === "phone") {
	                this.$element.find(".resource-phone").show();
	            } else if (this.secondaryType === "bike") {
	                this.$element.find(".resource-bike").show();
	            }
	
	            if (this.market) {
	                this.$element.find(".market-count-microchip").text(this.market.microchip);
	                this.$element.find(".market-count-phone").text(this.market.phone);
	                this.$element.find(".market-count-bike").text(this.market.bike);
	            }
	        }
	    }]);
	
	    return InfoMarketView;
	}(_gameView2.default);
	
	module.exports = InfoMarketView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 329:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _gameView = __webpack_require__(13);
	
	var _gameView2 = _interopRequireDefault(_gameView);
	
	var _infoMining = __webpack_require__(817);
	
	var _infoMining2 = _interopRequireDefault(_infoMining);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by fd on 2021-09-22 (13:39).
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var resourceIcons = __webpack_require__(63);
	
	__webpack_require__(748);
	
	var InfoMiningView = function (_GameView) {
	    _inherits(InfoMiningView, _GameView);
	
	    function InfoMiningView(options) {
	        _classCallCheck(this, InfoMiningView);
	
	        options.html = $(_infoMining2.default);
	
	        var _this = _possibleConstructorReturn(this, (InfoMiningView.__proto__ || Object.getPrototypeOf(InfoMiningView)).call(this, options));
	
	        _this.event = options.event;
	
	        options.html.find(".info-mode").hide();
	        options.html.find(".feedback-mode").hide();
	
	        options.html.find("." + options.mode + "-mode").show();
	
	        if (options.mode === "feedback") {
	            // options.html.find(".feedback-mode img").hide();
	
	            var resources = options.data.data.resources;
	
	            options.html.find(".feedback-mode").empty();
	
	            for (var i = 0; i < resources["resource_red"]; ++i) {
	                var img = $("<img src='" + resourceIcons("./resource_red.svg") + "' />");
	                options.html.find(".feedback-mode").append(img);
	            }
	
	            for (var _i = 0; _i < resources["resource_yellow"]; ++_i) {
	                var _img = $("<img src='" + resourceIcons("./resource_yellow.svg") + "' />");
	                options.html.find(".feedback-mode").append(_img);
	            }
	
	            for (var _i2 = 0; _i2 < resources["resource_purple"]; ++_i2) {
	                var _img2 = $("<img src='" + resourceIcons("./resource_purple.svg") + "' />");
	                options.html.find(".feedback-mode").append(_img2);
	            }
	
	            var sum = resources["resource_red"] + resources["resource_yellow"] + resources["resource_purple"];
	            if (sum === 1) {
	                options.html.find(".feedback-mode.popup-message").attr("data-localize", "info.mining.feedback.single");
	            } else {
	                options.html.find(".feedback-mode.popup-message").attr("data-localize", "info.mining.feedback");
	            }
	        }
	        return _this;
	    }
	
	    return InfoMiningView;
	}(_gameView2.default);
	
	module.exports = InfoMiningView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _gameView = __webpack_require__(13);
	
	var _gameView2 = _interopRequireDefault(_gameView);
	
	var _infoWasteDepot = __webpack_require__(818);
	
	var _infoWasteDepot2 = _interopRequireDefault(_infoWasteDepot);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by fd on 2021-09-22 (13:39).
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	__webpack_require__(749);
	
	var InfoWasteDepotView = function (_GameView) {
	  _inherits(InfoWasteDepotView, _GameView);
	
	  function InfoWasteDepotView(options) {
	    _classCallCheck(this, InfoWasteDepotView);
	
	    options.html = $(_infoWasteDepot2.default);
	
	    var _this = _possibleConstructorReturn(this, (InfoWasteDepotView.__proto__ || Object.getPrototypeOf(InfoWasteDepotView)).call(this, options));
	
	    _this.event = options.event;
	    return _this;
	  }
	
	  return InfoWasteDepotView;
	}(_gameView2.default);
	
	module.exports = InfoWasteDepotView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 331:
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Created by jv on 14/06/2017.
	 */
	module.exports = {
	  DEFAULT_LOCALE: "en-GB",
	
	  API_DATE_FORMAT: "YYYY-MM-DDTHH:mm:ss.SSSZZ",
	  READABLE_DATE_FORMAT: "DD-MM-YYYY",
	
	  // 50mb
	  // MAX_UPLOAD_FILE_SIZE: 52428800,
	  // 100mb
	  // MAX_UPLOAD_FILE_SIZE: 104857600,
	  // 250mb
	  MAX_UPLOAD_FILE_SIZE: 262144000,
	
	  BM_TRANSITION_SPEED: 300,
	
	  MOVEMENTS: {
	    HORIZONTAL: "horizontal",
	    VERTICAL: "vertical",
	    DIAGONAL: "diagonal"
	  },
	
	  DIRECTIONS: {
	    UP: "up",
	    DOWN: "down",
	    LEFT: "left",
	    RIGHT: "right"
	  },
	
	  BUSINESS_MODEL_ACTIONS: {
	    ACTIVATE: "activate",
	    DEACTIVATE: "deactivate"
	  }
	};

/***/ }),

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(4);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _appError = __webpack_require__(234);
	
	var _appError2 = _interopRequireDefault(_appError);
	
	var _historyController = __webpack_require__(511);
	
	var _historyController2 = _interopRequireDefault(_historyController);
	
	var _analytics = __webpack_require__(512);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 2019-09-09 (12:33).
	 */
	var log = __webpack_require__(7)();
	
	var GamePageController = function () {
	  function GamePageController(options) {
	    _classCallCheck(this, GamePageController);
	
	    if (_utils2.default.isNull(options) || !_utils2.default.isArray(options.gameViews) || options.gameViews.length === 0) {
	      throw new _appError2.default({ exception: new Error("GamePageController needs valid options object with at least 1 gameView") });
	    }
	
	    this.gameViews = options.gameViews;
	    this.defaultView = options.defaultView ? options.defaultView : this.gameViews[0];
	
	    this.basePath = options.basePath ? options.basePath : "";
	
	    this.onBeforePageChange = options.onBeforePageChange;
	    this.onContentShow = options.onContentShow;
	
	    this.initialPage = options.initialPage;
	
	    this.currentGameView = null;
	  }
	
	  _createClass(GamePageController, [{
	    key: "init",
	    value: function init() {
	      this._setInitialPage();
	      this._setUpEventListeners();
	    }
	  }, {
	    key: "changePage",
	    value: function changePage(gameView, replaceState) {
	      // NOTE - browser navigation should be disabled, we don't want users to use the back/forward buttons
	      replaceState = true;
	
	      if (_utils2.default.isNull(gameView)) gameView = {};
	
	      log.info("Trying to change page to gameView [%s]\nreplaceState: %s", gameView.key, replaceState);
	
	      if (_utils2.default.isFunction(this.onBeforePageChange)) {
	        var allowContinue = this.onBeforePageChange(gameView);
	
	        if (!allowContinue) {
	          return;
	        }
	      }
	
	      var valid = this.validateView(gameView.key);
	
	      log.info("GameView '%s' valid ? %s", gameView.key, valid);
	
	      if (valid) {
	        var url = this.basePath + "/" + gameView.path;
	
	        if (replaceState) {
	          _historyController2.default.replaceState({
	            contentId: gameView.key
	          }, null, url);
	        } else {
	          _historyController2.default.pushState({
	            contentId: gameView.key
	          }, null, url);
	        }
	
	        _analytics2.default.setPage(url);
	
	        this.showContent(gameView);
	      }
	    }
	  }, {
	    key: "showContent",
	    value: function showContent(gameView) {
	      if (_utils2.default.isNull(gameView)) return;
	
	      var isValid = this.validateView(gameView.key);
	
	      if (!isValid) {
	        return;
	      }
	
	      for (var i = 0; i < this.gameViews.length; i++) {
	        this.gameViews[i].hide();
	      }
	
	      if (!gameView.hasRendered) {
	        gameView.render();
	      }
	
	      this.currentGameView = gameView;
	
	      if (_utils2.default.isFunction(this.onContentShow)) {
	        this.onContentShow.call(this, gameView);
	      }
	
	      if (gameView.key === "session-join") {
	        $("footer").removeClass("marketing").addClass("marketing");
	        $("footer div.container").show();
	      } else {
	        $("footer").removeClass("marketing");
	        $("footer div.container").hide();
	      }
	    }
	  }, {
	    key: "validatePath",
	    value: function validatePath(path) {
	      if (_utils2.default.isNotNull(path)) {
	        path = path.replace(this.basePath + "/", "");
	
	        // TODO validate path
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: "validateView",
	    value: function validateView(gameViewKey) {
	      if (_utils2.default.isNotNull(gameViewKey)) {
	        for (var i = 0; i < this.gameViews.length; i++) {
	          if (this.gameViews[i].key === gameViewKey) {
	            return true;
	          }
	        }
	      }
	
	      return false;
	    }
	  }, {
	    key: "_setInitialPage",
	    value: function _setInitialPage() {
	      var pathName = this.initialPage || _utils2.default.getUrlPath();
	
	      var isValid = this.validatePath(pathName);
	
	      log.info("Path '%s' is %s", pathName, isValid ? "valid" : "not valid");
	
	      if (isValid) {
	        var foundGameView = null;
	
	        for (var i = 0; i < this.gameViews.length; i++) {
	          if (pathName.includes(this.gameViews[i].path)) {
	            foundGameView = this.gameViews[i];
	            break;
	          }
	        }
	
	        if (_utils2.default.isNotNull(foundGameView)) {
	          if (_utils2.default.isNull(this.initialPage) || this.initialPage === _utils2.default.getUrlPath()) {
	            this.showContent(foundGameView);
	          } else {
	            this.changePage(foundGameView, true);
	          }
	        } else {
	          this.changePage(this.defaultView, true);
	        }
	      } else {
	        this.changePage(this.defaultView, true);
	      }
	    }
	  }, {
	    key: "_setUpEventListeners",
	    value: function _setUpEventListeners() {
	      var _this = this;
	
	      $(window).on("popstate", function (event) {
	        log.info(event);
	        log.info("On popstate - state: %o", event.originalEvent.state);
	
	        var contentId = void 0;
	        var valid = false;
	
	        if (_utils2.default.isNotNull(event.originalEvent.state)) {
	          valid = _this.validateView(event.originalEvent.state.contentId);
	          contentId = event.originalEvent.state.contentId;
	        }
	
	        if (valid) {
	          _this.showContent(contentId);
	        } else {
	          _this.changePage(_this.defaultView, true);
	        }
	      });
	    }
	  }]);
	
	  return GamePageController;
	}();
	
	module.exports = GamePageController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	/**
	 * Created by jv on 20/01/2017.
	 */
	var tooltip = {};
	
	(function (Tooltip) {
	  /*
	   *  options.selector
	   *  options.trigger
	   *  options.title
	   *  options.content
	   *  options.placement
	   */
	  Tooltip.create = function (options) {
	    $(options.selector).popover({
	      content: options.content,
	      title: options.title || "",
	      placement: options.placement || "auto",
	      trigger: options.trigger || "hover",
	      html: true
	    });
	  };
	
	  Tooltip.dispose = function (options) {
	    try {
	      $(options.selector).popover("dispose");
	    } catch (e) {
	      // ignore?: dispose sometimes gives nullpointer on removeChild //%TODO: find out why
	    }
	  };
	})(tooltip);
	
	module.exports = tooltip;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 510:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Created by jv on 16/01/2017.
	 */
	var config = {
	  serviceBaseURL: "/services",
	  something: {}
	};
	
	if (false) {
	  config.something.something = "";
	} else {
	  config.something.something = "";
	}
	
	module.exports = config;

/***/ }),

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Created by jv on 22/08/2017.
	 */
	var utils = __webpack_require__(4);
	
	var HistoryController = {};
	
	(function (HistoryController) {
	  var history = window.history;
	
	  HistoryController.currentState = function () {
	    if (utils.isNotNull(history)) {
	      return history.state;
	    }
	  };
	
	  HistoryController.back = function () {
	    if (utils.isNotNull(history)) {
	      history.back();
	    }
	  };
	
	  HistoryController.forward = function () {
	    if (utils.isNotNull(history)) {
	      history.forward();
	    }
	  };
	
	  HistoryController.go = function (index) {
	    if (utils.isNotNull(history)) {
	      history.go(index);
	    }
	  };
	
	  HistoryController.pushState = function (stateObj, title, url) {
	    if (utils.isNotNull(history)) {
	      history.pushState(stateObj, title, url);
	    }
	  };
	
	  HistoryController.replaceState = function (stateObj, title, url) {
	    if (utils.isNotNull(history)) {
	      history.replaceState(stateObj, title, url);
	    }
	  };
	})(HistoryController);
	
	module.exports = HistoryController;

/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Created by jv on 2019-09-09 (12:44).
	 */
	var Analytics = {};
	
	(function (Analytics) {
	  Analytics.setPage = function (url) {
	    if (false) {} else {
	      // ga("set", "page", url);
	      // ga("send", "pageview");
	    }
	  };
	})(Analytics);
	
	exports.default = Analytics;

/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Created by jv on 2019-09-09 (15:49).
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	var _utils = __webpack_require__(4);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var log = __webpack_require__(7)();
	
	var SOCKET_STATES = {
	  CONNECTING: WebSocket ? WebSocket.CONNECTING : 0,
	  OPEN: WebSocket ? WebSocket.OPEN : 1,
	  CLOSING: WebSocket ? WebSocket.CLOSING : 2,
	  CLOSED: WebSocket ? WebSocket.CLOSED : 3
	};
	
	var WebSocketClient = function () {
	  function WebSocketClient(options) {
	    _classCallCheck(this, WebSocketClient);
	
	    this.url = options.url;
	
	    this.onOpen = options.onOpen;
	    this.onClose = options.onClose;
	    this.onError = options.onError;
	    this.onMessage = options.onMessage;
	  }
	
	  _createClass(WebSocketClient, [{
	    key: "open",
	    value: function open() {
	      var _this = this;
	
	      this.socket = new WebSocket(this.url);
	
	      this.socket.onopen = function (event) {
	        return _this._onOpen(event);
	      };
	      this.socket.onmessage = function (event) {
	        return _this._onMessage(event);
	      };
	      this.socket.onclose = function (event) {
	        return _this._onClose(event);
	      };
	      this.socket.onerror = function (event) {
	        return _this._onError(event);
	      };
	    }
	  }, {
	    key: "close",
	    value: function close(code, reason) {
	      if (_utils2.default.isNotNull(this.socket) && this.socket.readyState === SOCKET_STATES.OPEN) {
	        this.socket.close(code, reason);
	      }
	    }
	  }, {
	    key: "isConnected",
	    value: function isConnected() {
	      if (_utils2.default.isNotNull(this.socket)) {
	        return this.socket.readyState === SOCKET_STATES.OPEN;
	      }
	
	      return false;
	    }
	  }, {
	    key: "isClosed",
	    value: function isClosed() {
	      if (_utils2.default.isNotNull(this.socket)) {
	        return this.socket.readyState === SOCKET_STATES.CLOSED;
	      }
	
	      return false;
	    }
	  }, {
	    key: "sendData",
	    value: function sendData(data) {
	      if (_utils2.default.isNotNull(this.socket) && this.isConnected()) {
	        this.socket.send(data);
	      }
	    }
	  }, {
	    key: "_onOpen",
	    value: function _onOpen(event) {
	      // log.debug("websocket connection established - %o", event);
	
	      if (_utils2.default.isFunction(this.onOpen)) {
	        this.onOpen.call(this, event);
	      }
	    }
	  }, {
	    key: "_onMessage",
	    value: function _onMessage(event) {
	      // log.debug("websocket messaged received - %o", event);
	
	      if (_utils2.default.isFunction(this.onMessage)) {
	        this.onMessage.call(this, event);
	      }
	    }
	  }, {
	    key: "_onClose",
	    value: function _onClose(event) {
	      // log.debug("websocket connection closed - %o", event);
	
	      if (_utils2.default.isFunction(this.onClose)) {
	        this.onClose.call(this, event);
	      }
	    }
	  }, {
	    key: "_onError",
	    value: function _onError() {
	      // log.error("websocket error occurred - %o", event);
	
	      if (_utils2.default.isFunction(this.onError)) {
	        this.onError.call(this, event);
	      }
	    }
	  }]);
	
	  return WebSocketClient;
	}();
	
	exports.default = WebSocketClient;

/***/ }),

/***/ 515:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 16/05/2017.
	 */
	var utils = __webpack_require__(4);
	
	var ANIMATION_DURATION = 300;
	
	module.exports = function () {
	  function DialogTemplate(options) {
	    _classCallCheck(this, DialogTemplate);
	
	    if (utils.isNull(options)) {
	      throw "options must be defined";
	    }
	
	    this.dialogId = utils.isNotNull(options.dialogId) ? options.dialogId : utils.generateUIDShort();
	    this.backdropIdSuffix = "-modal-backdrop";
	    this.title = options.title;
	    this.dialogContent = options.dialogContent;
	    this.disposable = utils.isBoolean(options.disposable) ? options.disposable : true;
	    this.extraModalContentClass = options.extraModalContentClass;
	
	    this.confirmText = options.confirmText;
	    this.cancelText = options.cancelText;
	    this.cancelTopRight = utils.isBoolean(options.cancelTopRight) ? options.cancelTopRight : false;
	
	    this.onConfirm = options.onConfirm;
	    this.onCancel = options.onCancel;
	    this.onDispose = options.onDispose;
	
	    this.create();
	  }
	
	  _createClass(DialogTemplate, [{
	    key: "create",
	    value: function create() {
	      if (this._initialized !== true) {
	        this.renderDialog();
	
	        this.backdrop = "<div id='" + this.backdropId + "' class='modal-backdrop fade show'></div>";
	
	        this.dialogEl.appendTo("body");
	
	        if (this.disposable) {
	          this.addDisposeListener();
	        }
	
	        this._initialized = true;
	      }
	    }
	  }, {
	    key: "renderDialog",
	    value: function renderDialog() {
	      this.dialogEl = $("<div id='" + this.dialogId + "' class='modal fade' style='display: block;'>" + "<div class='modal-dialog modal-dialog-centered'>" + "<div class='modal-content " + this.extraModalContentClass + " clearfix'>" + "</div>" + "</div>" + "</div>");
	
	      this.renderDialogHeader();
	      this.renderDialogContent();
	      this.renderDialogFooter();
	    }
	  }, {
	    key: "renderDialogHeader",
	    value: function renderDialogHeader() {
	      if (utils.isNotNull(this.title)) {
	        var dialogContentEl = this.dialogEl.find(".modal-content");
	
	        if (utils.isNotNull(dialogContentEl) && dialogContentEl.length) {
	          var dialogHeader = "<div class='modal-header'><h4 class='dialog-title'>" + this.title + "</h4></div>";
	          dialogContentEl.append(dialogHeader);
	        }
	      }
	    }
	  }, {
	    key: "renderDialogContent",
	    value: function renderDialogContent() {
	      var dialogContentEl = this.dialogEl.find(".modal-content");
	
	      if (utils.isNotNull(dialogContentEl) && dialogContentEl.length) {
	        var dialogBodyEl = $("<div class='modal-body'></div>");
	        dialogBodyEl.append(this.dialogContent);
	
	        dialogContentEl.append(dialogBodyEl);
	      }
	    }
	  }, {
	    key: "renderDialogFooter",
	    value: function renderDialogFooter() {
	      var that = this;
	      var dialogContentEl = that.dialogEl.find(".modal-content");
	
	      if (utils.isNotNull(dialogContentEl) && dialogContentEl.length) {
	        var dialogFooterEl = $("<div class='modal-footer'></div>");
	
	        if (utils.isNotNull(that.confirmText)) {
	          var confirmBtn = $("<button class='btn dialog-btn dialog-confirm-btn' type='button'>" + that.confirmText + "</button>");
	
	          confirmBtn.on("click", function (e) {
	            if (utils.isFunction(that.onConfirm)) {
	              that.onConfirm();
	            }
	          });
	
	          dialogFooterEl.append(confirmBtn);
	        }
	
	        if (utils.isNotNull(that.cancelText) || that.cancelTopRight === true) {
	          var classNames = "btn dialog-btn dialog-cancel-btn";
	          var innerHTML = that.cancelText;
	
	          if (that.cancelTopRight) {
	            classNames = "btn btn-icon frameless cross-circle dark-grey pull-right";
	            innerHTML = "";
	          }
	
	          var cancelBtn = $("<button class='" + classNames + "' type='button'>" + innerHTML + "</button>");
	
	          cancelBtn.on("click", function () {
	            that.cancel();
	          });
	
	          if (that.cancelTopRight) {
	            that.dialogEl.find(".modal-content").prepend(cancelBtn);
	          } else {
	            dialogFooterEl.append(cancelBtn);
	          }
	        }
	
	        dialogContentEl.append(dialogFooterEl);
	      }
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      var that = this;
	
	      if (utils.isNotNull(that.dialogEl) && that.dialogEl.length && that._destroying !== true) {
	        that._destroying = true;
	
	        that.hide(function () {
	          that.dialogEl.remove();
	          that._initialized = false;
	          that._destroying = false;
	        });
	      }
	    }
	  }, {
	    key: "show",
	    value: function show(addBackdrop) {
	      var $body = $("body");
	      if (!$body.hasClass("modal-open")) {
	        $body.addClass("modal-open");
	      }
	
	      if (!this.backdropExists && addBackdrop !== false) {
	        $body.append(this.backdrop);
	      }
	
	      // Reading a css property forces layout to be computed
	      this.dialogEl.show().css("width");
	      this.dialogEl.addClass("show");
	    }
	  }, {
	    key: "hide",
	    value: function hide(callback) {
	      var that = this;
	      var $body = $("body");
	      if ($body.hasClass("modal-open")) {
	        $body.removeClass("modal-open");
	      }
	
	      var $backdrop = $("#" + this.backdropId);
	
	      if (utils.isNotNull($backdrop) && $backdrop.length) {
	        $backdrop.remove();
	      }
	
	      this.dialogEl.removeClass("show");
	
	      setTimeout(function () {
	        that.dialogEl.hide();
	        if (utils.isFunction(callback)) {
	          callback();
	        }
	      }, ANIMATION_DURATION);
	    }
	  }, {
	    key: "cancel",
	    value: function cancel() {
	      this.hide();
	
	      if (utils.isFunction(this.onCancel)) {
	        this.onCancel();
	      }
	    }
	  }, {
	    key: "dispose",
	    value: function dispose() {
	      this.hide();
	
	      if (utils.isFunction(this.onDispose)) {
	        this.onDispose();
	      }
	    }
	  }, {
	    key: "addDisposeListener",
	    value: function addDisposeListener() {
	      var that = this;
	
	      that.dialogEl.off().on("click", function (e) {
	        if (e.target.className === "modal-content" || $(e.target).closest(".modal-content").length) {
	          e.stopPropagation();
	          return;
	        }
	        that.dispose();
	      });
	    }
	  }, {
	    key: "backdropId",
	    get: function get() {
	      return this.dialogId + this.backdropIdSuffix;
	    }
	  }, {
	    key: "backdropExists",
	    get: function get() {
	      return $("#" + this.backdropId).length;
	    }
	  }]);
	
	  return DialogTemplate;
	}();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var utils = __webpack_require__(4);
	var LanguageManager = __webpack_require__(6);
	var DialogTemplate = __webpack_require__(515);
	
	var dialog = {};
	
	(function (Dialog) {
	    Dialog.showMessageDialog = function (options) {
	        var cancelText = undefined;
	        var confirmText = LanguageManager.getValueForKey("modal.buttons.ok");
	
	        if (options.confirmText !== undefined) {
	            confirmText = LanguageManager.getValueForKey(options.confirmText);
	        }
	
	        if (options.cancelText !== undefined) {
	            cancelText = LanguageManager.getValueForKey(options.cancelText);
	        }
	
	        var messageDialog = new DialogTemplate({
	            title: LanguageManager.getValueForKey(options.title),
	            dialogContent: LanguageManager.getValueForKey(options.message),
	            cancelText: cancelText,
	            confirmText: confirmText,
	            disposable: options.disposable,
	            extraModalContentClass: options.extraModalContentClass,
	            dialogId: options.dialogId,
	            onConfirm: function onConfirm() {
	                messageDialog.destroy();
	
	                if (utils.isFunction(options.onConfirm)) {
	                    options.onConfirm();
	                }
	            },
	            onCancel: function onCancel() {
	                messageDialog.destroy();
	            },
	            onDispose: function onDispose() {
	                messageDialog.destroy();
	
	                if (utils.isFunction(options.onDispose)) {
	                    options.onDispose();
	                }
	            }
	        });
	
	        messageDialog.show();
	
	        return messageDialog;
	    };
	
	    Dialog.showOkCancelDialog = function (options) {
	        var okCancelDialog = new DialogTemplate({
	            title: LanguageManager.getValueForKey(options.title),
	            dialogContent: LanguageManager.getValueForKey(options.message),
	            confirmText: LanguageManager.getValueForKey("modal.buttons.ok"),
	            cancelText: LanguageManager.getValueForKey("modal.buttons.cancel"),
	            disposable: options.disposable,
	            onConfirm: function onConfirm() {
	                okCancelDialog.destroy();
	
	                if (utils.isFunction(options.onOk)) {
	                    options.onOk();
	                }
	            },
	            onCancel: function onCancel() {
	                okCancelDialog.destroy();
	
	                if (utils.isFunction(options.onCancel)) {
	                    options.onCancel();
	                }
	            },
	            onDispose: function onDispose() {
	                okCancelDialog.destroy();
	
	                if (utils.isFunction(options.onDispose)) {
	                    options.onDispose();
	                }
	            }
	        });
	
	        okCancelDialog.show();
	
	        return okCancelDialog;
	    };
	
	    Dialog.showYesNoDialog = function (options) {
	        var yesNoDialog = new DialogTemplate({
	            title: LanguageManager.getValueForKey(options.title),
	            dialogContent: LanguageManager.getValueForKey(options.message),
	            confirmText: LanguageManager.getValueForKey("modal.buttons.yes"),
	            cancelText: LanguageManager.getValueForKey("modal.buttons.no"),
	            disposable: options.disposable,
	            onConfirm: function onConfirm() {
	                yesNoDialog.destroy();
	
	                if (utils.isFunction(options.onYes)) {
	                    options.onYes();
	                }
	            },
	            onCancel: function onCancel() {
	                yesNoDialog.destroy();
	
	                if (utils.isFunction(options.onNo)) {
	                    options.onNo();
	                }
	            },
	            onDispose: function onDispose() {
	                yesNoDialog.destroy();
	
	                if (utils.isFunction(options.onDispose)) {
	                    options.onDispose();
	                }
	            }
	        });
	
	        yesNoDialog.show();
	
	        return yesNoDialog;
	    };
	})(dialog);
	
	module.exports = dialog;

/***/ }),

/***/ 914:
/***/ (function(module, exports) {

	module.exports = "/**\n * Created by jv on 10/03/2017.\n */\n\n// (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){\n// (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),\n// m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)\n// })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');\n//\n// ga('create', 'UA-code-here', 'auto');\n// ga('set', 'anonymizeIp', true);\n\"use strict\";"

/***/ }),

/***/ 918:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(268)(__webpack_require__(914))

/***/ })

});


// WEBPACK FOOTER //
// js/commons.0f0f037f66fad29c8dd1.js